webpackJsonp([3],{

/***/ "+ENJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _msgpad_show = __webpack_require__("2QB/");

var _msgpad_show2 = _interopRequireDefault(_msgpad_show);

var _base_api = __webpack_require__("+TLI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-new */

var st_shop_key = "shop_info";

var state = {
	shop_info: null

	// getters
};var getters = {
	shop_info: function shop_info(state) {
		if (state.shop_info) return state.shop_info;
		var shop_info = localStorage.getItem(st_shop_key);
		if (shop_info) {
			try {
				state.shop_info = JSON.parse(shop_info);
			} catch (err) {
				debugger;
				(0, _msgpad_show2.default)("msgpad", "失败", err.message, 'error');
			}
		}
		return state.shop_info;
	}

	// actions
};var actions = {
	act_look_shop_info: function act_look_shop_info(context, data) {
		return (0, _base_api.base_api)({
			method: 'post',
			schema: 'shopinfo',
			params: { action: 'shop_login' },
			data: data
		}).then(function (resp) {
			context.commit('MUTATIONS_SHOP_SHOP_INFO', resp.data);
			return resp.data;
		});
	},
	act_sysuser_login: function act_sysuser_login(context, data) {
		return (0, _base_api.base_api)({
			method: 'post',
			schema: 'shopinfo',
			params: { action: 'shop_login' },
			data: data
		}).then(function (resp) {
			context.commit('MUTATIONS_SHOP_SHOP_INFO', resp.data);
			return resp.data;
		});
	}
};

// mutations
var mutations = {
	MUTATIONS_SHOP_SHOP_INFO: function MUTATIONS_SHOP_SHOP_INFO(state, info) {
		if (info) {
			state.shop_info = info;
			localStorage.setItem(st_shop_key, (0, _stringify2.default)(info));
		} else {
			state.shop_info = info;
			localStorage.removeItem(st_shop_key);
		}
	}
};

exports.default = {
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations
};

/***/ }),

/***/ "+TLI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.debug_obj = exports.base_url = undefined;

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

exports.base_api = base_api;

var _ajax_request = __webpack_require__("Hm2B");

var _ajax_request2 = _interopRequireDefault(_ajax_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base_url = exports.base_url = "/api";
var debug_obj = exports.debug_obj = {};
// export const debug_obj = process.env.NODE_ENV === 'production'?{}:
// 	{
// 		shop_id :'558cddd574184c39d2abf993',
// 		api     :'mobile_device'
// 	}

function base_api(_ref) {
	var method = _ref.method,
	    schema = _ref.schema,
	    params = _ref.params,
	    data = _ref.data;

	var url = base_url + '/pos/' + schema;
	// console.log("debug_obj:",debug_obj,"url:",url);
	return (0, _ajax_request2.default)({
		url: url,
		method: method ? method : 'get',
		params: (0, _assign2.default)({}, debug_obj, params ? params : {}),
		data: data ? data : null
	});
}

/***/ }),

/***/ "/jFE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saleorder_vue__ = __webpack_require__("R5Pn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saleorder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saleorder_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saleorder_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saleorder_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e66604a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saleorder_vue__ = __webpack_require__("E/RS");
function injectStyle (ssrContext) {
  __webpack_require__("o9Le")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e66604a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saleorder_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e66604a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saleorder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/wzy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',_vm._b({attrs:{"fluid":"","mt-2":""}},'v-container',( _obj = {}, _obj[("grid-list-" + _vm.dev_view)] = true, _obj ),false),[_c('v-layout',{attrs:{"row":"","nowrap":""}},[_c('v-flex',{class:_vm.classObject,attrs:{"sm6":"","xs6":"","py-0":"","mb-2":""}},[_c('div',{staticClass:"bg-info  mb-0 border-0 app-card"},[_c('v-card-text',[_c('div',{staticClass:"layout justify-space-between pa-0 "},[_c('div',{staticClass:"align-item-start"},[_c('div',{staticClass:"total_info"},[_c('span',{staticClass:"total_num"},[_vm._v(_vm._s(_vm.sum_info.total_num - _vm.sum_info.total_save_num))]),_vm._v(" "),(_vm.sum_info.total_save_num)?_c('span',[_vm._v("\n                         存\n                        "),_c('span',{staticClass:"total_save",staticStyle:{"font-size":"32px","color":"red"}},[_vm._v("\n                          "+_vm._s(_vm.sum_info.total_save_num)+"\n                        ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"align-item-start"},[_c('h3',{staticClass:"total_money",on:{"click":function($event){$event.stopPropagation();_vm.make_to_int()}}},[_vm._v("￥"+_vm._s(_vm.bill_money)+" ")]),_vm._v(" "),_c('p',{staticClass:"ma-0 fs-14"},[(_vm.sum_info.total_less+ _vm.sum_info.less_to_int>0)?_c('del',[_vm._v("\n                          优惠￥"+_vm._s((_vm.sum_info.total_less+ _vm.sum_info.less_to_int ).toFixed(2))+"\n                    ")]):_vm._e(),_vm._v(" "),(_vm.sum_info.use_prepay>0)?_c('span',{staticClass:"red--text title"},[_vm._v("会员卡:"+_vm._s(_vm.sum_info.use_prepay.toFixed(2)))]):_vm._e(),_vm._v(" "),(_vm.sum_info.amount_less >0)?_c('del',[_vm._v("积分￥"+_vm._s(_vm.sum_info.amount_less.toFixed(2)))]):_vm._e(),_vm._v(" "),(_vm.sum_info.less_to_int >0)?_c('del',[_vm._v("抹零￥"+_vm._s(_vm.sum_info.less_to_int.toFixed(2)))]):_vm._e()])])])])],1)]),_vm._v(" "),(_vm.vip_info.mobile)?_c('v-flex',{class:_vm.classObject,attrs:{"sm6":"","xs6":"","py-0":"","mb-2":""}},[_c('div',{staticClass:"bg-secondary mb-0 border-0 app-card"},[_c('v-card-text',[_c('div',{staticClass:"layout justify-space-between pa-0"},[_c('div',{staticClass:"align-item-start"},[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-avatar',{staticClass:"drop-menu",attrs:{"slot":"activator","tile":_vm.title,"color":"grey lighten-4"},slot:"activator"},[_c('img',{attrs:{"src":"/static/img/user-7.jpg","alt":"avatar"}})]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.lookup_vip_info(_vm.vip_info.mobile)}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-reload")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("刷新会员")])],1)],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.clear_vip()}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-close")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("清除会员")])],1)],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.add_vip("edit")}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-pencil")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("修改会员")])],1)],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.show_dialog("SHOW_DIALOG_VIP_RECHARGE")}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray large"},[_vm._v("ti-money")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("会员充值")])],1)],1),_vm._v(" "),(_vm.vip_saved&&_vm.vip_saved.length)?_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.lookup_vip_saved()}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-save")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("暂存商品")])],1)],1):_vm._e(),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"to":"/users/user-profile"}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-list")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("购买记录")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"align-item-start"},[_c('h3',{staticClass:"prepay_money",on:{"click":function($event){_vm.use_prepay_money()}}},[_vm._v("￥"+_vm._s(_vm.vip_info.prepay_money?_vm.vip_info.prepay_money.toFixed(2):0))]),_vm._v(" "),_c('p',{staticClass:"ma-0 fs-14",on:{"click":function($event){_vm.use_amount()}}},[_vm._v("积分:"+_vm._s(_vm.vip_info.user_amount?_vm.vip_info.user_amount:0))])]),_vm._v(" "),_c('div',{staticClass:"align-item-start"},[_c('h3',{staticStyle:{"margin":"0 0"}},[_vm._v(_vm._s(_vm.vip_info.name)+" ")]),_vm._v(" "),_c('p',{staticClass:"ma-0 fs-14"},[_vm._v(_vm._s(_vm.vip_info.mobile))])]),_vm._v(" "),(_vm.vip_saved&&_vm.vip_saved.length)?_c('div',{staticClass:"align-item-end"},[_c('v-btn',{staticClass:"d-inline-50",attrs:{"icon":""},on:{"click":function($event){_vm.lookup_vip_saved()}}},[_c('v-icon',{staticStyle:{"font-size":"250%"},attrs:{"color":"orange darken-2"}},[_vm._v("ti-save")])],1)],1):_vm._e()])])],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{class:_vm.classObject,attrs:{"sm12":"","xs12":"","py-0":"","mb-2":""}},[_c('div',{staticClass:"input_pad  mb-0 border-0 app-card"},[_c('v-card-text',[_c('div',{staticClass:"layout justify-space-between pa-0 "},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input_gid),expression:"input_gid"}],staticClass:"gid_control",attrs:{"type":"search","placeholder":"条码/会员号","autocomplete":"off","autocorrect":"off","autocapitalize":"off","spellcheck":"false"},domProps:{"value":(_vm.input_gid)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.input_gid=$event.target.value},_vm.gid_input],"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==13){ return null; }$event.stopPropagation();_vm.lookup_product(true)}}}),_vm._v(" "),(_vm.input_gid.length)?_c('v-btn',{staticClass:"d-inline-50",attrs:{"icon":""},on:{"click":function($event){_vm.clear_input(true)}}},[_c('span',{staticClass:"black--text",staticStyle:{"font-size":"250%"}},[_vm._v("x")])]):_c('v-btn',{staticClass:"d-inline-50",attrs:{"icon":""},on:{"click":_vm.do_pay_money}},[_c('span',{staticClass:"pink--text",staticStyle:{"font-size":"250%"}},[_vm._v("￥")])])],1)])],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xl12":"","lg12":"","md12":"","xs12":""}},[_c('div',[_c('v-alert',{attrs:{"value":_vm.pay_info.pay_status,"type":"success","transition":"scale-transition"}},[_c('h2',[_c('span',{staticClass:"pink--text"},[_vm._v("本单已经结算！")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.pay_info_str))])])])],1),_vm._v(" "),_c('v-tabs',{attrs:{"slot":"extension","right":"","slider-color":"yellow"},slot:"extension",model:{value:(_vm.active_tab),callback:function ($$v) {_vm.active_tab=$$v},expression:"active_tab"}},[(_vm.pay_info.pay_status)?_c('v-btn',{staticClass:"d-inline-50",attrs:{"icon":""}},[_c('v-icon',{attrs:{"large":"","color":"purple darken-2"}},[_vm._v("ti-print")])],1):_c('div',[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"info","dark":""},slot:"activator"},[_vm._v(" 更多操作 ")]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.show_ship_out_dialog('ship_out')}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-sharethis")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("出库")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.show_ship_out_dialog('recv')}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-shopping-cart")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("收货")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.show_destroy_dialog('destroy')}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-trash")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("报损")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.show_ship_out_dialog('request')}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-receipt")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("配货申请")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.show_ship_out_dialog('pandian')}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-list")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("盘点")])],1)],1)],1),_vm._v(" "),(_vm.selected_num)?_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',{staticClass:"iconfont icon-more"})],1),_vm._v(" "),_c('v-list',[_c('v-layout',{attrs:{"row":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"light-green lighten-3"},on:{"click":function($event){_vm.set_discount(90)}}},[_vm._v("90折")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"light-blue lighten-3"},on:{"click":function($event){_vm.set_discount(88)}}},[_vm._v("88折")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"warning"},on:{"click":function($event){_vm.set_discount(85)}}},[_vm._v("85折")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"success"},on:{"click":function($event){_vm.set_discount(80)}}},[_vm._v("80折")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"success"},on:{"click":function($event){_vm.set_discount(75)}}},[_vm._v("75折")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"warning"},on:{"click":function($event){_vm.set_discount(70)}}},[_vm._v("70折")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"light-blue lighten-3"},on:{"click":function($event){_vm.set_discount(61)}}},[_vm._v("61折")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"light-green lighten-3"},on:{"click":function($event){_vm.set_discount(50)}}},[_vm._v("50折")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"success"},on:{"click":function($event){_vm.set_discount(100)}}},[_vm._v("不打折")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"light-blue"},on:{"click":function($event){_vm.def_discount()}}},[_vm._v("自定义")])],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-sale"}},[_vm._v("待售表")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-prepare"}},[_vm._v("预选表")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-shortcut"}},[_vm._v("速记表")])],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.active_tab),callback:function ($$v) {_vm.active_tab=$$v},expression:"active_tab"}},[_c('sale-tab',{attrs:{"name":"tab-sale"}}),_vm._v(" "),_c('prepare-tab',{attrs:{"name":"tab-prepare"},on:{"active_tab":_vm.act_tab,"clear_input":function($event){_vm.clear_input(true)}}}),_vm._v(" "),_c('shortcut-tab',{attrs:{"name":"tab-shortcut"}})],1)],1),_vm._v(" "),_c('dialog_user_pay'),_vm._v(" "),_c('dialog_ship_out'),_vm._v(" "),_c('dialog_destroy'),_vm._v(" "),_c('dialog_vip_recharge',{attrs:{"config":_vm.recharge_conf},on:{"recharge":_vm.recharge}})],1)],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0DU1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

var _oper_menu = __webpack_require__("uMRW");

var _oper_menu2 = _interopRequireDefault(_oper_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

var g_index = 0;

exports.default = {
  //template:``,
  name: '',
  props: {
    // isfinished:{type:Boolean, default:false }
  },
  // mixins:[oper_mixin],
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    vip_info: 'vip_info',
    list: 'get_prodcuts_list', //商品列表
    item_money: 'get_product_money', //单品总金额
    item_discount: 'get_product_discount', //单品折扣
    pay_info: 'get_pay_info',
    prepay_money: 'get_use_prepay_money'
  }), {
    isfinished: function isfinished() {
      return this.pay_info.pay_status;
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)({
    edit_item: 'PRODUCTS_EDIT_ITEM',
    select_all_rec: 'PRODUCTS_SELECT_ALL'
  }), {
    msgpad_show: function msgpad_show(group, title, text, type) {
      this.$notify({ group: group, title: title, text: text, type: type });
    },
    delete_it: function delete_it(item) {
      if (this.isfinished) {
        this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
      };
      this.$store.commit('VIP_PREPAY_MONEY_ADJUST', this.prepay_money);
      this.$store.commit('USE_PREPAY_MONEY', 0.0);
      this.$store.commit('PRODUCTS_EDIT_ITEM', {
        gid: item.gid,
        oper: 'delete'
      });
    },
    inc_number: function inc_number(item, val) {
      if (this.isfinished) {
        this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
      };
      this.$store.commit('VIP_PREPAY_MONEY_ADJUST', this.prepay_money);
      this.$store.commit('USE_PREPAY_MONEY', 0.0);
      this.$store.commit('PRODUCTS_EDIT_ITEM', {
        gid: item.gid,
        oper: 'inc_num',
        value: val
      });
    },
    inc_save: function inc_save(item, val) {
      if (this.isfinished) {
        this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
      };
      this.$store.commit('PRODUCTS_EDIT_ITEM', {
        gid: item.gid,
        oper: 'inc_save',
        value: val
      });
    }
  }),
  components: { opermenu: _oper_menu2.default },
  watch: {
    select_all: function select_all(val) {
      this.select_all_rec(val);
    }
  },
  directives: {},
  mounted: function mounted() {},
  data: function data() {
    return {
      select_all: false,
      headers: [{ text: '', sort: false }, { text: '商品名称', value: 'name' }, { text: '零售价', value: 'sale_price' }, { text: '折扣价', value: 'real_price' }, { text: '数量', value: 'num' }, { text: '金额', value: 'protein' }]
      /*{
      "gid": "8801092512721",
      "nm": "保宁洗衣香皂(香草香）",
      "num": 1,
      "price": 14,
      "realprice": 14,
      "discount": 100,
      "money": 14,
      "less": 0,
      "save_num": 0,
      "flag": "sale",
      "isEMS": false,
      "outsea": false
      }*/
    };
  },

  filters: {
    //pluralize: (n, w) => n === 1 ? w : (w + 's'),
    capitalize: function capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }
  }
};

/***/ }),

/***/ "0ixg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _mutations; /* eslint-disable no-new */

var _mutationDefine = __webpack_require__("a2hP");

var types = _interopRequireWildcard(_mutationDefine);

var _msgpad_show = __webpack_require__("2QB/");

var _msgpad_show2 = _interopRequireDefault(_msgpad_show);

var _products = __webpack_require__("g0az");

var API = _interopRequireWildcard(_products);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
gid:条码
name:名称
num:数量

is_weight:是否称重
unit:[pc-件,g-克,kg-公斤,500g-斤]
vip:[vip-注册会员,copper-铜牌会员,silver-银牌会员,gold-金牌会员,diamond-钻石会员]
vip_price:[vip-注册会员,copper-铜牌会员,silver-银牌会员,gold-金牌会员,diamond-钻石会员]

sale_price:零售价
-real_price:实际销售价

save_take:[sale-销售,take-提货]
all_num: 存货总数量
save_number: 暂存数量
less: 减免
-discount:折扣

*/

var state = {
    pay_info: {
        pay_type: "cash",
        pay_status: 0,
        bank_id: "",
        use_prepay: 0,
        total_money: 0,
        recv: 0,
        ret: 0,
        other: 0
    },
    list: [],
    make_to_int: 0,
    outsea_products: {},
    multil_index: 0,
    amount_less: 0, //积分抵现
    use_prepay: 0, //储值卡消费
    order_id: +new Date(),
    note: ''
};

function _have_this_gid(gid) {
    for (var i = 0; i < state.list.length; i++) {
        var item = state.list[i];
        if (item.gid == gid) {
            return i;
        }
    }
    return -1;
}

// getters
var getters = {
    /*{
        list         :state.list,
        make_to_int  :state.make_to_int,
        multil_index :state.multil_index,
        amount_less  :state.amount_less,
        order_id     :state.order_id,
        note         :state.note}*/
    get_order_raw: function get_order_raw(state) {
        return state;
    },
    get_order_id: function get_order_id(state) {
        return state.order_id;
    },
    get_order_note: function get_order_note(state) {
        return state.note;
    },

    get_pay_info: function get_pay_info(state) {
        return state.pay_info;
    },
    get_outsea_products: function get_outsea_products(state) {
        return state.outsea_products;
    },
    get_prodcuts_list: function get_prodcuts_list(state) {
        return state.list;
    },
    get_mutil_index: function get_mutil_index(state) {
        return state.multil_index;
    },
    get_use_prepay_money: function get_use_prepay_money(state) {
        return state.use_prepay;
    },
    get_amount_less: function get_amount_less(state) {
        return state.amount_less;
    },
    get_selected_num: function get_selected_num(state) {
        var num = 0;
        state.list.map(function (it) {
            if (it.selected) num++;
        });
        return num;
    },
    get_product_money: function get_product_money(state, getters) {
        return function (gid) {
            var item = state.list[_have_this_gid(gid)];
            var t_money = item.real_price * item.num - (item.less ? item.less : 0);
            return t_money.toFixed(2) * 1;
        };
    },
    have_this_gid: function have_this_gid(state, getters) {
        return function (gid) {
            var index = _have_this_gid(gid);
            return index >= 0;
        };
    },
    get_product_discount: function get_product_discount(state, getters) {
        return function (gid) {
            var item = state.list[_have_this_gid(gid)];
            if (item.real_price * item.num * item.sale_price == 0) return 0;
            return parseInt((item.real_price * item.num - item.less) * 100 / (item.sale_price * item.num));
        };
    },
    get_products_sum_info: function get_products_sum_info(state, getters) {
        var _ref = [0, 0, 0, 0, 0, 0, 0],
            total_num = _ref[0],
            total_save_num = _ref[1],
            total_money = _ref[2],
            total_discount = _ref[3],
            total_less = _ref[4],
            less_to_int = _ref[5];

        var amount_less = state.amount_less;
        var use_prepay = state.use_prepay;
        var all_salemoney = 0,
            total_real_price = 0;

        for (var i = 0; i < state.list.length; i++) {
            var item = state.list[i];
            if (item.save_take == 'sale') {
                total_save_num += item.save_num ? item.save_num : 0;
            }
            if (item.is_weight) {
                total_num += 1;
            } else {
                total_num += item.num;
            }
            all_salemoney += item.sale_price * item.num;
            total_real_price += item.real_price * item.num - item.less;
        }

        total_less = all_salemoney - total_real_price;
        total_less = total_less.toFixed(2) * 1;

        if (all_salemoney < 0.01) {
            total_discount = 0;
        } else {
            total_discount = parseInt(total_real_price * 100 / all_salemoney);
        }

        total_money = total_real_price - state.amount_less;
        if (state.make_to_int) {
            less_to_int = total_money - parseInt(total_money);
            total_money -= less_to_int;
        }
        var pay_status = state.pay_status;
        if (use_prepay > total_money) use_prepay = total_money;
        if (use_prepay < 0) use_prepay = 0;
        return { pay_status: pay_status, total_num: total_num, total_save_num: total_save_num, total_money: total_money,
            total_less: total_less, total_discount: total_discount, amount_less: amount_less, less_to_int: less_to_int, use_prepay: use_prepay };
    },
    get_sale_post_data: function get_sale_post_data(state, getters) {
        //use_prepay
        var _getters$get_products = getters.get_products_sum_info,
            pay_status = _getters$get_products.pay_status,
            total_num = _getters$get_products.total_num,
            total_save_num = _getters$get_products.total_save_num,
            total_money = _getters$get_products.total_money,
            total_less = _getters$get_products.total_less,
            total_discount = _getters$get_products.total_discount,
            amount_less = _getters$get_products.amount_less,
            less_to_int = _getters$get_products.less_to_int,
            use_prepay = _getters$get_products.use_prepay;


        var sum = { total_num: total_num, total_save_num: total_save_num, total_money: total_money, use_prepay: use_prepay,
            total_less: total_less, total_discount: total_discount, amount_less: amount_less, less_to_int: less_to_int };

        var vip = {
            vip_mobile: getters.vip_info.mobile,
            vip_discount: sum.total_discount
        };

        var detail = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(state.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                detail.push({
                    gid: item.gid,
                    nm: item.name,
                    num: item.num,
                    price: item.sale_price,
                    realprice: item.real_price,
                    discount: item.discount,
                    money: getters.get_product_money(item.gid),
                    less: item.less,
                    save_num: item.save_num,
                    flag: item.save_take,
                    is_new: item.is_new ? true : false,
                    isEMS: item.isEMS ? true : false,
                    outsea: item.outsea ? true : false,
                    change_to: item.change_to ? item.change_to : null
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return {
            order_id: state.order_id,
            sum: sum,
            detail: detail,
            note: state.note,
            vip: vip
        };
    },
    get_shipout_data: function get_shipout_data(state, getters) {

        var out_obj = {
            order_id: state.order_id,
            total_num: getters.get_products_sum_info.total_num,
            items: []
        };

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = (0, _getIterator3.default)(state.list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                out_obj.items.push({
                    gid: item.gid,
                    num: item.num,
                    info: item.name,
                    flag: item.save_take
                });
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return out_obj;
    }

    // actions
};var actions = {
    act_lookup_products_by_gid: function act_lookup_products_by_gid(_ref2, _ref3) {
        var commit = _ref2.commit;
        var gid = _ref3.gid,
            prepare = _ref3.prepare,
            callback = _ref3.callback,
            self = _ref3.self,
            raw = _ref3.raw;

        // let url = "/product?oper=lookup&gid="+gid;
        // let url = "/api/pos/product?oper=lookup&gid="+gid;
        // console.log("URL:",url)
        return API.lookup_products_by_gid(gid).then(function (resp) {
            if (resp.status == 200) {
                var data = resp.data;
                // console.log("RECV:",data,commit)
                if (raw) return data;
                commit("PRODUCTS_RESPONS_LIST", { data: data, gid: gid, commit: commit, callback: callback, prepare: prepare, self: self });
                return data;
                // if(callback){callback(data);}
            } else if (!prepare) {
                (0, _msgpad_show2.default)("msgpad", "失败", resp.data.err_msg, 'error');
            }
        }).catch(function (err) {
            (0, _msgpad_show2.default)("msgpad", "NETWORK_ERROR", err.message, 'error');
        });
    },
    act_lookup_home_stock: function act_lookup_home_stock(_ref4, _ref5) {
        var commit = _ref4.commit;
        var gid = _ref5.gid,
            name = _ref5.name,
            prepare = _ref5.prepare,
            callback = _ref5.callback,
            self = _ref5.self;

        // let url = "/product?oper=lookup&gid="+gid;
        // let url = "/api/pos/product?oper=lookup&gid="+gid;
        // console.log("URL:",url)
        API.lookup_home_stock({ gid: gid }).then(function (resp) {
            if (resp.status == 200) {
                var data = resp.data;
                console.log("RECV:", data, commit);
                commit("PRODUCTS_RESPONS_LIST", { data: data, gid: gid, commit: commit, callback: callback, prepare: prepare, self: self });
                // if(callback){callback(data);}
            } else if (!prepare) {
                (0, _msgpad_show2.default)("msgpad", "失败", resp.data.err_msg, 'error');
            }
        }).catch(function (err) {
            (0, _msgpad_show2.default)("msgpad", "NETWORK_ERROR", err.message, 'error');
        });
    },
    act_ship_out_products: function act_ship_out_products(_ref6, _ref7) {
        var commit = _ref6.commit,
            state = _ref6.state,
            getters = _ref6.getters;
        var type = _ref7.type,
            param = _ref7.param,
            self = _ref7.self;

        function post_products(post_url, obj, dlg, ok_callback) {
            if (vue_products.total_info.total_num == 0) {
                bootbox.alert("<h3>商品列表为空</h3>");
                return;
            }
            var post_data = {};
            if (typeof obj != "undefined") (0, _keys2.default)(obj).forEach(function (key) {
                post_data[key] = obj[key];
            });

            post_data.items = [];
            /*if (vue_products.order_id == 0) {
                var d = new Date();
                vue_products.order_id = d.getTime();
            }*/

            post_data.order_id = get_sale_order_id(); //vue_products.order_id;
            post_data.total_num = vue_products.total_info.total_num;

            (0, _keys2.default)(vue_products.$data.list).forEach(function (key) {
                var obj = vue_products.$data.list[key];
                post_data.items.push({
                    gid: obj.gid,
                    num: obj.num,
                    info: obj.name,
                    flag: obj.save_take
                });
            });
        }
    }
};

function rest_vip_price(item, vip) {
    // debugger
    //vip-注册会员,copper-铜牌会员,silver-银牌会员,gold-金牌会员,diamond-钻石会员
    if (vip == "注册会员") vip = "vip";else if (vip == "铜牌会员") vip = "copper";else if (vip == "银牌会员") vip = "silver";else if (vip == "金牌会员") vip = "gold";else if (vip == "钻石会员") vip = "diamond";

    item['less'] = 0;

    if (vip && item.vip_price && typeof item.vip_price[vip] != 'undefined') {
        var real_price = item.vip_price[vip];
        item['default_vip_price'] = item['real_price'] = item.vip_price[vip]; //vip price
    } else {
        item['default_vip_price'] = item['real_price'] = item.sale_price;
        if (item.vip_price && typeof item.vip_price['vip'] != 'undefined') item['default_vip_price'] = item.vip_price['vip'];
    }

    console.log("[%s]====> REAL:%s DEF_VIP:%s", vip, item['sale_price'], item['default_vip_price']);

    if (item['real_price'] > item['sale_price']) {
        item['real_price'] = item['sale_price'];
        return (0, _msgpad_show2.default)("msgpad", "ERROR", '会员价格高于零售价', 'error');
    }
}

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.PAYINFO_SETTING, function (state, info) {
    state.pay_info = info;
}), (0, _defineProperty3.default)(_mutations, types.USE_PREPAY_MONEY, function (state, money) {
    state.use_prepay = money;
}), (0, _defineProperty3.default)(_mutations, types.PRODUCTS_SELECT_ALL, function (state, flag) {
    state.list.map(function (it) {
        it.selected = flag;
    });
}), (0, _defineProperty3.default)(_mutations, types.PRODUCTS_RESTORE_LIST, function (state, obj) {
    // debugger
    if (obj) {
        console.log("==", (0, _keys2.default)(obj));
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = (0, _getIterator3.default)((0, _keys2.default)(obj)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var key = _step3.value;

                if (key == 'vip') continue;
                state[key] = obj[key];
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
    }
}), (0, _defineProperty3.default)(_mutations, types.PRODUCTS_DISCOUNT_SELECTED, function (state, discount) {
    state.list.map(function (it) {
        if (it.selected) {
            it['real_price'] = it.sale_price * discount / 100;
            it['less'] = 0;
        }
    });
}), (0, _defineProperty3.default)(_mutations, types.PRODUCTS_RESET_VIP_PRICE, function (state, vip_group) {
    // debugger
    var need_del = [];
    for (var i = 0; i < state.list.length; i++) {
        var item = state.list[i];
        if (!vip_group) {
            if (item.save_take == 'take') {
                need_del.push(item.gid);
                continue;
            }
            item.save_num = 0;
        }
        rest_vip_price(item, vip_group);
    }
    state.amount_less = 0.0;
    state.make_to_int = false;

    need_del.map(function (gid) {
        var index = _have_this_gid(gid);
        if (index >= 0) {
            var _item = state.list[index];
            state.list.splice(index, 1);
        }
    });
}), (0, _defineProperty3.default)(_mutations, types.PRODUCTS_LIST_INC_MUL_INDEX, function (state) {
    var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    state.multil_index += val;
}), (0, _defineProperty3.default)(_mutations, types.PRODUCTS_LIST_CLEAN, function (state) {

    state.list = [];
    state.make_to_int = 0, state.multil_index = 0;
    state.amount_less = 0;
    state.use_prepay = 0;
    state.order_id = +new Date();
    state.note = '';
    state.outsea_products = {};
    state.pay_info = {
        pay_type: "cash",
        pay_status: 0,
        bank_id: "",
        recv: 0,
        ret: 0,
        other: 0
    };
}), (0, _defineProperty3.default)(_mutations, types.PRODUCTS_NEW_ORDER_ID, function (state) {
    state.order_id = +new Date();
}), (0, _defineProperty3.default)(_mutations, types.PRODUCTS_EDIT_NOTE, function (state, note) {
    state.note = note;
}), (0, _defineProperty3.default)(_mutations, types.PRODUCTS_RESPONS_LIST, function (state, _ref8) {
    var data = _ref8.data,
        gid = _ref8.gid,
        commit = _ref8.commit,
        callback = _ref8.callback,
        prepare = _ref8.prepare,
        self = _ref8.self;

    if (data.data) data = data.data;
    if (data.length == 0) {
        commit(types.PRODUCTS_PREPARE_LIST, data);
        if (!prepare) {
            (0, _msgpad_show2.default)("msgpad", "ERROR", '无此商品信息', 'error');
            // if(callback){
            //     callback(data,self);
            // }
        }
        return;
    }
    // console.log("PRODUCTS_RESPONS_LIST:",data,"from_gid",gid,"prepare:",prepare)
    if (!prepare || data.length == 1) {
        // debugger
        for (var i = 0; i < data.length; i++) {
            if (data[i].gid == gid) {
                data[i].oper = 'add';
                data[i].vip = self.$store.getters.vip_info.mobile;

                commit(types.PRODUCTS_EDIT_ITEM, data[i]);
                // self.$root.$emit("active_sale_tab",0);
                // self.$root.$emit('clear_input')
                var act_tab = 'tab-sale';
                callback && callback(data, act_tab);
                console.log("Active table!", act_tab);
                return;
            }
        }
    }
    commit(types.PRODUCTS_PREPARE_LIST, data);
    // self.$root.$emit("active_sale_tab",1);
    callback && callback(data, "tab-prepare");
    return;
}), (0, _defineProperty3.default)(_mutations, types.PRODUCTS_EDIT_ITEM, function (state, detail) {
    var oper = detail.oper,
        gid = detail.gid;

    var index = _have_this_gid(gid);
    var item = state.list[index];

    console.log("PRODUCTS_EDIT_ITEM:", oper, gid, detail);

    if (state.pay_info.pay_status > 0) {
        return (0, _msgpad_show2.default)("msgpad", "ERROR", '操作无效！本单位已结算', 'error');
    }

    if (oper == 'add') {
        if (index >= 0) {
            item.num += detail.num ? detail.num : 1;
            state.list.splice(index, 1);
            state.list.unshift(item);
            return;
        }

        var _gid = detail.gid,
            name = detail.name,
            num = detail.num,
            is_weight = detail.is_weight,
            unit = detail.unit,
            vip = detail.vip,
            vip_price = detail.vip_price,
            sale_price = detail.sale_price,
            save_take = detail.save_take,
            all_num = detail.all_num,
            save_num = detail.save_num,
            less = detail.less,
            discount = detail.discount,
            _detail$isEMS = detail.isEMS,
            isEMS = _detail$isEMS === undefined ? false : _detail$isEMS,
            _detail$outsea = detail.outsea,
            outsea = _detail$outsea === undefined ? false : _detail$outsea;

        if (save_num === undefined) save_num = 0;
        if (save_take === undefined) save_take = 'sale';
        if (num === undefined) num = 1;
        if (all_num === undefined) all_num = 0;

        var n_obj = { gid: _gid, name: name, num: num, is_weight: is_weight, unit: unit, vip: vip, vip_price: vip_price, sale_price: sale_price, save_take: save_take, all_num: all_num, save_num: save_num, less: less, discount: discount, isEMS: isEMS, outsea: outsea };
        n_obj.selected = false;
        n_obj.change_to = null;
        // console.log("New Obje:",n_obj,"VIP:",vip);
        rest_vip_price(n_obj, vip);
        state.list.unshift(n_obj);
        if (outsea) {
            state.outsea_products[_gid] = n_obj;
        }
        return;
    } else if (oper == 'make_to_int') {
        state.make_to_int = !!detail.value;
        return;
    } else if (oper == 'vip_use_amount') {
        state.amount_less = detail.value;
        return;
    }

    if (index < 0) return (0, _msgpad_show2.default)("msgpad", "ERROR", '未发现商品:' + gid, 'error');
    // console.log(item)
    switch (oper) {
        case 'delete':
            state.list.splice(index, 1);
            if (item.outsea) delete state.outsea_products[item.gid];
            break;
        case 'return_it':
            item.num *= -1;
            break;
        case 'set_num':
            detail.value = detail.value * 1 - item.num;
        // item.num = detail.value*1;
        // break;
        case 'inc_num':

            if (item.save_take == 'sale') {
                // debugger
                item.num += detail.value * 1;
                if (item.less / (item.real_price ? item.real_price : 1) > item.num) {
                    (0, _msgpad_show2.default)("msgpad", "ERROR", '重新计算减免赠送金额', 'error');
                    item.less = 0;
                }

                if (item.save_num > item.num && item.num >= 0) {
                    item.save_num = item.num;
                } else if (item.num < 0) {
                    item.save_num = 0;
                }
            } else if (item.save_take == 'take') {
                if (item.num + detail.value * 1 > item.all_num) {
                    return (0, _msgpad_show2.default)("msgpad", "ERROR", item.name + ':提货数量超过存放数量！', 'error');
                }
                if (item.num + detail.value * 1 < 0) {
                    return (0, _msgpad_show2.default)("msgpad", "ERROR", item.name + ':提货数量不能为0！', 'error');
                }
                item.num += detail.value * 1;
            }
            if (item.num < 0) {
                item.num = 0;
                return (0, _msgpad_show2.default)("msgpad", "ERROR", item.name + ':数量不能小于0;如果是退货，请选择"退货"！', 'error');
            }
            break;
        case 'set_less':
            item.less = detail.value;
            break;
        case 'free_it':
            // item.s
            if (item.real_price != item.sale_price) {
                item.real_price = item.sale_price;
                item.less = 0;
            }
            item.less += item.real_price;
            break;
        case 'set_to_int':
            item.less += detail.value;
            break;
        case 'selected':
            item.selected = !item.selected;
            console.log("SELECTED:", item.selected);
            break;
        case 'set_discount':
            if (detail.value > 0 && detail.value <= 100) {
                item['real_price'] = item.sale_price * detail.value / 100;
                item.less = 0;
            }
            break;
        case 'inc_save':
            var inc = detail.value;
            if (item.save_take == 'take') {
                return (0, _msgpad_show2.default)("msgpad", "ERROR", '状态错误', 'error');
            }
            if (item.save_num + inc > item.num) {
                return (0, _msgpad_show2.default)("msgpad", "ERROR", '寄存商品不能大于购买商品:', 'error');
                item.save_num = item.num;
            } else if (item.save_num + inc < 0) {
                item.save_num = 0;
                return (0, _msgpad_show2.default)("msgpad", "ERROR", '寄存商品不能小于0:', 'error');
            } else {
                item.save_num += inc;
            }
            break;
        case 'set_real_price':
            //
            item.real_price = detail.value;
            item.less = 0;
            break;
        case 'set_flag':
            item.save_take = detail.value;
            break;
        case 'set_ems':
            item.isEMS = !item.isEMS;
            break;
        case 'use_vip_price':
            rest_vip_price(item, detail.value);
            break;
        case 'change_saved_item_to':
            break;
        case 'make_to_int':
            state.make_to_int = !!detail.value;
            break;
        // case 'vip_use_amount':
        //     state.amount_less  =  detail.value;
        //     break;
        default:
            return (0, _msgpad_show2.default)("msgpad", "ERROR", '未知操作:' + oper, 'error');
            break;
    }
}), _mutations);

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ "0vQH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
exports.default = {
  //template:``,
  name: '',
  props: {},
  computed: {},
  methods: {},
  components: {},
  watch: {},
  directives: {},
  mounted: function mounted() {},
  data: function data() {
    return {
      lorem: 'Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.'
    };
  },
  filters: {
    //pluralize: (n, w) => n === 1 ? w : (w + 's'),
    capitalize: function capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }
  }
};

/***/ }),

/***/ "1+W4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"session-banner"},[_c('v-container',{attrs:{"px-0":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md6":"","lg5":"","mx-auto":"","mb-70":""}},[_c('div',{staticClass:"mb-70"},[_c('router-link',{staticClass:"d-block text-xs-center",attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/static/img/session-logo.png"}}),_c('h3',{staticStyle:{"color":"white"}},[_vm._v("生活、学习点滴记录")])]),_c('p')],1),_vm._v(" "),_c('div',{staticClass:"session-block"},[_c('div',{staticClass:"session-head text-xs-center"},[_c('div',{staticClass:"div-icon mb-3"},[_c('i',{staticClass:"ti-lock font-2x"})]),_vm._v(" "),_c('h3',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.session_info[_vm.login_step].h1))]),_vm._v(" "),_c('p',{staticClass:"fs-14 px-5"},[_vm._v(_vm._s(_vm.session_info[_vm.login_step].h2))])]),_vm._v(" "),_c('v-form',{ref:"form",staticClass:"mb-4",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{ref:"id",attrs:{"label":_vm.session_info[_vm.login_step].f1.lable,"rules":_vm.session_info[_vm.login_step].f1.rules,"required":""},on:{"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==13){ return null; }_vm.$refs['password'].focus()}},model:{value:(_vm.id),callback:function ($$v) {_vm.id=$$v},expression:"id"}}),_vm._v(" "),_c('v-text-field',{ref:"password",attrs:{"label":_vm.session_info[_vm.login_step].f2.lable,"type":"password","rules":_vm.session_info[_vm.login_step].f2.rules,"required":""},on:{"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==13){ return null; }return _vm.submit($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-btn',{staticClass:"btn-gradient-primary",attrs:{"block":""},on:{"click":_vm.submit}},[_vm._v("登录")])],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm10":"","md6":"","lg5":"","mx-auto":""}},[_c('div',{staticClass:"mb-70"},[_c('h3',{staticStyle:{"color":"white","display":"flex","justify-content":"center"}},[_c('a',{staticStyle:{"color":"white"},attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("湘ICP备16002252号-1")])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1EX4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_user_pay_vue__ = __webpack_require__("mimI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_user_pay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_user_pay_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_user_pay_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_user_pay_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750668d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_user_pay_vue__ = __webpack_require__("3Rkh");
function injectStyle (ssrContext) {
  __webpack_require__("NSx4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-750668d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_user_pay_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750668d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_user_pay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2Lsv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2QB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = msgpad_show;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pad_vue = void 0;

function msgpad_show(group, title, text, type) {
	if (!pad_vue) {
		pad_vue = new _vue2.default({});
	}
	pad_vue.$notify({ group: group, title: title, text: text, type: type });
}

/***/ }),

/***/ "2e75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.width},model:{value:(_vm.show_dialog),callback:function ($$v) {_vm.show_dialog=$$v},expression:"show_dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline info lighten-2",attrs:{"primary-title":""}},[_c('h2',[_vm._v("商品报损")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._v("\n            报损原因\n          "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-radio-group',{attrs:{"mandatory":false},model:{value:(_vm.why),callback:function ($$v) {_vm.why=$$v},expression:"why"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-radio',{attrs:{"label":"过期","value":"timeout"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"损坏","value":"breakdown"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-radio',{attrs:{"label":"退货","value":"back"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"其它","value":"else"}})],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"备注","error":!_vm.node,"required":""},model:{value:(_vm.node),callback:function ($$v) {_vm.node=$$v},expression:"node"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"btn-",on:{"click":function($event){$event.stopPropagation();_vm.show_dialog=false}}},[_vm._v("取消")]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.creating,"disabled":_vm.creating||!(_vm.why&&_vm.node),"color":"info"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.create_record($event)}}},[_vm._v("\n\t      确定\n\t      "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_vm._v("\n\t        Loading...\n\t      ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Rkh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"700px","height":"400px"},model:{value:(_vm.show_dialog ),callback:function ($$v) {_vm.show_dialog =$$v},expression:"show_dialog "}},[_c('v-card',{staticClass:"dialog_user_pay"},[_c('v-card-text',[_c('v-tabs',{attrs:{"icons-and-text":"","dark":"","color":"cyan"},model:{value:(_vm.pay_type),callback:function ($$v) {_vm.pay_type=$$v},expression:"pay_type"}},[_c('v-tabs-slider',{attrs:{"color":"red"}}),_vm._v(" "),_c('v-tab',{directives:[{name:"show",rawName:"v-show",value:(_vm.enable_tab('cash')),expression:"enable_tab('cash')"}],attrs:{"href":"#cash"}},[_vm._v(" 现金/银行卡 "),_c('v-icon',[_vm._v("ti-money")])],1),_vm._v(" "),_c('v-tab',{directives:[{name:"show",rawName:"v-show",value:(_vm.enable_tab('weixin')),expression:"enable_tab('weixin')"}],attrs:{"href":"#weixin"}},[_vm._v(" 微信     "),_c('v-icon',[_vm._v("ti-themify-favicon-alt")])],1),_vm._v(" "),_c('v-tab',{directives:[{name:"show",rawName:"v-show",value:(_vm.enable_tab('alipay')),expression:"enable_tab('alipay')"}],attrs:{"href":"#alipay"}},[_vm._v(" 支付宝    "),_c('v-icon',[_vm._v("ti-reddit")])],1),_vm._v(" "),_c('v-tab',{directives:[{name:"show",rawName:"v-show",value:(_vm.enable_tab('mall')),expression:"enable_tab('mall')"}],attrs:{"href":"#mall"}},[_vm._v(" 商场代收    "),_c('v-icon',[_vm._v("ti-home")])],1),_vm._v(" "),_c('v-tab-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.enable_tab('cash')),expression:"enable_tab('cash')"}],attrs:{"id":"cash"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('h2',[_vm._v("\n                            现金/银行卡支付\n                            "),_c('span',{staticClass:"red--text"},[_vm._v("(总金额:"+_vm._s(_vm.total_money.toFixed(2))+")")]),_vm._v(" "),(_vm.use_prepay>0)?_c('span',{staticClass:"red--text"},[_vm._v("(会员卡支付:"+_vm._s(_vm.use_prepay.toFixed(2))+")")]):_vm._e()])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-title',[_c('h3',[_vm._v("收取现金")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{ref:"in_cash",staticClass:"big_input",attrs:{"clearable":""},on:{"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==13){ return null; }_vm.enter_cash('cash')}},model:{value:(_vm.recv_money),callback:function ($$v) {_vm.recv_money=_vm._n($$v)},expression:"recv_money"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-title',[_c('h3',[_vm._v("银行卡号")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{ref:"in_bank",staticClass:"big_input",attrs:{"clearable":""},on:{"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==13){ return null; }_vm.enter_cash('bank')}},model:{value:(_vm.bank_id),callback:function ($$v) {_vm.bank_id=$$v},expression:"bank_id"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.enable_tab('weixin')),expression:"enable_tab('weixin')"}],attrs:{"id":"weixin"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('h2',[_vm._v("微信扫码支付\n                            "),_c('span',{staticClass:"red--text"},[_vm._v("(总金额:"+_vm._s(_vm.total_money.toFixed(2))+")")]),_vm._v(" "),(_vm.use_prepay>0)?_c('span',{staticClass:"red--text"},[_vm._v("(会员卡支付:"+_vm._s(_vm.use_prepay.toFixed(2))+")")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-switch',{attrs:{"color":"error","label":"部分现金"},model:{value:(_vm.mix_cash),callback:function ($$v) {_vm.mix_cash=$$v},expression:"mix_cash"}})],1),_vm._v(" "),_c('v-card-text',[(_vm.mix_cash)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-title',[_c('h3',[_vm._v("收取现金")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{ref:"weixin_cash",staticClass:"big_input",attrs:{"clearable":""},model:{value:(_vm.recv_money),callback:function ($$v) {_vm.recv_money=_vm._n($$v)},expression:"recv_money"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-title',[_c('h3',[_vm._v("微信扫码")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{ref:"in_weixin",staticClass:"big_input",attrs:{"clearable":""},on:{"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==13){ return null; }_vm.do_pay()}},model:{value:(_vm.auth_code),callback:function ($$v) {_vm.auth_code=$$v},expression:"auth_code"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.enable_tab('alipay')),expression:"enable_tab('alipay')"}],attrs:{"id":"alipay"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('h2',[_vm._v("支付宝扫码支付\n                            "),_c('span',{staticClass:"red--text"},[_vm._v("(总金额:"+_vm._s(_vm.total_money.toFixed(2))+")")]),_vm._v(" "),(_vm.use_prepay>0)?_c('span',{staticClass:"red--text"},[_vm._v("(会员卡支付:"+_vm._s(_vm.use_prepay.toFixed(2))+")")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-switch',{attrs:{"color":"error","label":"部分现金"},model:{value:(_vm.mix_cash),callback:function ($$v) {_vm.mix_cash=$$v},expression:"mix_cash"}})],1),_vm._v(" "),_c('v-card-text',[(_vm.mix_cash)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-title',[_c('h3',[_vm._v("收取现金")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{ref:"alipay_cash",staticClass:"big_input",attrs:{"clearable":""},model:{value:(_vm.recv_money),callback:function ($$v) {_vm.recv_money=_vm._n($$v)},expression:"recv_money"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-title',[_c('h3',[_vm._v("支付宝扫码")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{ref:"in_alipay",staticClass:"big_input",attrs:{"clearable":""},on:{"keyup":function($event){if(!('button' in $event)&&$event.keyCode!==13){ return null; }_vm.do_pay()}},model:{value:(_vm.auth_code),callback:function ($$v) {_vm.auth_code=$$v},expression:"auth_code"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.enable_tab('alipay')),expression:"enable_tab('alipay')"}],attrs:{"id":"mall"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('h2',[_vm._v("商场代收:\n                            "),_c('span',{staticClass:"red--text"},[_vm._v("(总金额:"+_vm._s(_vm.total_money.toFixed(2))+")")]),_vm._v(" "),(_vm.use_prepay>0)?_c('span',{staticClass:"red--text"},[_vm._v("(会员卡支付:"+_vm._s(_vm.use_prepay.toFixed(2))+")")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-switch',{attrs:{"color":"error","label":"部分现金"},model:{value:(_vm.mix_cash),callback:function ($$v) {_vm.mix_cash=$$v},expression:"mix_cash"}})],1),_vm._v(" "),_c('v-card-text',[(_vm.mix_cash)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-title',[_c('h3',[_vm._v("收取现金")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{ref:"mall_cash",staticClass:"big_input",attrs:{"clearable":""},model:{value:(_vm.recv_money),callback:function ($$v) {_vm.recv_money=_vm._n($$v)},expression:"recv_money"}})],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),(_vm.cash_msg)?_c('h2',{staticClass:"red--text"},[_vm._v(_vm._s(_vm.cash_msg)+" ")]):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[(_vm.enable_types.indexOf('taobao')>-1)?_c('v-switch',{attrs:{"color":"error","label":"淘宝订单"},model:{value:(_vm.taobao),callback:function ($$v) {_vm.taobao=$$v},expression:"taobao"}}):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"btn-",on:{"click":function($event){$event.stopPropagation();_vm.show_dialog=false;_vm.callback&&_vm.callback(null)}}},[_vm._v("取消")]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.creating,"disabled":_vm.creating,"color":"info"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.do_pay($event)}}},[_vm._v("\n          确定\n          "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_vm._v("\n            Loading...\n          ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3mzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("iLnh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4b3195c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("9bvA");
function injectStyle (ssrContext) {
  __webpack_require__("p8by")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4b3195c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4qdK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_take_money_vue__ = __webpack_require__("KqHd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_take_money_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_take_money_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_take_money_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_take_money_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d9b1626_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_take_money_vue__ = __webpack_require__("kOQc");
function injectStyle (ssrContext) {
  __webpack_require__("hi8j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d9b1626"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_take_money_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d9b1626_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_take_money_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5beL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6YVE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Sidebar Routers
var category1 = exports.category1 = [{
  action: 'ti-dashboard',
  title: 'lookup_records',
  items: [
  // { title: 'Sale', path: '/front_sale/sale' },
  { title: 'sale_orders', path: '/admin/pages/sale_orders' }]
},
// {
//   action: 'ti-layers',
//   title: 'pages',
//   items: [
//     { title: 'gallery', path: '/pages/gallery' },
//     { title: 'pricing', path: '/pages/pricing' },
//     { title: 'blank', path: '/pages/blank' }
//   ]
// },
{
  action: 'ti-timer',
  title: 'session',
  items: [{ title: 'signUp', path: '/session/sign-up' }, { title: 'login', path: '/session/login' }, { title: 'lockScreen', path: '/session/lock-screen' }]
}];

var category2 = exports.category2 = [{
  action: 'ti-layout',
  title: 'uiElements',
  items: [{ title: 'buttons', path: '/ui-elements/buttons' }, { title: 'cards', path: '/ui-elements/cards' }, { title: 'checkbox', path: '/ui-elements/checkbox' }, { title: 'carousel', path: '/ui-elements/carousel' }, { title: 'chips', path: '/ui-elements/chips' }, { title: 'datepicker', path: '/ui-elements/datepicker' }, { title: 'dialog', path: '/ui-elements/dialog' }, { title: 'grid', path: '/ui-elements/grid' }, { title: 'input', path: '/ui-elements/input' }, { title: 'list', path: '/ui-elements/list' }, { title: 'menu', path: '/ui-elements/menu' }, { title: 'progress', path: '/ui-elements/progress' }, { title: 'radio', path: '/ui-elements/radio' }, { title: 'select', path: '/ui-elements/select' }, { title: 'slider', path: '/ui-elements/slider' }, { title: 'snackbar', path: '/ui-elements/snackbar' }, { title: 'tabs', path: '/ui-elements/tabs' }, { title: 'toolbar', path: '/ui-elements/toolbar' }, { title: 'tooltip', path: '/ui-elements/tooltip' }, { title: 'timepicker', path: '/ui-elements/timepicker' }]
}, {
  action: 'ti-comment-alt',
  title: 'forms',
  items: [{ title: 'formValidation', path: '/forms/form-validation' }, { title: 'stepper', path: '/forms/stepper' }]
}, {
  action: 'ti-pie-chart',
  title: 'charts',
  items: [{ title: 'vueChartjs', path: '/charts/vue-chartjs' }, { title: 'vueEcharts', path: '/charts/vue-echarts' }]
}, {
  action: 'ti-star',
  title: 'icons',
  items: [{ title: 'themify', path: '/icons/themify' }, { title: 'material', path: '/icons/material' }]
}, {
  action: 'ti-layout',
  title: 'tables',
  items: [{ title: 'standard', path: '/tables/standard' }, { title: 'slots', path: '/tables/slots' }, { title: 'selectable', path: '/tables/selectablerows' }, { title: 'searchRow', path: '/tables/searchwithtext' }]
}, {
  action: 'ti-map-alt',
  title: 'maps',
  items: [{ title: 'googleMaps', path: '/maps/google-maps' }, { title: 'leafletMaps', path: '/maps/leaflet-maps' }, { title: 'jvectorMap', path: '/maps/jvector-map' }]
}];

var category3 = exports.category3 = [{
  action: 'ti-email',
  title: 'inbox',
  items: null,
  path: '/inbox'
}, {
  action: 'ti-user',
  title: 'users',
  items: [{ title: 'userProfile', path: '/users/user-profile' }, { title: 'usersList', path: '/users/users-list' }]
}, {
  action: 'ti-calendar',
  title: 'calendar',
  items: null,
  path: '/calendar'
}];

var category4 = exports.category4 = [{
  action: 'ti-pencil-alt',
  title: 'editor',
  items: [{ title: 'quillEditor', path: '/editor/quilleditor' }, { title: 'wYSIWYG', path: '/editor/wysiwyg' }]
}, {
  action: 'ti-mouse-alt',
  title: 'dragAndDrop',
  items: [{ title: 'vue2Dragula', path: '/drag-drop/vue2dragula' }, { title: 'vueDraggable', path: '/drag-drop/vuedraggable' }, { title: 'draggableResizeable', path: '/drag-drop/vuedraggableresizeable' }]
}];

/***/ }),

/***/ "7ie1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_ship_out_vue__ = __webpack_require__("Otg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_ship_out_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_ship_out_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_ship_out_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_ship_out_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ea00e28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_ship_out_vue__ = __webpack_require__("WP+5");
function injectStyle (ssrContext) {
  __webpack_require__("rJFl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ea00e28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_ship_out_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ea00e28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_ship_out_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7r/j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Jk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("nKaI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be0fd80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("k59F");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be0fd80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8k8G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_destroy_vue__ = __webpack_require__("Zdt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_destroy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_destroy_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_destroy_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_destroy_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc564070_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_destroy_vue__ = __webpack_require__("2e75");
function injectStyle (ssrContext) {
  __webpack_require__("TzVh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc564070"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_destroy_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc564070_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_destroy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8s9y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "95Q9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base_api = __webpack_require__("+TLI");

var _select_options = __webpack_require__("KykW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    //template:``,
    name: '',
    props: {
        width: {
            type: String,
            default: '500px'
        }
    },
    computed: {
        show_dialog: {
            get: function get() {
                return this.$store.state.dialog.show_pay_order_dialog;
            },
            set: function set(val) {
                this.$store.commit('SHOW_DIALOG_PAY_ORDER', val);
            }
        }
    },
    methods: {
        init_value: function init_value() {
            this.money = this.bywho = this.forwhat = this.note = this.from = null;
        },
        isvalide: function isvalide() {
            return 1 * this.money && this.forwhat && this.from && this.note && this.bywho;
        },
        get_user_list: function get_user_list() {
            var _this = this;

            console.log("NEED GET SYSUSER LIST");
            (0, _select_options.selectoption)({ oper: 'sysuser', key: "_id", value: "name", type: 'obj' }).then(function (resp) {
                _this.sysuser = resp.data;
            }).catch(function (err) {
                console.log(err);
            });
        },
        create_record: function create_record() {
            var _this2 = this;

            console.log("click");
            this.creating = true;

            if (this.isvalide()) {
                (0, _base_api.base_api)({
                    schema: 'payout',
                    method: 'post',
                    params: {},
                    data: {
                        bywho: this.bywho,
                        money: this.money,
                        order_id: this.order_id,
                        forwhat: this.forwhat,
                        from: this.from,
                        note: this.note
                    }
                }).then(function (doc) {
                    _this2.$notify({
                        group: 'msg',
                        type: 'success',
                        title: '操作成功！',
                        text: '提现记录创建成功',
                        duration: 500
                    });
                    _this2.show_dialog = false;
                    _this2.init_value();
                }).catch(function (err) {
                    _this2.$notify({
                        group: 'msg',
                        type: 'warn',
                        title: '操作失败！',
                        text: '提现记录创建失败' + err.message
                    });
                }).then(function (_) {
                    debugger;
                    _this2.creating = false;
                });
            }
        }
    },
    components: {},
    watch: {
        show_dialog: function show_dialog(val) {
            if (val) {
                // this.creating = false,
                this.order_id = +new Date();
                if (this.sysuser.length == 0) {
                    this.get_user_list();
                }
            }
        }
    },
    directives: {},
    mounted: function mounted() {
        if (this.sysuser.length == 0) {
            this.get_user_list();
        }
    },
    data: function data() {
        return {
            creating: false,
            order_id: +new Date(),
            money: null,
            forwhat: null,
            bywho: null,
            note: null,
            from: null,
            sysuser: [],
            from_option: [{ value: 'zhuanzhang', text: '转账支出' }, { value: 'liushui', text: '店内流水' }, { value: 'dianfu', text: '个人垫付' }, { value: 'onpay', text: '记帐' }],
            what_option: [{ value: 'shuidian', text: '水电费' }, { value: 'dianhua', text: '电话费' }, { value: 'wuliu', text: '快递/物流' }, { value: 'fangzu', text: '房租' }, { value: 'qita', text: '其他' }]
        };
    },

    filters: {
        //pluralize: (n, w) => n === 1 ? w : (w + 's'),
        capitalize: function capitalize(s) {
            return s.charAt(0).toUpperCase() + s.slice(1);
        }
    }
};

/***/ }),

/***/ "986N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-card mb-0"},[_c('div',{staticClass:"app-card-content"},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.list,"item-key":"gid","hide-actions":"","no-data-text":"无商品信息"},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[_c('th',{staticStyle:{"width":"20px"}},[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},model:{value:(_vm.select_all),callback:function ($$v) {_vm.select_all=$$v},expression:"select_all"}})],1),_vm._v(" "),_vm._l((props.headers),function(header){return _c('th',{key:header.text},[_vm._v("\n            "+_vm._s(header.text)+"\n          ")])})],2)]}},{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},model:{value:(props.item.selected),callback:function ($$v) {_vm.$set(props.item, "selected", $$v)},expression:"props.item.selected"}})],1),_vm._v(" "),_c('td',[_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"pink darken-1"},on:{"click":function($event){_vm.delete_it(props.item)}}},[_c('v-icon',{staticClass:"iconfont",attrs:{"dark":""}},[_vm._v("icon-del1")])],1)],1),_vm._v(" "),_c('td',[_c('h3',[_vm._v(_vm._s(props.item.name)+"\n              "),(props.item.isEMS)?_c('span',{staticClass:"mylable purple darken-1"},[_vm._v("直邮")]):_vm._e()]),_vm._v(" "),_c('p',[_vm._v("\n              "+_vm._s(props.item.gid)+"\n              "),(props.item.save_take == 'take')?_c('span',{staticClass:"mylable red darken-1"},[_vm._v("存"+_vm._s(props.item.all_num)+"&提货")]):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('h4',[_vm._v(_vm._s(props.item.sale_price))]),_vm._v(" "),_c('span',{staticClass:"mylable mylable-success "},[_vm._v("V:"+_vm._s(props.item.default_vip_price))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('span',{staticClass:"realprice"},[_vm._v(_vm._s(props.item.real_price.toFixed(2)))]),_vm._v(" "),(props.item.default_vip_price == props.item.real_price)?_c('span',{staticClass:"mylable mylable-success "},[_vm._v("V")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"mylable purple darken-1"},[_vm._v(_vm._s(_vm.item_discount(props.item.gid))+"折")]),_vm._v(" "),(Math.floor(props.item.less/props.item.real_price)>0)?_c('v-badge',{attrs:{"color":"pink"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(Math.floor(props.item.less/props.item.real_price)))]),_vm._v(" "),_c('span',{staticClass:"p_less"},[_vm._v("赠")])]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"warning"},on:{"click":function($event){_vm.inc_number(props.item,-1)}}},[_c('v-icon',{staticClass:"iconfont",attrs:{"dark":""}},[_vm._v("icon-jian")])],1),_vm._v(" "),_c('span',{staticClass:"p_count"},[_vm._v(_vm._s(props.item.num))]),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"success"},on:{"click":function($event){_vm.inc_number(props.item,+1)}}},[_c('v-icon',{staticClass:"iconfont",attrs:{"dark":""}},[_vm._v("icon-plus")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center`"},[_c('opermenu',{attrs:{"item":props.item,"isfinished":_vm.isfinished}})],1)]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Z//":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
exports.default = {
  data: function data() {
    return {
      items: [{ active: true, title: "Jason Oner", avatar: "/static/img/user-6.jpg" }, {
        active: true,
        title: "Ranee Carlson",
        avatar: "/static/img/user-7.jpg"
      }, { title: "Cindy Baker", avatar: "/static/img/user-8.jpg" }, { title: "Ali Connors", avatar: "/static/img/user-9.jpg" }],
      items2: [{ title: "Travis Howard", avatar: "/static/img/user-10.jpg" }]
    };
  }
};

/***/ }),

/***/ "9bvA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"navbar-default",attrs:{"app":"","fixed":"","clipped-left":!_vm.ifRtlLayout,"clipped-right":_vm.ifRtlLayout}},[_c('div',{staticClass:"site-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/static/img/lovebaby.png","alt":"site logo","width":"50","height":"50"}}),_vm._v(" "),_c('small',{staticClass:"shop_name"},[_vm._v(_vm._s(_vm.shop_info.cn_name))])])],1),_vm._v(" "),_c('div',{staticClass:"left-nav"},[_c('v-menu',{attrs:{"offset-y":""}},[_c('div',{staticClass:"drop-menu",attrs:{"slot":"activator"},slot:"activator"},[_c('img',{staticClass:"rounded-circle",attrs:{"width":"30px","height":"30px","src":"/static/img/user-7.jpg"}}),_vm._v(" "),_c('span',[_vm._v("店内事务")])]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.add_vip()}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray iconfont"},[_vm._v("icon-usherplus")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("添加会员")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.show_dialog('SHOW_DIALOG_TAKE_CASH')}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray iconfont"},[_vm._v("icon-newbimoney")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("提现")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.show_dialog('SHOW_DIALOG_PAY_ORDER')}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray iconfont"},[_vm._v("icon-credit")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("费用支出")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.$router.push('/admin/pages/miaosha_order')}}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray iconfont"},[_vm._v("icon-list")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("秒杀订单")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"href":"/front_admin.php","target":"_blank"}},[_c('v-icon',{staticClass:"mr-3 font-lg iconfont"},[_vm._v("icon-static")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("数据")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"left-nav"},[_c('v-btn',{staticClass:"d-inline-50",attrs:{"icon":"","href":"/","target":"_blank"}},[_c('i',{staticClass:"font-lg iconfont icon-source "})]),_vm._v(" "),_c('v-btn',{staticClass:"d-inline-50",attrs:{"icon":""},on:{"click":_vm.reset_order}},[_c('i',{staticClass:"font-lg iconfont icon-refresh"})]),_vm._v(" "),_c('v-btn',{staticClass:"d-inline-50",attrs:{"icon":""},on:{"click":function($event){_vm.add_vip()}}},[_c('i',{staticClass:"font-lg iconfont icon-usherplus"})]),_vm._v(" "),_c('v-btn',{staticClass:"d-inline-50",attrs:{"icon":""},on:{"click":function($event){_vm.edit_sale_note_dlg('订单备注')}}},[_c('i',{staticClass:"font-lg iconfont icon-note-copy"})]),_vm._v(" "),_c('v-btn',{staticClass:"d-inline-50",attrs:{"icon":""},on:{"click":function($event){_vm.device_api.open_box()}}},[_c('i',{staticClass:"font-lg iconfont icon-unlock"})]),_vm._v(" "),_c('v-btn',{staticClass:"d-inline-50",attrs:{"icon":""},on:{"click":function($event){_vm.$router.push('/admin/pages/sale_orders')}}},[_c('i',{staticClass:"font-lg iconfont icon-List"})])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"pa-3"}),_vm._v(" "),_c('div',{staticClass:"right-nav"},[_c('v-btn',{staticClass:"d-inline-50",attrs:{"icon":""},on:{"click":_vm.toggleFullScreen}},[_c('i',{staticClass:"ti-fullscreen"})]),_vm._v(" "),_c('v-menu',{staticClass:"d-inline-50",attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray icon-message"})],1),_vm._v(" "),_c('v-list',_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.title,on:{"click":function($event){}}},[_c('v-icon',{},[_vm._v("  "+_vm._s(item.icon))]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)}))],1),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""}},[_c('div',{staticClass:"drop-menu",attrs:{"slot":"activator"},slot:"activator"},[_c('img',{staticClass:"rounded-circle",attrs:{"width":"30px","height":"30px","src":"/static/img/user-7.jpg"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s((_vm.sysuser_info&&_vm.sysuser_info.name)?_vm.sysuser_info.name:""))])]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":_vm.user_logout}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-power-off")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("退出")])],1)],1)],1)],1)],1),_vm._v(" "),_c('dialog_user_input'),_vm._v(" "),_c('dialog_vip_edit'),_vm._v(" "),_c('dialog_take_money'),_vm._v(" "),_c('dialog_pay_order')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AEVS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AZo+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToken = getToken;
exports.setToken = setToken;
exports.removeToken = removeToken;

var _jsCookie = __webpack_require__("lbHh");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TokenKey = 'ppvision-sale';

function getToken() {
  return _jsCookie2.default.get(TokenKey);
}

function setToken(token) {
  return _jsCookie2.default.set(TokenKey, token);
}

function removeToken() {
  return _jsCookie2.default.remove(TokenKey);
}

/***/ }),

/***/ "BW+J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_vip_recharge_vue__ = __webpack_require__("tMWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_vip_recharge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_vip_recharge_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_vip_recharge_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_vip_recharge_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dc1ed9d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_vip_recharge_vue__ = __webpack_require__("yVEx");
function injectStyle (ssrContext) {
  __webpack_require__("zkQm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0dc1ed9d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_vip_recharge_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dc1ed9d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_vip_recharge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Be4M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _mutations;

var _mutationDefine = __webpack_require__("a2hP");

var types = _interopRequireWildcard(_mutationDefine);

var _base_api = __webpack_require__("+TLI");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var st_sysuser_key = "shop_info";
// const storage =  sessionStorage;
var storage = localStorage; //

var state = {
  //{name:'调货申请', href:"#", percent:0, level:"success", }
  todo_task: [],
  notify: [],
  messages: [],

  detail: null,
  user_name: "",
  user_id: "",
  avatar: "../static/avatars/user.jpg"

  // getters
};var getters = {
  sysuser_info: function sysuser_info(state) {
    if (state.detail) return state.detail;
    var user_info = sessionStorage.getItem(st_sysuser_key);
    if (user_info) {
      try {
        state.detail = JSON.parse(user_info);
      } catch (err) {
        debugger;
        msgpad_show("msgpad", "失败", err.message, 'error');
      }
    }
    return state.detail;
  },
  user_todo_task: function user_todo_task(state) {
    return state.todo_task;
  },
  user_notify: function user_notify(state) {
    return state.notify;
  },
  user_messages: function user_messages(state) {
    return state.messages;
  }

  // actions
};var actions = {
  act_worker_login: function act_worker_login(context, _ref) {
    var shop_id = _ref.shop_id,
        sec_key = _ref.sec_key,
        worker_id = _ref.worker_id,
        password = _ref.password;

    //{method,schema,params,data}
    // debugger
    return (0, _base_api.base_api)({
      method: 'post',
      schema: 'login',
      params: { action: 'ajaxlogin' },
      data: {
        shop_id: shop_id,
        sec_key: sec_key,
        worker_id: worker_id,
        password: password
      }
    }).then(function (resp) {
      return resp.data;
    });
  },
  act_worker_logout: function act_worker_logout(context) {
    return (0, _base_api.base_api)({
      method: 'get',
      schema: 'login',
      params: { action: 'ajaxlogout' }
    }).then(function (resp) {

      return resp.data;
    });
  },
  act_user_message: function act_user_message(context) {},
  req_user_todo_task: function req_user_todo_task(context) {},
  req_user_message: function req_user_message(context) {},
  req_user_notify: function req_user_notify(context) {}
};

// mutations
var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.NAVBAR_USER_USER_INFO, function (state, user_info) {
  state.detail = user_info;
  sessionStorage.setItem(st_sysuser_key, (0, _stringify2.default)(user_info));
}), (0, _defineProperty3.default)(_mutations, types.NAVBAR_USER_TODO_TASK, function (state, todo_task) {
  state.todo_task = todo_task ? todo_task : [];
}), (0, _defineProperty3.default)(_mutations, types.NAVBAR_USER_NOTIFY, function (state, notify) {
  state.notify = notify ? notify : [];
}), (0, _defineProperty3.default)(_mutations, types.NAVBAR_USER_MESSAGE, function (state, msg) {
  state.messages = msg ? msg : [];
}), _mutations);

exports.default = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),

/***/ "Cleq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

exports.lookup_cash_withdraw = lookup_cash_withdraw;
exports.create_cash_withdraw = create_cash_withdraw;

var _ajax_request = __webpack_require__("Hm2B");

var _ajax_request2 = _interopRequireDefault(_ajax_request);

var _base_api = __webpack_require__("+TLI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function lookup_cash_withdraw(query) {
	var def_base_url = _base_api.base_url + "/pos";
	var url = def_base_url + "/cash";
	return (0, _ajax_request2.default)({
		url: url,
		method: 'get',
		params: (0, _assign2.default)({}, _base_api.debug_obj, query ? query : {})
	});
}

function create_cash_withdraw(_ref) {
	var params = _ref.params,
	    data = _ref.data;

	var def_base_url = _base_api.base_url + '/pos';

	var url = def_base_url + "/cash";
	debugger;
	return (0, _ajax_request2.default)({
		url: url,
		method: 'post',
		// params :{oper:type},
		params: (0, _assign2.default)({}, _base_api.debug_obj, params ? params : {}),
		data: data
	});
}

/***/ }),

/***/ "D/sH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _module$exports;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
//messages.js
module.exports = (_module$exports = {
  general: 'General',
  overview: 'Overview',
  customizer: 'Customizer',
  applications: 'Application',
  features: 'Features',
  components: 'Components'
}, (0, _defineProperty3.default)(_module$exports, 'applications', 'Applications'), (0, _defineProperty3.default)(_module$exports, 'features', 'Features'), (0, _defineProperty3.default)(_module$exports, 'salesAndVisitStats', 'SALES & VISITS STATS'), (0, _defineProperty3.default)(_module$exports, 'orderAndProjectStats', 'Order & Projects Stats'), (0, _defineProperty3.default)(_module$exports, 'fitnessStats', 'Fitness Stats'), (0, _defineProperty3.default)(_module$exports, 'supportAndUsefulWidgets', 'Support & Usefull Widgets'), (0, _defineProperty3.default)(_module$exports, 'dashboard', 'Dashboard'), (0, _defineProperty3.default)(_module$exports, 'lookup_records', '记录查询'), (0, _defineProperty3.default)(_module$exports, 'Sale', '销售'), (0, _defineProperty3.default)(_module$exports, 'sale_orders', '销售详单'), (0, _defineProperty3.default)(_module$exports, 'shop_stock', '店内库存'), (0, _defineProperty3.default)(_module$exports, 'shop_cash_mng', "现金管理"), (0, _defineProperty3.default)(_module$exports, 'shop_new_vip', "新增会员"), (0, _defineProperty3.default)(_module$exports, 'shop_user_saved', "用户暂存"), (0, _defineProperty3.default)(_module$exports, 'shop_user_prepay', "用户充值"), (0, _defineProperty3.default)(_module$exports, 'shop_ship_order', "店铺调拨"), (0, _defineProperty3.default)(_module$exports, 'shop_recv_order', "店铺收货"), (0, _defineProperty3.default)(_module$exports, 'shop_pandian_order', "店铺盘点"), (0, _defineProperty3.default)(_module$exports, 'shop_destroy_order', "商品报损"), (0, _defineProperty3.default)(_module$exports, 'shop_request_order', "配货申请"), (0, _defineProperty3.default)(_module$exports, 'dashboardv1', 'Dashboard V1'), (0, _defineProperty3.default)(_module$exports, 'dashboardv2', 'Dashboard V2'), (0, _defineProperty3.default)(_module$exports, 'pages', 'Pages'), (0, _defineProperty3.default)(_module$exports, 'gallery', 'Gallery'), (0, _defineProperty3.default)(_module$exports, 'pricing', 'Pricing'), (0, _defineProperty3.default)(_module$exports, 'blank', 'Blank'), (0, _defineProperty3.default)(_module$exports, 'session', 'Session'), (0, _defineProperty3.default)(_module$exports, 'signUp', 'Sign Up'), (0, _defineProperty3.default)(_module$exports, 'login', 'Login'), (0, _defineProperty3.default)(_module$exports, 'lockScreen', 'Lock Screen'), (0, _defineProperty3.default)(_module$exports, 'uiElements', 'UI Elements'), (0, _defineProperty3.default)(_module$exports, 'buttons', 'Buttons'), (0, _defineProperty3.default)(_module$exports, 'cards', 'Cards'), (0, _defineProperty3.default)(_module$exports, 'checkbox', 'Checkbox'), (0, _defineProperty3.default)(_module$exports, 'carousel', 'Carousel'), (0, _defineProperty3.default)(_module$exports, 'chips', 'Chips'), (0, _defineProperty3.default)(_module$exports, 'datepicker', 'Datepicker'), (0, _defineProperty3.default)(_module$exports, 'dialog', 'Dialog'), (0, _defineProperty3.default)(_module$exports, 'grid', 'Grid'), (0, _defineProperty3.default)(_module$exports, 'input', 'Input'), (0, _defineProperty3.default)(_module$exports, 'list', 'List'), (0, _defineProperty3.default)(_module$exports, 'menu', 'Menu'), (0, _defineProperty3.default)(_module$exports, 'progress', 'Progress'), (0, _defineProperty3.default)(_module$exports, 'radio', 'Radio'), (0, _defineProperty3.default)(_module$exports, 'select', 'Select'), (0, _defineProperty3.default)(_module$exports, 'slider', 'Slider'), (0, _defineProperty3.default)(_module$exports, 'snackbar', 'Snackbar'), (0, _defineProperty3.default)(_module$exports, 'tabs', 'Tabs'), (0, _defineProperty3.default)(_module$exports, 'toolbar', 'Toolbar'), (0, _defineProperty3.default)(_module$exports, 'tooltip', 'Tooltip'), (0, _defineProperty3.default)(_module$exports, 'timepicker', 'Timepicker'), (0, _defineProperty3.default)(_module$exports, 'forms', 'Forms'), (0, _defineProperty3.default)(_module$exports, 'formValidation', 'Form Validation'), (0, _defineProperty3.default)(_module$exports, 'stepper', 'Stepper'), (0, _defineProperty3.default)(_module$exports, 'charts', 'Charts'), (0, _defineProperty3.default)(_module$exports, 'vueChartjs', 'Vue Chartjs'), (0, _defineProperty3.default)(_module$exports, 'vueEcharts', 'Vue Echarts'), (0, _defineProperty3.default)(_module$exports, 'icons', 'Icons'), (0, _defineProperty3.default)(_module$exports, 'themify', 'Themify'), (0, _defineProperty3.default)(_module$exports, 'material', 'Material'), (0, _defineProperty3.default)(_module$exports, 'tables', 'Tables'), (0, _defineProperty3.default)(_module$exports, 'standard', 'Standard'), (0, _defineProperty3.default)(_module$exports, 'slots', 'Slots'), (0, _defineProperty3.default)(_module$exports, 'selectable', 'Selectable'), (0, _defineProperty3.default)(_module$exports, 'searchRow', 'Search Row'), (0, _defineProperty3.default)(_module$exports, 'maps', 'Maps'), (0, _defineProperty3.default)(_module$exports, 'googleMaps', 'Google Maps'), (0, _defineProperty3.default)(_module$exports, 'leafletMaps', 'Leaflet Maps'), (0, _defineProperty3.default)(_module$exports, 'jvectorMap', 'Jvector Map'), (0, _defineProperty3.default)(_module$exports, 'inbox', 'Inbox'), (0, _defineProperty3.default)(_module$exports, 'users', 'Users'), (0, _defineProperty3.default)(_module$exports, 'userProfile', 'User Profile'), (0, _defineProperty3.default)(_module$exports, 'usersList', 'Users List'), (0, _defineProperty3.default)(_module$exports, 'calendar', 'Calendar'), (0, _defineProperty3.default)(_module$exports, 'editor', 'Editor'), (0, _defineProperty3.default)(_module$exports, 'quillEditor', 'Quill Editor'), (0, _defineProperty3.default)(_module$exports, 'wYSIWYG', 'WYSIWYG'), (0, _defineProperty3.default)(_module$exports, 'vue2Dragula', 'Vue2 Dragula'), (0, _defineProperty3.default)(_module$exports, 'dragAndDrop', 'Drag And Drop'), (0, _defineProperty3.default)(_module$exports, 'vueDraggable', 'Vue Draggable'), (0, _defineProperty3.default)(_module$exports, 'draggableResizeable', 'Draggable Resizeable'), _module$exports);

/***/ }),

/***/ "DX2N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _module$exports;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
//messages.js
module.exports = (_module$exports = {
  general: 'Général',
  overview: 'Aperçu',
  customizer: 'Personnalisateur',
  components: 'Composants',
  applications: 'Applications',
  features: 'Fonctionnalités'
}, (0, _defineProperty3.default)(_module$exports, 'applications', 'Applications'), (0, _defineProperty3.default)(_module$exports, 'features', 'Caractéristiques'), (0, _defineProperty3.default)(_module$exports, 'salesAndVisitStats', 'STATISTIQUES DE VENTE ET VISITES'), (0, _defineProperty3.default)(_module$exports, 'orderAndProjectStats', 'Stats de commandes et de projets'), (0, _defineProperty3.default)(_module$exports, 'fitnessStats', 'Stats de remise en forme'), (0, _defineProperty3.default)(_module$exports, 'supportAndUsefulWidgets', 'Support et Widgets utiles'), (0, _defineProperty3.default)(_module$exports, 'dashboard', 'Tableau de bord'), (0, _defineProperty3.default)(_module$exports, 'dashboardv1', 'Tableau de bord V1'), (0, _defineProperty3.default)(_module$exports, 'dashboardv2', 'Tableau de bord V2'), (0, _defineProperty3.default)(_module$exports, 'pages', 'Pages'), (0, _defineProperty3.default)(_module$exports, 'gallery', 'Galerie'), (0, _defineProperty3.default)(_module$exports, 'pricing', 'Tarification'), (0, _defineProperty3.default)(_module$exports, 'blank', 'Blanc'), (0, _defineProperty3.default)(_module$exports, 'session', 'Session'), (0, _defineProperty3.default)(_module$exports, 'signUp', "S'inscrire"), (0, _defineProperty3.default)(_module$exports, 'login', "S'identifier"), (0, _defineProperty3.default)(_module$exports, 'lockScreen', 'Écran verrouillé'), (0, _defineProperty3.default)(_module$exports, 'uiElements', "Éléments d'interface utilisateur"), (0, _defineProperty3.default)(_module$exports, 'buttons', 'Boutons'), (0, _defineProperty3.default)(_module$exports, 'cards', 'Cartes'), (0, _defineProperty3.default)(_module$exports, 'checkbox', 'Case à cocher'), (0, _defineProperty3.default)(_module$exports, 'carousel', 'Carrousel'), (0, _defineProperty3.default)(_module$exports, 'chips', 'chips'), (0, _defineProperty3.default)(_module$exports, 'datepicker', 'Sélecteur de date'), (0, _defineProperty3.default)(_module$exports, 'dialog', 'Dialogue'), (0, _defineProperty3.default)(_module$exports, 'grid', 'la grille'), (0, _defineProperty3.default)(_module$exports, 'input', 'Contribution'), (0, _defineProperty3.default)(_module$exports, 'list', 'liste'), (0, _defineProperty3.default)(_module$exports, 'menu', 'Menu'), (0, _defineProperty3.default)(_module$exports, 'progress', 'Le progrès'), (0, _defineProperty3.default)(_module$exports, 'radio', 'Radio'), (0, _defineProperty3.default)(_module$exports, 'select', 'Sélectionner'), (0, _defineProperty3.default)(_module$exports, 'slider', 'Slider'), (0, _defineProperty3.default)(_module$exports, 'snackbar', 'Snackbar'), (0, _defineProperty3.default)(_module$exports, 'tabs', 'Tabs'), (0, _defineProperty3.default)(_module$exports, 'toolbar', "Barre d'outils"), (0, _defineProperty3.default)(_module$exports, 'tooltip', "info-bulle"), (0, _defineProperty3.default)(_module$exports, 'timepicker', 'Timepicker'), (0, _defineProperty3.default)(_module$exports, 'forms', 'Formes'), (0, _defineProperty3.default)(_module$exports, 'formValidation', 'Validation de formulaire'), (0, _defineProperty3.default)(_module$exports, 'stepper', 'Stepper'), (0, _defineProperty3.default)(_module$exports, 'charts', 'Graphiques'), (0, _defineProperty3.default)(_module$exports, 'vueChartjs', 'Vue Chartjs'), (0, _defineProperty3.default)(_module$exports, 'vueEcharts', 'Vue Echarts'), (0, _defineProperty3.default)(_module$exports, 'icons', 'Icônes'), (0, _defineProperty3.default)(_module$exports, 'themify', 'Thémifier'), (0, _defineProperty3.default)(_module$exports, 'material', 'Matériel'), (0, _defineProperty3.default)(_module$exports, 'tables', 'les tables'), (0, _defineProperty3.default)(_module$exports, 'standard', 'la norme'), (0, _defineProperty3.default)(_module$exports, 'slots', 'Slots'), (0, _defineProperty3.default)(_module$exports, 'selectable', 'Sélectionnable'), (0, _defineProperty3.default)(_module$exports, 'searchRow', 'Rechercher une ligne'), (0, _defineProperty3.default)(_module$exports, 'maps', 'Plans'), (0, _defineProperty3.default)(_module$exports, 'googleMaps', 'Google Maps'), (0, _defineProperty3.default)(_module$exports, 'leafletMaps', 'Cartes de brochure'), (0, _defineProperty3.default)(_module$exports, 'jvectorMap', 'Carte Jvector'), (0, _defineProperty3.default)(_module$exports, 'inbox', 'Boîte de réception'), (0, _defineProperty3.default)(_module$exports, 'users', 'Utilisateurs'), (0, _defineProperty3.default)(_module$exports, 'userProfile', "Profil de l'utilisateur"), (0, _defineProperty3.default)(_module$exports, 'usersList', 'Liste des utilisateurs'), (0, _defineProperty3.default)(_module$exports, 'calendar', 'Calendrier'), (0, _defineProperty3.default)(_module$exports, 'editor', 'Éditeur'), (0, _defineProperty3.default)(_module$exports, 'quillEditor', 'Éditeur de piquants'), (0, _defineProperty3.default)(_module$exports, 'wYSIWYG', 'WYSIWYG'), (0, _defineProperty3.default)(_module$exports, 'vue2Dragula', 'Vue2 Dragula'), (0, _defineProperty3.default)(_module$exports, 'dragAndDrop', 'Glisser déposer'), (0, _defineProperty3.default)(_module$exports, 'vueDraggable', 'Vue Draggable'), (0, _defineProperty3.default)(_module$exports, 'draggableResizeable', 'Draggable Resizeable'), _module$exports);

/***/ }),

/***/ "E/RS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab-item',{attrs:{"id":_vm.name}},[_c('v-flex',{attrs:{"xl12":"","lg12":"","md12":"","xs12":""}},[_c(_vm.show_style,{tag:"component"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hm2B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _auth = __webpack_require__("AZo+");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { getToken } from '@/utils/auth'

// create an axios instance
var service = _axios2.default.create({
  baseURL: Object({"NODE_ENV":"production"}).BASE_API, // api的base_url
  timeout: 30000 // request timeout

});

// request interceptor
service.interceptors.request.use(function (config) {
  // Do something before request is sent
  if (_store2.default.getters.token) {
    // config.headers['X-Token'] = getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  }
  return config;
}, function (error) {
  // Do something with request error
  console.log(error); // for debug
  _promise2.default.reject(error);
});

// respone interceptor
service.interceptors.response.use(function (response) {
  return response;
},
/**
* 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
* 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
*/
//  const res = response.data;
//     if (res.code !== 20000) {
//       Message({
//         message: res.message,
//         type: 'error',
//         duration: 5 * 1000
//       });
//       // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
//       if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
//         MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
//           confirmButtonText: '重新登录',
//           cancelButtonText: '取消',
//           type: 'warning'
//         }).then(() => {
//           store.dispatch('FedLogOut').then(() => {
//             location.reload();// 为了重新实例化vue-router对象 避免bug
//           });
//         })
//       }
//       return Promise.reject('error');
//     } else {
//       return response.data;
//     }
function (error) {
  console.log('err' + error); // for debug
  // Message({
  //   message: error.message,
  //   type: 'error',
  //   duration: 5 * 1000
  // })

  if (error.response && error.response.status === 401) {
    console.log('unauthorized, logging out ... router.replace(login)');
    // auth.logout();
    (0, _auth.removeToken)();
    _router2.default.replace("/login");
    // router.push('/login');
    debugger;
  }

  return _promise2.default.reject(error);
});

exports.default = service;

/***/ }),

/***/ "HpBf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I2dI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('v-content',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('vm-back-top')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ILPL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base_api = __webpack_require__("+TLI");

var _is_valid_usercid = __webpack_require__("SxnS");

var _is_valid_usercid2 = _interopRequireDefault(_is_valid_usercid);

var _select_options = __webpack_require__("KykW");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    //template:``,
    name: '',
    props: {
        width: {
            type: String,
            default: '500px'
        }
    },
    computed: {
        show_dialog: {
            get: function get() {
                return this.$store.state.dialog.show_editvip_dialog;
            },
            set: function set(val) {
                // debugger
                if (val == true) {
                    if (this.show_dialog == 'add' || this.show_dialog == 'edit' || this.show_dialog == 'valid') return;
                }
                this.$store.commit('SHOW_DIALOG_EDITVIP', val);
            }
        },
        vip_info: function vip_info() {
            return this.$store.state.vip.vip;
        },
        title: function title() {
            // debugger
            if (this.show_dialog == 'add') return '添加会员';
            if (this.show_dialog == 'valid') return '会员信息验证';
            return '修改会员';
        },
        birthday: function birthday() {
            if (this.child.birthday) return this.child.birthday.split('T')[0];
            return '';
        }
    },
    methods: {
        empty_value: function empty_value() {
            this.mobile = "";
            this.name = "";
            this.user_group = "vip";
            this.addr_act = "";
            this.signed = false;
            this.sex = false;
            this.child.birthday = "";
            this.child.sex = true;
            this.spec_info.userid = '';
            this.spec_info.valid = false;
        },
        init_value: function init_value() {
            // debugger
            if (this.show_dialog == 'add') {
                return this.empty_value();
            }
            if (!this.vip_info.mobile) return this.empty_value();

            this.mobile = this.vip_info.mobile;
            this.name = this.vip_info.name;
            this.user_group = this.vip_info.user_group;
            this.addr_act = this.vip_info.addr_act;
            this.signed = this.vip_info.signed;
            this.sex = this.vip_info.sex;
            this.child.birthday = this.vip_info.child && this.vip_info.child.birthday ? this.vip_info.child.birthday.split(' ')[0] : "";
            this.child.sex = this.vip_info.child && this.vip_info.child.sex;
            this.spec_info.userid = this.vip_info.spec_info.userid;
            this.spec_info.valid = this.vip_info.spec_info.valid;
        },
        save_menu: function save_menu(date) {
            console.log("data select change:", date);
            this.$refs.menu.save(date);
        },
        is_valide_mobiel: function is_valide_mobiel(val) {
            if (/^1[345789]\d{9}$/.test(val)) return true;
            return "不正确的手机格式";
        },
        valide_userid: function valide_userid() {

            return (0, _is_valid_usercid2.default)(this.spec_info.userid);
        },
        is_valide_userid: function is_valide_userid(val) {
            if (val == "") {
                return true;
            }
            var isok = (0, _is_valid_usercid2.default)(val);
            if (isok) return true;
            return "身份证格式不正确";
        },
        check_valid: function check_valid() {
            var self = this;
            var name = this.name;
            if (name.length < 2 || name.indexOf('小姐') >= 0 || name.indexOf('女士') >= 0 || name.indexOf('先生') >= 0) {
                this.$notify({ group: 'msgpad', type: 'error', title: '姓名格式不正确', text: '', duration: 500 });
                return false;
            }
            (0, _base_api.base_api)({
                schema: 'vip',
                method: 'post',
                params: { oper: 'idvalid' },
                data: {
                    name: self.name,
                    mobile: self.mobile,
                    userid: self.spec_info.userid
                } }).then(function (resp) {
                // debugger
                self.$store.commit("VIP_SET_VIP_INFO", resp.data);

                self.$notify({
                    group: 'msgpad',
                    type: 'success',
                    title: '认证成功',
                    text: '姓名与身份证信息一致'
                });
                self.init_value();
                if (self.show_dialog == 'valid') {
                    self.show_dialog = false;
                }
            }).catch(function (err) {
                self.$notify({
                    group: 'msgpad',
                    type: 'error',
                    title: '认证失败',
                    text: err.response ? err.response.data : err.message
                });
            });
        },
        create_record: function create_record() {
            console.log("click");
            var self = this;
            debugger;
            var ok = self.$refs.form.validate();
            if (!ok) return;
            (0, _base_api.base_api)({
                schema: 'vip',
                method: 'post',
                params: { oper: self.show_dialog },
                data: {
                    oper: self.show_dialog == "add" ? "add" : "edit",
                    mobile: self.mobile,
                    name: self.name,
                    user_group: self.user_group,
                    addr_act: self.addr_act,
                    signed: self.signed,
                    sex: self.sex,
                    child: {
                        birthday: self.child.birthday,
                        sex: self.child.sex
                    },
                    spec_info: {
                        userid: self.spec_info.userid,
                        valid: self.spec_info.valid
                    }
                }
            }).then(function (resp) {
                self.$notify({ group: 'msgpad', type: 'success', title: '操作成功！', text: '', duration: 500 });
                // self.init_value();
                self.$store.commit("VIP_SET_VIP_INFO", resp.data);
                if (self.show_dialog == "add") {
                    self.$store.commit("VIP_SET_VIP_SAVED", []);
                    self.$store.commit("PRODUCTS_PREPARE_LIST", []);
                }
                self.$store.commit("PRODUCTS_RESET_VIP_PRICE", resp.data.user_group);
                self.show_dialog = false;
            }).catch(function (err) {
                self.$notify({
                    group: 'msgpad',
                    type: 'error',
                    title: '操作失败！',
                    text: err.response ? err.response.data : err.message
                });
            }).then(function (_) {
                // debugger;
                self.doing = false;
            });
        }
    },
    components: {},
    watch: {
        show_dialog: function show_dialog(val, old) {
            console.log("show_dialog :", val, old);
            if (val) {
                this.init_value();
            } else {
                this.doing = false;
            }
        },
        menu: function menu(val) {
            var _this = this;

            val && this.$nextTick(function () {
                return _this.$refs.picker.activePicker = 'YEAR';
            });
        }
    },
    directives: {},
    mounted: function mounted() {},
    data: function data() {
        return {
            mobile: "",
            name: "",
            user_group: "vip",
            addr_act: "",
            signed: false,
            sex: false,
            child: {
                birthday: "",
                sex: true
            },
            spec_info: {
                userid: "",
                valid: false
            },
            vip_type: [{ value: 'vip', text: '注册会员' }, { value: 'copper', text: '铜牌会员' }, { value: 'silver', text: '银牌会员' }, { value: 'gold', text: '金牌会员' }, { value: 'diamond', text: '钻石会员' }],
            doing: false,
            menu: false
        };
    },

    filters: {
        //pluralize: (n, w) => n === 1 ? w : (w + 's'),
        capitalize: function capitalize(s) {
            return s.charAt(0).toUpperCase() + s.slice(1);
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _vip_store = __webpack_require__("hwn7");

var _vip_store2 = _interopRequireDefault(_vip_store);

var _prepare_store = __webpack_require__("NSzy");

var _prepare_store2 = _interopRequireDefault(_prepare_store);

var _products_store = __webpack_require__("0ixg");

var _products_store2 = _interopRequireDefault(_products_store);

var _dialog_store = __webpack_require__("dn0Q");

var _dialog_store2 = _interopRequireDefault(_dialog_store);

var _saved_orders_store = __webpack_require__("u7OC");

var _saved_orders_store2 = _interopRequireDefault(_saved_orders_store);

var _select_options_store = __webpack_require__("ulTV");

var _select_options_store2 = _interopRequireDefault(_select_options_store);

var _shop_store = __webpack_require__("+ENJ");

var _shop_store2 = _interopRequireDefault(_shop_store);

var _sys_user = __webpack_require__("Be4M");

var _sys_user2 = _interopRequireDefault(_sys_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-new */
_vue2.default.use(_vuex2.default);
// import navbar_user from './navbar_user'
exports.default = new _vuex2.default.Store({
  modules: {
    vip: _vip_store2.default,
    prepare_product: _prepare_store2.default,
    products: _products_store2.default,
    dialog: _dialog_store2.default,
    saved_order: _saved_orders_store2.default,
    select_options: _select_options_store2.default,
    shop_info: _shop_store2.default,
    sys_user: _sys_user2.default
  }
});

/***/ }),

/***/ "If6g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.lookup_vip = lookup_vip;
exports.create_or_update_vip = create_or_update_vip;
exports.lookup_vip_saved_products = lookup_vip_saved_products;
exports.vip_recharge = vip_recharge;

var _ajax_request = __webpack_require__("Hm2B");

var _ajax_request2 = _interopRequireDefault(_ajax_request);

var _base_api = __webpack_require__("+TLI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// export function get_table_schema(tableName) {
//     return request({
//         url: `${def_schema_url}${tableName}/schema`,
//         method: 'get'
//     })
// }
var def_base_url = _base_api.base_url + '/pos';

function lookup_vip(mobile) {

	return (0, _base_api.base_api)({
		method: 'get',
		schema: 'vip',
		params: {
			oper: 'get',
			mobile: mobile
		}
	});
}

function create_or_update_vip() {
	var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'add';
	var _ref = arguments[1];
	var data = _ref.data;


	return (0, _base_api.base_api)({
		method: 'post',
		schema: 'vip',
		params: {
			oper: type
		},
		data: data
	});
}

function lookup_vip_saved_products(mobile) {
	return (0, _base_api.base_api)({
		method: 'get',
		schema: 'vip',
		params: {
			oper: saved,
			mobile: mobile
		},
		data: data
	});
}

function vip_recharge(_ref2) {
	var params = _ref2.params,
	    data = _ref2.data;

	return (0, _base_api.base_api)({
		method: 'post',
		schema: 'vip',
		params: {
			oper: 'prepay'
		},
		data: data
	});
}

/***/ }),

/***/ "JlET":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue__ = __webpack_require__("0vQH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f67493c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_test_vue__ = __webpack_require__("LUsn");
function injectStyle (ssrContext) {
  __webpack_require__("AEVS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f67493c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f67493c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_test_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KqHd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shop_cash = __webpack_require__("Cleq");

var CashApi = _interopRequireWildcard(_shop_cash);

var _select_options = __webpack_require__("KykW");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  //template:``,
  name: '',
  props: {
    width: {
      type: String,
      default: '500px'
    }
  },
  computed: {
    show_dialog: {
      get: function get() {
        return this.$store.state.dialog.show_take_cash_dialog;
      },
      set: function set(val) {
        this.$store.commit('SHOW_DIALOG_TAKE_CASH', val);
      }
    }
  },
  methods: {
    init_value: function init_value() {
      this.money = this.who = this.bywho = null;
    },
    get_user_list: function get_user_list() {
      var _this = this;

      console.log("NEED GET SYSUSER LIST");
      (0, _select_options.selectoption)({ oper: 'sysuser', key: "_id", value: "name", type: 'obj' }).then(function (resp) {
        _this.sysuser = resp.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    create_record: function create_record() {
      var _this2 = this;

      console.log("click");
      this.creating = true;

      if (1 * this.money && this.who && this.bywho) {
        CashApi.create_cash_withdraw({ data: {
            money: this.money,
            who: this.who,
            bywho: this.bywho,
            order_id: this.order_id
          } }).then(function (doc) {
          _this2.$notify({
            group: 'msg',
            type: 'success',
            title: '操作成功！',
            text: '提现记录创建成功',
            duration: 500
          });
          _this2.show_dialog = false;
          _this2.init_value();
        }).catch(function (err) {
          _this2.$notify({
            group: 'msg',
            type: 'warn',
            title: '操作失败！',
            text: '提现记录创建失败' + err.message
          });
        }).then(function (_) {
          _this2.creating = false;
        });
      }
    }
  },
  components: {},
  watch: {
    show_dialog: function show_dialog(val) {
      if (val) {
        this.order_id = +new Date();

        if (this.sysuser.length == 0) {
          this.get_user_list();
        }
      }
    }
  },
  directives: {},
  mounted: function mounted() {
    if (this.sysuser.length == 0) {
      this.get_user_list();
    }
  },
  data: function data() {
    return {
      creating: false,
      money: null,
      who: null,
      bywho: null,
      order_id: +new Date(),
      sysuser: []
    };
  },

  filters: {
    //pluralize: (n, w) => n === 1 ? w : (w + 's'),
    capitalize: function capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }
  }
};

/***/ }),

/***/ "KykW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

exports.selectoption = selectoption;

var _ajax_request = __webpack_require__("Hm2B");

var _ajax_request2 = _interopRequireDefault(_ajax_request);

var _base_api = __webpack_require__("+TLI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function selectoption(query) {

	var url = _base_api.base_url + '/pos/selectoption';
	console.log(_base_api.debug_obj);
	var params = {};
	if (query) {
		if (!query.nodebug) (0, _assign2.default)(params, _base_api.debug_obj);
		(0, _assign2.default)(params, query);
	} else {
		(0, _assign2.default)(params, _base_api.debug_obj);
	}

	var req = (0, _ajax_request2.default)({
		url: url,
		method: 'get',
		params: params
	});
	console.log(_base_api.debug_obj);
	return req;
}

/***/ }),

/***/ "LUsn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","order-xs5":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-card',{attrs:{"color":"blue-grey","dark":"","tile":"","flat":""}},[_c('v-card-text',[_vm._v(_vm._s(_vm.lorem))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":""}},[_c('v-card',{attrs:{"color":"brown","dark":"","tile":"","flat":""}},[_c('v-card-text',[_vm._v(_vm._s(_vm.lorem))])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm7":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":""}},[_c('v-card',{attrs:{"color":"indigo lighten-2","dark":"","tile":"","flat":""}},[_c('v-card-text',[_vm._v(_vm._s(_vm.lorem.slice(0, 70)))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":""}},[_c('v-layout',{attrs:{"row":""}},_vm._l((2),function(n){return _c('v-flex',{key:n,attrs:{"d-flex":""}},[_c('v-card',{attrs:{"color":"amber lighten-2","tile":"","flat":""}},[_c('v-card-text',[_vm._v(_vm._s(_vm.lorem.slice(0, 40)))])],1)],1)}))],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm2":"","child-flex":""}},[_c('v-card',{attrs:{"color":"orange lighten-2","tile":"","flat":""}},[_c('v-card-text',[_vm._v(_vm._s(_vm.lorem.slice(0, 90)))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm3":""}},[_c('v-card',{attrs:{"color":"red lighten-2","dark":"","tile":"","flat":""}},[_c('v-card-text',[_vm._v(_vm._s(_vm.lorem.slice(0, 100)))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LufI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

var _auth = __webpack_require__("AZo+");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// getToken from cookie

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({ shop_info: 'shop_info' }), {
    login_step: function login_step() {
      return this.shop_info ? 1 : 0;
    }
  }),
  data: function data() {
    return {
      checkbox: false,
      valid: false,
      id: "",
      password: "",
      session_info: [{
        h1: '>用户登录<',
        h2: '请输入用户号及密码',
        f1: {
          lable: '用户号',
          rules: [function (v) {
            return !!v || "用户号是必须的";
          }]
        },
        f2: {
          lable: '密码',
          rules: [function (v) {
            return !!v || "密码是必需的";
          }]
        }
      }, {
        h1: '用户登录',
        h2: '请输入用户名及密码',
        f1: {
          lable: '用户名/手机号',
          rules: [function (v) {
            return !!v || "用户是必须的";
          }, function (v) {
            return (/^1[345789]\d{9}$/.test(v) || "用户名格式不正确"
            );
          }]
        },
        f2: {
          lable: '密码',
          rules: [function (v) {
            return !!v || "密码是必需的";
          }]
        }
      }]

    };
  },

  methods: {
    submit: function submit() {
      console.log("Login");
      var ok = this.$refs.form.validate();
      if (!ok) return this.$notify({ group: 'msgpad', type: 'error', title: '输入错误', text: '输入的信息有误！' });
      if (this.login_step == 0) this.shop_login();else this.user_login();
    },
    shop_login: function shop_login() {
      var _this = this;

      this.$store.dispatch('act_look_shop_info', {
        shop_id: this.id,
        sec_key: this.password
      }).then(function (info) {
        // debugger
        _this.$store.commit('MUTATIONS_SHOP_SHOP_INFO', info);
        _this.$notify({ group: 'msgpad', type: 'success', title: '成功', text: '店铺设置成功' });
        _this.id = _this.password = '';
      }).catch(function (err) {
        debugger;
        var msg = err.response && err.response.data ? err.response.data : err.message;
        _this.$notify({ group: 'msgpad', type: 'error', title: '系统错误', text: '登陆错误' });
      });
    },
    user_login: function user_login() {
      var self = this;
      self.$store.dispatch('act_worker_login', {
        shop_id: self.shop_info.shop_id,
        sec_key: self.shop_info.sec_key,
        worker_id: self.id,
        password: self.password
      }).then(function (user_info) {
        self.$store.commit('NAVBAR_USER_USER_INFO', user_info);
        self.$notify({ group: 'msgpad', type: 'success', title: '成功', text: '登陆成功' });
        self.id = self.password = '';
        (0, _auth.setToken)(user_info._id);
        self.$router.push('/');
      }).catch(function (err) {
        debugger;
        var msg = err.data ? err.data : '';
        msg = msg ? msg : err.response && err.response.data ? err.response.data : err.message;
        self.$notify({ group: 'msgpad', type: 'error', title: '系统错误', text: msg });
      });
    }
  }
};

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e56dc076_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Mb5B");
function injectStyle (ssrContext) {
  __webpack_require__("HpBf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e56dc076_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MFnL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.axios_get = axios_get;
exports.axios_post = axios_post;

var _mutationDefine = __webpack_require__("a2hP");

var types = _interopRequireWildcard(_mutationDefine);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _msgpad_show = __webpack_require__("2QB/");

var _msgpad_show2 = _interopRequireDefault(_msgpad_show);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function axios_get(url, _ref, _ref2, call_back) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        state = _ref.state;
    var mutation = _ref2.mutation,
        field = _ref2.field;

    _axios2.default.get(url).then(function (resp) {
        if (resp.status == 200) {
            commit(mutation, resp.data[field]);
        } else {
            (0, _msgpad_show2.default)("msgpad", "失败", resp.data.err_msg, 'error');
        }
        if (call_back) {
            call_back(null, resp);
        }
    }).catch(function (err) {
        (0, _msgpad_show2.default)("msgpad", "NETWORK_ERROR", err.message, 'error');
        if (call_back) call_back(err);
    });
} /* eslint-disable no-new */
function axios_post(url, data, _ref3, _ref4, call_back) {
    var commit = _ref3.commit,
        state = _ref3.state;
    var mutation = _ref4.mutation,
        field = _ref4.field;

    _axios2.default.post(url, data).then(function (resp) {
        debugger;
        if (resp.status == 200) {
            commit(mutation, resp.data[field]);
        } else {
            (0, _msgpad_show2.default)("msgpad", "失败", resp.data.err_msg, 'error');
        }
        if (call_back) {
            call_back(null, resp);
        }
    }).catch(function (err) {
        (0, _msgpad_show2.default)("msgpad", "NETWORK_ERROR", err.message, 'error');
        if (call_back) call_back(err);
    });
}

/***/ }),

/***/ "MUGa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mb5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:[{ 'customizer-in': _vm.customizerIn, 'box-layout': _vm.boxLayoutHandler, 'collapse-sidebar': _vm.collapseSidebarHandler, 'rtl-layout': _vm.rtlLayoutHandler}],attrs:{"dark":_vm.darkModeHandler,"id":"inspire"}},[_c('router-view'),_vm._v(" "),_c('notifications',{attrs:{"group":"msgpad","duration":3000,"width":300,"animation-name":"v-fade-left","position":"bottom left"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _vuetify = __webpack_require__("3EgV");

var _vuetify2 = _interopRequireDefault(_vuetify);

var _vueMultipleBackTop = __webpack_require__("XcbY");

var _vueMultipleBackTop2 = _interopRequireDefault(_vueMultipleBackTop);

var _vueNotification = __webpack_require__("CLX7");

var _vueNotification2 = _interopRequireDefault(_vueNotification);

var _vuejsLocalization = __webpack_require__("Fmni");

var _vuejsLocalization2 = _interopRequireDefault(_vuejsLocalization);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

__webpack_require__("e7uY");

__webpack_require__("kTXO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// permission control

// import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload, {
//   error: '/static/img/none.png',
//   loading: '/static/img/loading.gif',
//   try: 1 // default 1
// })

// jvector map
// import 'jvectormap'
// import 'jvectormap/tests/assets/jquery-jvectormap-world-mill-en'
// import 'jvectormap/jquery-jvectormap.css'

// import './assets/css/googlefonts.source.sans.pro.css'
// import './assets/css/material.icons.css'

// import 'font-awesome/css/font-awesome.min.css' // Ensure you are using css-loader


// include all css files

// import AmCharts from 'amcharts3'
// import AmSerial from 'amcharts3/amcharts/serial'
// import AmAngularGauge from 'amcharts3/amcharts/gauge'

// import * as VueGoogleMaps from 'vue2-google-maps'
// import { Vue2Dragula } from 'vue2-dragula'
// import VueQuillEditor from 'vue-quill-editor'
// import wysiwyg from 'vue-wysiwyg'
// import VueBreadcrumbs from 'vue2-breadcrumbs'
// import VueResource from 'vue-resource'
_vue2.default.use(_vuex2.default); // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

_vue2.default.use(_vuetify2.default, {
  iconfont: 'fa4'
});
// Vue.use(AmCharts)
// Vue.use(AmSerial)
// Vue.use(AmAngularGauge)
// Vue.use(Vue2Dragula)
// Vue.use(VueQuillEditor)
// Vue.use(VueResource)
// Vue.use(wysiwyg, {})
// Vue.use(VueBreadcrumbs)
_vue2.default.use(_vueNotification2.default);
_vue2.default.component(_vueMultipleBackTop2.default.name, _vueMultipleBackTop2.default);

_vuejsLocalization2.default.requireAll(__webpack_require__("apj+"));
_vue2.default.use(_vuejsLocalization2.default);

_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  template: '<App/>',
  components: { App: _App2.default, notification: _vueNotification2.default }
});

/***/ }),

/***/ "NSx4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NSzy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutationDefine = __webpack_require__("a2hP");

var types = _interopRequireWildcard(_mutationDefine);

var _axios_operator = __webpack_require__("MFnL");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-new */
var state = {
  // list:[],
  list: []
  /*
  {
      "_id": "52db532e7e0bac05ef28001a",
      "lastmodify": "2015-08-31T05:34:30.934Z",
      "gid": "5000378998232",
      "name": "奶粉-英国牛栏2段",
      "zhujima": "NF-YGNL2D",
      "in_price": 130,
      "sale_price": 218,
      "category": "55bf66e1bad8be11687eaab3",
      "brand": "55d2a575ed1da14a1639ecfc",
      "enable": true,
      "is_weight": false,
      "unit": "pc",
      "vip_price": {
        "vip": 208
      },
      "same": [],
      "tags": []
    }
  
  */
  // getters
};var getters = {
  get_prepare_list: function get_prepare_list(state) {
    return state.list;
  }

  // actions
  // const actions = {
  //   act_lookup_products_prepare (context,gid) {
  //     let url = "/front/api/vip_info?oper=lookup&moblile=" + mobile
  //   	axios_get(url,context,{mutation:types.VIP_SET_VIP_INFO,field:'vip'});
  //   }
  // }

  // mutations
};var mutations = (0, _defineProperty3.default)({}, types.PRODUCTS_PREPARE_LIST, function (state, list) {
  //debugger
  console.log("PRODUCTS_PREPARE_LIST", list);
  state.list = list ? list : [];
});

exports.default = {
  state: state,
  getters: getters,
  // actions,
  mutations: mutations
};

/***/ }),

/***/ "O/hE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _form_item = __webpack_require__("P2it");

var _form_item2 = _interopRequireDefault(_form_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    //template:``,
    name: '',
    props: {
        width: { type: String, default: "500px" }
    },
    computed: {
        show_dialog: {
            get: function get() {
                return this.$store.state.dialog.show_user_input_dialog;
            },
            set: function set(val) {
                this.$store.commit('SHOW_DIALOG_USER_INPUT', val);
            }
        },
        dlg_config: function dlg_config() {
            return this.$store.state.dialog.user_input_fields;
        }
    },
    methods: {
        close_dialog: function close_dialog() {
            this.doing = false;
            this.show_dialog = false;
        },
        set_errmsg: function set_errmsg(fd, err) {
            if (!err) return;
            var field = this.dlg_config.fields.find(function (it) {
                return it.name == fd;
            });
            if (field) {
                field.err_msg.splice(0, field.err_msg.length);
                field.err_msg.push(err);
            }
        },
        field_change: function field_change(value, fd) {
            console.log("field_change:", fd, value);
            console.log("value:", this.dlg_config);
            if (this.dlg_config.change) this.dlg_config.change(value, fd);
        },
        action: function action(type) {
            var data = {};
            this.dlg_config.fields.map(function (fd) {
                data[fd.name] = fd.value;
            });
            this.dlg_config.action && this.dlg_config.action({
                close: this.close_dialog,
                self: this,
                data: data,
                type: type ? type : 'cancel'
            });
        }
    },
    components: { myinput: _form_item2.default },
    watch: {},
    directives: {},
    mounted: function mounted() {},
    data: function data() {
        return {
            valid: false,
            doing: false,
            err_msg: []
        };
    },

    filters: {
        //pluralize: (n, w) => n === 1 ? w : (w + 's'),
        capitalize: function capitalize(s) {
            return s.charAt(0).toUpperCase() + s.slice(1);
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Otg5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base_api = __webpack_require__("+TLI");

var _select_options = __webpack_require__("KykW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    //template:``,
    name: '',
    props: {
        width: {
            type: String,
            default: '500px'
        }
    },
    computed: {
        show_dialog: {
            get: function get() {
                return this.$store.state.dialog.show_ship_out_dialog;
            },
            set: function set(val) {
                if (val == true) {
                    debugger;
                    if (this.support_oper.indexOf(this.show_dialog) >= 0) {
                        return;
                    }
                }
                this.$store.commit('SHOW_DIALOG_SHIP_OUT', val);
            }
        },
        prodcuts_list: function prodcuts_list() {
            return this.$store.state.products;
        },
        title: function title() {
            switch (this.show_dialog) {
                case 'ship_out':
                    return "出库";
                case 'request':
                    return "配货申请";
                case 'destroy':
                    return "报损";
                case 'recv':
                    return "收货";
                case 'pandian':
                    return "盘点";
                default:
                    return this.show_dialog;
            }
        }
    },
    methods: {
        init_value: function init_value() {
            this.creating = false;
            this.shop_id = "";
            this.note = '';
        },
        can_do_it: function can_do_it() {
            if (this.show_dialog == 'ship_out' && (!this.shop_id || !this.note)) return false;
            if (!this.note) return false;
            return true;
        },
        get_shop_list: function get_shop_list() {
            var _this = this;

            console.log("NEED GET SYSUSER LIST");
            (0, _select_options.selectoption)({ oper: 'shop', key: "_id", value: "cn_name", type: 'obj', skipp: 'shop_id' }).then(function (resp) {
                _this.shop_list = resp.data;
            }).catch(function (err) {
                console.log(err);
                debugger;
            });
        },
        post_data_gen: function post_data_gen() {
            debugger;
            var self = this;
            var oper = self.show_dialog;
            var schema = 'ship.php';
            var title = oper == 'request' ? "配货请求操作成功" : "出库成功！";
            var data = {
                order_id: self.prodcuts_list.order_id,
                note: self.note,
                to: self.shop_id,
                items: self.prodcuts_list.list.map(function (it) {
                    return {
                        gid: it.gid,
                        info: it.name,
                        num: it.num,
                        incount: 0
                    };
                })
            };

            if (oper == 'request') {
                data.node = data.note;
            }
            //gid,nm,count,isnew
            if (oper == 'recv' || oper == 'pandian') {
                schema = oper + ".php";
                oper = oper == 'recv' ? 'upload' : 'pandian';
                title = oper == 'upload' ? '收货成功!' : '盘点数据上传成功!';
                data.detail = self.prodcuts_list.list.map(function (it) {
                    return {
                        gid: it.gid,
                        nm: it.name,
                        count: it.num,
                        isnew: it.isnew ? true : false
                    };
                });
                delete data.items;
            }
            if (oper != 'ship_out') {
                delete data.shop_id;
            }
            return { oper: oper, schema: schema, data: data, title: title };
        },
        create_record: function create_record() {
            console.log("click");
            var self = this;
            if (self.prodcuts_list.list.length == 0) {
                return self.$notify({
                    group: 'msgpad',
                    type: 'warn',
                    title: '操作失败！',
                    text: '无待操作商品'
                });
            }

            if (self.support_oper.indexOf(self.show_dialog) < 0) return false;

            var _self$post_data_gen = self.post_data_gen(),
                oper = _self$post_data_gen.oper,
                schema = _self$post_data_gen.schema,
                data = _self$post_data_gen.data,
                title = _self$post_data_gen.title;

            debugger;

            // let oper = (self.show_dialog == 'recv'?'upload':self.show_dialog);
            // let oper_title = (oper == 'request')? "配货请求操作成功":"出库成功！";

            // if(self.show_dialog == 'recv') oper_title = "收货成功";

            self.creating = true;
            (0, _base_api.base_api)({ //"/recv.php?oper=upload";
                schema: schema,
                method: 'post',
                params: { oper: oper }, //self.show_dialog
                data: data
            }).then(function (doc) {
                self.$store.commit('PAYINFO_SETTING', { pay_status: 1, title: title });
                self.$notify({
                    group: 'msgpad',
                    type: 'success',
                    title: '操作成功！',
                    text: title,
                    duration: 500
                });
                self.show_dialog = false;
            }).catch(function (err) {
                self.$notify({
                    group: 'msgpad',
                    type: 'warn',
                    title: '操作失败！',
                    text: '记录创建失败' + err.response && err.response.data ? err.response.data : err.message
                });
            }).then(function (_) {
                self.creating = false;
            });
        }
    },
    components: {},
    watch: {
        show_dialog: function show_dialog(val) {
            if (val) {
                this.init_value();
                if (this.shop_list.length == 0) {
                    this.get_shop_list();
                }
            }
        }
    },
    directives: {},
    mounted: function mounted() {
        if (this.shop_list.length == 0) {
            this.get_shop_list();
        }
    },
    data: function data() {
        return {
            creating: false,
            shop_id: null,
            note: '',
            shop_list: [],
            support_oper: ['ship_out', 'request', 'destroy', 'recv', 'pandian']
        };
    },

    filters: {
        //pluralize: (n, w) => n === 1 ? w : (w + 's'),
        capitalize: function capitalize(s) {
            return s.charAt(0).toUpperCase() + s.slice(1);
        }
    }
};

/***/ }),

/***/ "P2it":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_item_vue__ = __webpack_require__("Tm5a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_item_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_item_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_item_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62677c99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_item_vue__ = __webpack_require__("smBi");
function injectStyle (ssrContext) {
  __webpack_require__("tl62")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_item_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62677c99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QCv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QKaY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _sale = __webpack_require__("fGws");

var sale_api = _interopRequireWildcard(_sale);

var _vuex = __webpack_require__("NYxO");

var _debounce = __webpack_require__("HhAh");

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        mutil_index: 'get_mutil_index',

        vip_info: 'vip_info',
        vip_saved: 'vip_saved',

        sum_info: 'get_products_sum_info',
        pay_info: 'get_pay_info',
        order_id: 'get_order_id',
        order_note: 'get_order_note',

        prodcuts_list: 'get_prodcuts_list',
        selected_num: 'get_selected_num',

        outsea_products: 'get_outsea_products',

        post_data: 'get_sale_post_data',

        prepay_money: 'get_use_prepay_money',
        amount_less: 'get_amount_less',

        have_this_gid: 'have_this_gid'

    }), {
        bill_money: function bill_money() {
            var money = this.sum_info.total_money - this.sum_info.use_prepay;
            if (parseInt(money) == money) return money;
            return 1 * money.toFixed(2);
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)({
        inc_mul_index: 'PRODUCTS_LIST_INC_MUL_INDEX',
        set_discount: 'PRODUCTS_DISCOUNT_SELECTED',
        act_tab: 'SHOW_DIALOG_ACTIVE_TAB'
    }), {
        lookup_vip_info: function lookup_vip_info(mobile, callback) {
            var self = this;
            self.$store.dispatch('act_lookup_vip', {
                mobile: mobile,
                callback: callback ? callback : function (data) {
                    var tab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tab-sale';

                    self.act_tab(tab);
                    if (data.vip) self.clear_input(); //founed
                }
            });
        },
        add_custom_item: function add_custom_item(gid, name, money) {
            var is_new = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

            var money = parseFloat(money);
            var obj = { oper: 'add', num: 1 };
            obj["gid"] = gid;
            obj["name"] = name;
            obj["is_weight"] = false;
            obj["discount"] = 100;
            obj['unit'] = 'pc';
            obj["in_price"] = obj["real_price"] = obj["sale_price"] = money;
            obj["all_num"] = obj["save_num"] = obj["less"] = 0;
            obj["vip_price"] = { 'vip': money };
            obj['save_take'] = 'sale';
            obj['is_new'] = is_new;
            this.edit_item(obj);
        },

        gid_input: (0, _debounce2.default)(function (e) {
            var gid = this.input_gid;
            if (gid && gid.length > 2) {
                this.lookup_product();
            } else if (!gid) {
                this.act_tab('tab-sale');
            }
        }, 350),
        lookup_products_bat: function lookup_products_bat(array) {
            var each_gid = function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    var _this = this;

                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret;

                    return _regenerator2.default.wrap(function _callee2$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _iteratorNormalCompletion = true;
                                    _didIteratorError = false;
                                    _iteratorError = undefined;
                                    _context3.prev = 3;
                                    _loop = /*#__PURE__*/_regenerator2.default.mark(function _loop() {
                                        var it, gid;
                                        return _regenerator2.default.wrap(function _loop$(_context2) {
                                            while (1) {
                                                switch (_context2.prev = _context2.next) {
                                                    case 0:
                                                        it = _step.value;
                                                        gid = it.trim();

                                                        if (!self.have_this_gid(gid)) {
                                                            _context2.next = 7;
                                                            break;
                                                        }

                                                        self.$store.commit('PRODUCTS_EDIT_ITEM', {
                                                            gid: gid,
                                                            oper: 'inc_num',
                                                            value: 1
                                                        });
                                                        return _context2.abrupt('return', 'continue');

                                                    case 7:
                                                        console.log("=============>", gid);
                                                        _context2.next = 10;
                                                        return self.$store.dispatch('act_lookup_products_by_gid', {
                                                            gid: gid,
                                                            prepare: false,
                                                            self: self,
                                                            callback: null,
                                                            raw: true
                                                        }).then(function () {
                                                            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(list) {
                                                                return _regenerator2.default.wrap(function _callee$(_context) {
                                                                    while (1) {
                                                                        switch (_context.prev = _context.next) {
                                                                            case 0:
                                                                                if (!list) list = [];
                                                                                if (list.data) list = list.data;

                                                                                if (!(list.length == 0)) {
                                                                                    _context.next = 7;
                                                                                    break;
                                                                                }

                                                                                _context.next = 5;
                                                                                return self.input_custom_product("请输入临时商品:" + gid).then(function (doc) {
                                                                                    self.add_custom_item(gid, doc.name, doc.money * 1);
                                                                                    self.act_tab('tab-sale');
                                                                                }).catch(function (err) {});

                                                                            case 5:
                                                                                _context.next = 8;
                                                                                break;

                                                                            case 7:
                                                                                if (list.length == 1) {
                                                                                    // console.log("RECV ONE:",list[0].name)
                                                                                    list[0].oper = 'add';
                                                                                    list[0].vip = self.$store.getters.vip_info.mobile;
                                                                                    self.$store.commit('PRODUCTS_EDIT_ITEM', list[0]);
                                                                                }

                                                                            case 8:
                                                                            case 'end':
                                                                                return _context.stop();
                                                                        }
                                                                    }
                                                                }, _callee, _this);
                                                            }));

                                                            return function (_x3) {
                                                                return _ref2.apply(this, arguments);
                                                            };
                                                        }());

                                                    case 10:
                                                    case 'end':
                                                        return _context2.stop();
                                                }
                                            }
                                        }, _loop, _this);
                                    });
                                    _iterator = (0, _getIterator3.default)(array);

                                case 6:
                                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                        _context3.next = 14;
                                        break;
                                    }

                                    return _context3.delegateYield(_loop(), 't0', 8);

                                case 8:
                                    _ret = _context3.t0;

                                    if (!(_ret === 'continue')) {
                                        _context3.next = 11;
                                        break;
                                    }

                                    return _context3.abrupt('continue', 11);

                                case 11:
                                    _iteratorNormalCompletion = true;
                                    _context3.next = 6;
                                    break;

                                case 14:
                                    _context3.next = 20;
                                    break;

                                case 16:
                                    _context3.prev = 16;
                                    _context3.t1 = _context3['catch'](3);
                                    _didIteratorError = true;
                                    _iteratorError = _context3.t1;

                                case 20:
                                    _context3.prev = 20;
                                    _context3.prev = 21;

                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }

                                case 23:
                                    _context3.prev = 23;

                                    if (!_didIteratorError) {
                                        _context3.next = 26;
                                        break;
                                    }

                                    throw _iteratorError;

                                case 26:
                                    return _context3.finish(23);

                                case 27:
                                    return _context3.finish(20);

                                case 28:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee2, this, [[3, 16, 20, 28], [21,, 23, 27]]);
                }));

                return function each_gid() {
                    return _ref.apply(this, arguments);
                };
            }();

            var self = this;

            each_gid();
        },
        lookup_product: function lookup_product(enter) {
            var self = this;
            var gid = self.input_gid.trim();

            var array = gid.split(/\s+/);
            if (array.length > 1) {
                self.clear_input();
                self.lookup_products_bat(array);
                console.log("LOOKUP BAT Count:", array.length);
            }

            if (self.pay_info.pay_status) return self.reset_state();

            if (/^[+-]([0-9]*\.?[0-9]+)$/.test(gid)) {
                if (!enter) return;
                var money = parseFloat(gid);
                var gid = "0000000000" + this.mutil_index;
                var name = "临时输入" + this.mutil_index;

                self.add_custom_item(gid, name, money, false);
                self.inc_mul_index(1);
                self.act_tab('tab-sale');
                self.clear_input();
                return;
            }
            if (!enter && /^1[345789]/.test(gid) && gid.length < 11) {
                return;
            }

            if (/^1[345789]\d{9}$/.test(gid)) {
                self.lookup_vip_info(gid);
            } else if (self.command_list(gid, enter)) {} else if (gid.length) {
                if (self.have_this_gid(gid)) {
                    self.clear_input();
                    return self.$store.commit('PRODUCTS_EDIT_ITEM', {
                        gid: gid,
                        oper: 'inc_num',
                        value: 1
                    });
                }
                self.$store.dispatch('act_lookup_products_by_gid', {
                    gid: gid,
                    prepare: !enter,
                    self: self,
                    callback: function callback(data) {
                        var tab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "tab-prepare";

                        self.act_tab(tab);
                        if (tab == 'tab-sale') self.clear_input();
                    }
                }).then(function (list) {
                    if (!list) list = [];
                    if (list.data) list = list.data;
                    if (list.length == 0 && enter) {
                        self.input_custom_product("请输入临时商品").then(function (doc) {
                            self.add_custom_item(gid, doc.name, doc.money * 1);
                            self.clear_input();
                            self.act_tab('tab-sale');
                        }).catch();
                    }
                });
            } else {
                console.log('KEY DOWN:', gid, gid.length);
                if (self.prodcuts_list.length) self.do_pay_money();
            }
        },

        vip_prepay_fake_order: function vip_prepay_fake_order(order_id, mobile, pay_info) {
            var note = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

            return {
                "order_id": order_id,
                "sum": {
                    "total_num": 1,
                    "total_money": pay_info.total_money,
                    "recv": pay_info.recv_money,
                    "pay_type": pay_info.pay_type,
                    "bank_id": pay_info.bank_id,
                    "where": pay_info.where,
                    "auth_code": pay_info.auth_code
                },
                "detail": [{
                    "gid": pay_info.total_money + '',
                    "nm": "会员充值-" + pay_info.total_money,
                    "num": 1,
                    "price": pay_info.total_money,
                    "realprice": pay_info.total_money,
                    "money": pay_info.total_money,
                    "less": pay_info.ext,
                    "save_num": 0,
                    "flag": "prepay",
                    "change_to": null
                }],
                "note": note || '',
                "vip": {
                    "vip_mobile": mobile,
                    "vip_discount": 100
                }
            };
        },
        sale_detail: function sale_detail(pay_info) {
            var my_info = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var sale_info = my_info ? my_info : this.post_data;
            // debugger total_money
            sale_info.sum.recv = parseFloat(pay_info.recv_money);
            sale_info.sum.ret = sale_info.sum.recv > pay_info.total_money ? sale_info.sum.recv - pay_info.total_money : 0;
            sale_info.sum.pay_type = pay_info.pay_type;
            sale_info.sum.bank_id = pay_info.bank_id;
            sale_info.sum.auth_code = pay_info.auth_code;

            sale_info.sum.where = pay_info.taobao ? 'taobao' : pay_info.pay_type == 'mall' ? "mall" : "store";
            /************sum part*************************************/
            return sale_info;
        },
        do_post_sale: function do_post_sale(post_obj) {
            var self = this;
            return sale_api.sale({ data: post_obj }).then(function (resp) {
                if (resp.status == 200) {
                    if (resp.data.order_id == self.order_id) self.$store.commit('PAYINFO_SETTING', {
                        pay_status: 1,
                        title: "",
                        pay_type: post_obj.sum.pay_type,
                        total_money: post_obj.sum.total_money,
                        use_prepay: post_obj.sum.use_prepay,
                        bank_id: post_obj.sum.bank_id,
                        recv: post_obj.sum.recv,
                        // ret         : post_obj.sum.pay_type == 'cash' ? (post_obj.sum.recv - post_obj.sum.total_money) : 0,
                        ret: post_obj.sum.pay_type == 'cash' ? post_obj.sum.recv - (post_obj.sum.total_money - post_obj.sum.use_prepay) : 0,
                        other: post_obj.sum.where
                    });
                    return resp.data;
                }
            }).catch(function (err) {
                var err_msg = "";
                if (err.response && err.response.data) {
                    err_msg = err.response.data;
                } else {
                    err_msg = err.message;
                }
                self.$notify({ group: "msgpad", title: "错误", text: err_msg, type: "error" });
            });
        },
        clear_vip: function clear_vip() {
            this.$store.commit('VIP_SET_VIP_INFO', {});
            this.$store.commit('PRODUCTS_RESET_VIP_PRICE', "");
            this.$store.commit('PRODUCTS_PREPARE_LIST', []);
            this.$store.commit('USE_PREPAY_MONEY', 0.0);
        },
        reset_state: function reset_state() {
            this.$store.commit('VIP_SET_VIP_INFO', {});
            this.$store.commit('PRODUCTS_LIST_CLEAN');
            this.$store.commit('PRODUCTS_PREPARE_LIST', []);
            this.$store.commit('USE_PREPAY_MONEY', 0.0);
            this.act_tab('tab-sale');
        },
        not_use_prepay_money: function not_use_prepay_money() {
            // this.$store.commit('VIP_PREPAY_MONEY', this.vip_info.prepay_money + this.prepay_money);
            this.make_to_int(false);
            this.$store.commit('VIP_PREPAY_MONEY_ADJUST', this.prepay_money);
            this.$store.commit('USE_PREPAY_MONEY', 0.0);
            return;
        },
        not_use_amount: function not_use_amount() {
            // this.$store.commit('VIP_PREPAY_MONEY', this.vip_info.prepay_money + this.prepay_money);
            if (this.amount_less) {
                this.make_to_int(false);
                this.$store.commit('VIP_AMOUNT_ADJUST', parseInt(this.amount_less * 200));
                this.$store.commit('PRODUCTS_EDIT_ITEM', { oper: 'vip_use_amount', gid: '', value: 0 });
            }
        },
        make_to_int: function make_to_int(oper) {
            var flag = oper == undefined ? this.sum_info.less_to_int > 0 ? false : true : oper;
            // debugger
            this.$store.commit('PRODUCTS_EDIT_ITEM', { oper: 'make_to_int', gid: '', value: flag });
        },
        use_prepay_money: function use_prepay_money() {
            if (this.pay_info.pay_status > 0) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算！', 'error');
                return;
            };
            if (this.prepay_money > 0.01) {
                this.not_use_prepay_money();
                return;
            }
            if (this.vip_info.prepay_money) {
                this.make_to_int(false);
                var total_money = this.sum_info.total_money;

                if (this.vip_info.prepay_money > total_money) {
                    this.$store.commit('USE_PREPAY_MONEY', total_money);
                } else {
                    this.$store.commit('USE_PREPAY_MONEY', this.vip_info.prepay_money);
                }
                this.$store.commit('VIP_PREPAY_MONEY', this.vip_info.prepay_money - this.prepay_money);
            }
        },
        use_amount: function use_amount() {
            // debugger
            if (this.pay_info.pay_status > 0) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算！', 'error');
                return;
            };
            if (this.amount_less > 0.01) {
                this.not_use_amount();
                return;
            }
            if (this.vip_info.user_amount) {
                this.make_to_int(false);
                var total_money = this.sum_info.total_money;
                if (this.prepay_money) {
                    total_money -= this.prepay_money;
                }
                if (total_money == 0) return;
                var as_money = this.vip_info.user_amount / 200;
                var less_money = as_money > total_money ? total_money : as_money;

                this.$store.commit('PRODUCTS_EDIT_ITEM', { oper: 'vip_use_amount', gid: '', value: less_money });
                this.$store.commit('VIP_AMOUNT_ADJUST', parseInt(less_money * 200 * -1));
            }
        },
        check_weixin_alipy_state: function check_weixin_alipy_state(order_id, type) {
            sale_api.check_pay_state_3part({
                order_id: order_id,
                type: type
            }).then(function (obj) {
                // if(obj.trade_status =="TRADE_SUCCESS" || obj.trade_state =="SUCCESS" ){
                // }else{

                // }
            });
        },
        show_dialog: function show_dialog(type) {
            var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            this.$store.commit(type, val);
        },
        msgpad_show: function msgpad_show(group, title, text, type) {
            this.$notify({ group: group, title: title, text: text, type: type });
        },
        ready_for_sale: function ready_for_sale() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var text = '';
            if (this.prodcuts_list.length == 0) text = '无待操作商品 ';
            if (this.pay_info.pay_status != 0) text = '本单已经结算！';

            if (type != '') return true;

            if ((0, _keys2.default)(this.outsea_products).length > 0) {
                if (!this.vip_info.mobile) {
                    text = "跨境商品需要会员信息！";
                } else if (this.vip_info.spec_info.userid && this.vip_info.spec_info.valid) {
                    return true;
                } else {
                    this.show_dialog('SHOW_DIALOG_EDITVIP', 'valid');
                    text = '需要验证会员身份证！';
                }
            }
            if (text) {
                this.$notify({
                    group: 'msgpad',
                    type: 'error',
                    title: '操作失败！',
                    text: text
                });
                return false;
            }
            return true;
        },
        input_custom_product: function input_custom_product(title) {
            var _this2 = this;

            return new _promise2.default(function (resove, reject) {
                var dlg_conf = {
                    title: title,
                    fields: [{
                        title: '商品名称',
                        placeholder: '商品名称',
                        type: "string",
                        value: '',
                        name: 'name',
                        err_msg: [],
                        rules: [function (v) {
                            return !!v || "商品名称是必须的";
                        }]
                    }, {
                        title: '零售价',
                        placeholder: '零售价',
                        type: "number",
                        value: 0,
                        name: 'money',
                        rules: [function (v) {
                            return 1 * v == 0 || /[0-9]*\.?[0-9]+$/.test(v) || "金额格式不正确";
                        }],
                        err_msg: []
                    }],
                    action: function action(_ref3) {
                        var close = _ref3.close,
                            self = _ref3.self,
                            type = _ref3.type,
                            data = _ref3.data;

                        if (type == 'cancel') return reject('cancel');
                        var ok = self.$refs.form.validate();
                        if (!ok) return reject(false);
                        self.close_dialog();
                        return resove(data);
                    }
                };
                _this2.$store.commit('USER_INPUT_FIELDS', dlg_conf);
            });
        }
    })
};

/***/ }),

/***/ "R5Pn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _product_item_list = __webpack_require__("wPxS");

var _product_item_list2 = _interopRequireDefault(_product_item_list);

var _product_item_table = __webpack_require__("zmSt");

var _product_item_table2 = _interopRequireDefault(_product_item_table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//

/* eslint-disable */
exports.default = {
  //template:``,
  name: '',
  props: {
    name: { type: String, default: 'tab-sale' }
  },
  computed: {},
  methods: {},
  components: { ItemList: _product_item_list2.default, ItemTable: _product_item_table2.default },
  watch: {},
  directives: {},
  mounted: function mounted() {},
  data: function data() {
    return {
      sheet: false,
      show_style: "ItemTable",
      tiles: [{ img: 'keep.png', title: 'Keep' }, { img: 'inbox.png', title: 'Inbox' }, { img: 'hangouts.png', title: 'Hangouts' }, { img: 'messenger.png', title: 'Messenger' }, { img: 'google.png', title: 'Google+' }]
    };
  },

  filters: {
    //pluralize: (n, w) => n === 1 ? w : (w + 's'),
    capitalize: function capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }
  }
};

/***/ }),

/***/ "ST9y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
		methods: {
				prompt_dlg: function prompt_dlg(title, fd_title, fd_nm, test) {
						var _this = this;

						return new _promise2.default(function (resove, reject) {
								var dlg_conf = {
										title: title,
										fields: [{
												title: fd_title,
												placeholder: fd_title,
												type: "string",
												value: '',
												name: fd_nm,
												err_msg: []
										}],
										action: function action(_ref) {
												var close = _ref.close,
												    self = _ref.self,
												    type = _ref.type;

												if (type == 'cancel') return reject('cancel');
												// debugger
												// self.doing = true;
												var value = dlg_conf.fields[0].value.trim();
												if (!test) return resove(value);

												if (test(value, self)) {
														resove(value);
														self.close_dialog();
												}
												// if (typeof(rang) == "undefined" || (rang && 1 * value >= rang[0] && 1 * value <= rang[1])){
												//     resove(value);
												//     self.close_dialog();
												// }else{
												// 	self.set_errmsg("输入范围不正确")
												// 	reject('input error')；
												// }
												else {
																reject('input error');
														}
										}
								};
								_this.$store.commit('USER_INPUT_FIELDS', dlg_conf);
						});
				}
		}
};

/***/ }),

/***/ "SxnS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var aCity = {
    11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古",
    21: "辽宁", 22: "吉林", 23: "黑龙江",
    31: "上海", 32: "江苏", 33: "浙江", 34: "安徽 ", 35: "福建 ", 36: "江西 ", 37: " 山东 ",
    41: " 河南 ", 42: " 湖北 ", 43: " 湖南 ", 44: " 广东 ", 45: " 广西 ", 46: " 海南 ",
    50: " 重庆 ", 51: " 四川 ", 52: " 贵州 ", 53: "云南", 54: "西藏",
    61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆",
    71: "台湾", 81: "香港", 82: "澳门", 91: "国外"
};

function cidInfo(sId) {
    var iSum = 0;
    var info = "";
    var sBirthday = "";
    if (!/^\d{17}(\d|x)$/i.test(sId)) return false;
    sId = sId.replace(/x$/i, "a");
    if (aCity[parseInt(sId.substr(0, 2))] == null) return false;
    sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
    var d = new Date(sBirthday.replace(/-/g, "/"));
    if (sBirthday != d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()) return false;
    for (var i = 17; i >= 0; i--) {
        iSum += Math.pow(2, i) % 11 * parseInt(sId.charAt(17 - i), 11);
    }if (iSum % 11 != 1) return false;
    return true;
}
exports.default = cidInfo;

/***/ }),

/***/ "Tm5a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*listReport, groupOperation, deleteItem, addItem, importExcle,updateItem, downloadFile, httpCommand, autoComplete*/
// import {refSelectoption,autoComplete} from '@/api/report'
exports.default = {
    name: 'myInput',
    components: {},
    model: {
        prop: 'value',
        event: 'change'

    },
    props: {
        value: [String, Number, Object, Boolean, Array],
        field: Object,
        rules: Array,
        err_msg: { type: Array, default: function _default() {
                return [];
            }
            // size        :String,
            // placeholder :String,
            // width       :{type :String,default:'100%'},
            // quickadd    :{type :Boolean,default:true},
            // ref_cache   :{type : Object,default:function(){return {}}},        
        } },
    data: function data() {
        return {
            // cache     : [],
            // ref_lable : 'name',
            // ref_value : '_id' ,
            // ref_key   : '_id',
            /*******************/
            curr_value: Array.isArray(this.value) ? this.value : (0, _typeof3.default)(this.value) == 'object' && this.value != null ? this.value._id : this.value
        };
    },

    watch: {
        value: function value(val) {
            this.curr_value = val;
            console.log("binding change:", val);
        },
        curr_value: function curr_value(value) {
            console.log("curr_value changed!", value);
            // let val= {value,fd:this.field.name};
            this.$emit('change', value);
            if (this.field.type == 'checkboxs') {
                this.$emit('checkboxs', value);
            }
        }
    },
    methods: {
        /*
        fetch_suggestions(obj, lookfor, cb){
            // debugger
            if(!lookfor){
                cb([])
            }else{
                Api.table_field_autocomplete(obj, lookfor).then(res => {
                    this.autoTpl = res.data.template;
                    cb(res.data.data);
                })
            }
        },
        handleSelect(item){
            console.log("SELECT:",item);
            this.$emit('suggestion',item);
        },
        quickAddRef(ref, title){
            if(this.quickadd)
                this.$emit('quick_add_ref_table',ref,title);
        }
        */
        // ,
        // checkbox_notify(new_val){
        //    console.log("curry value:",this.curr_value,new_val)
        //    this.$emit('checkboxs',this.curr_value,new_val); 
        // }
    },
    created: function created() {}
};

/***/ }),

/***/ "TzVh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UNiv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab-item',{attrs:{"id":_vm.name}},[_c('v-flex',{attrs:{"xl12":"","lg12":"","md12":"","xs12":""}},[_c('div',{staticClass:"app-card mb-0"},[_c('div',{staticClass:"app-card-title"},[_c('h3',[_vm._v("Recent Sale")]),_vm._v(" "),_c('div',{staticClass:"app-contextual-link"},[_c('v-menu',{attrs:{"origin":"center center","transition":"scale-transition","bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("ti-more-alt")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("ti-settings")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Settings")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("ti-more-alt")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("View More")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("ti-bell")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Disable notifications")])],1)],1)],1)],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VGcv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('v-menu',{attrs:{"close-on-content-click":true,"nudge-width":100,"max-width":"220px","offset-x":""},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('div',{attrs:{"slot":"activator"},slot:"activator"},[_c('span',{staticClass:"p_money",attrs:{"flat":""}},[_vm._v(_vm._s(_vm.money))]),_vm._v(" "),(_vm.item.save_num > 0)?_c('v-badge',{attrs:{"color":"pink"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.item.save_num))]),_vm._v(" "),_c('v-icon',{staticClass:"iconfont",attrs:{"color":"red"}},[_vm._v("icon-save1")])],1):_vm._e(),_vm._v(" "),(_vm.item.less>0)?_c('del',{staticClass:"p_less"},[_vm._v(" "+_vm._s(_vm.item.less.toFixed(2)))]):_vm._e()],1),_vm._v(" "),_c('v-card',[_c('v-layout',{attrs:{"row":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"small":"","color":"success"},nativeOn:{"click":function($event){_vm.my_prompt_input('count')}}},[_vm._v("数量")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"info"},nativeOn:{"click":function($event){_vm.my_prompt_input('price')}}},[_vm._v("自定价")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs4":"","d-flex":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"warning"},nativeOn:{"click":function($event){_vm.my_prompt_input('discount')}}},[_vm._v("折扣")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","d-flex":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"light-blue lighten-4"},on:{"click":function($event){_vm.set_discount(100)}}},[_vm._v("无折")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","d-flex":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"light-green lighten-3"},on:{"click":function($event){_vm.use_vip_price()}}},[_vm._v("会员")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"info"},nativeOn:{"click":function($event){_vm.free_it()}}},[_vm._v("赠送")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"success"},nativeOn:{"click":function($event){_vm.my_prompt_input('less')}}},[_vm._v("减免")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"purple lighten-4"},nativeOn:{"click":function($event){_vm.set_to_int()}}},[_vm._v("抹零")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"light-green lighten-3"},on:{"click":function($event){_vm.set_discount(90)}}},[_vm._v("90")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"light-blue lighten-3"},on:{"click":function($event){_vm.set_discount(88)}}},[_vm._v("88")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"warning"},on:{"click":function($event){_vm.set_discount(85)}}},[_vm._v("85")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"success"},on:{"click":function($event){_vm.set_discount(80)}}},[_vm._v("80")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"lime lighten-3"},on:{"click":function($event){_vm.set_discount(75)}}},[_vm._v("75")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"warning"},on:{"click":function($event){_vm.set_discount(70)}}},[_vm._v("70")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"info"},on:{"click":function($event){_vm.set_discount(61)}}},[_vm._v("61")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"primary"},on:{"click":function($event){_vm.set_discount(50)}}},[_vm._v("半")])],1)],1),_vm._v(" "),_c('div',[_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"warning"}},[_vm._v("库存")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"orange lighten-1"},nativeOn:{"click":function($event){_vm.return_it()}}},[_vm._v("退货")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"error"},on:{"click":function($event){_vm.delete_it()}}},[_vm._v("删除")])],1)],1)],1),_vm._v(" "),(_vm.vip.mobile)?_c('div',[_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"success"},on:{"click":function($event){_vm.set_to_ems()}}},[_vm._v("直邮")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.vip.mobile)?_c('div',[_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{attrs:{"dark":"","small":"","color":"warning"},on:{"click":function($event){$event.stopPropagation();_vm.inc_save(-1)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("ti-minus")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('span',{staticClass:"save_count"},[_c('small',[_vm._v("存")]),_vm._v(_vm._s(_vm.item.save_num))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-btn',{attrs:{"dark":"","small":"","color":"success"},on:{"click":function($event){$event.stopPropagation();_vm.inc_save(1)}}},[_c('v-icon',{staticClass:"iconfont",attrs:{"dark":""}},[_vm._v("icon-plus")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"depressed":"","small":"","color":"pink"},on:{"click":function($event){_vm.print_lable(_vm.item)}}},[_vm._v("打印标签")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WP+5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.width},model:{value:(_vm.show_dialog),callback:function ($$v) {_vm.show_dialog=$$v},expression:"show_dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline info lighten-2",attrs:{"primary-title":""}},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('v-card-text',[_c('v-form',[(_vm.show_dialog == 'ship_out')?_c('v-select',{attrs:{"items":_vm.shop_list,"error":!_vm.shop_id,"label":"请选择目标店铺","item-value":"_id","item-text":"cn_name","required":"","clearable":""},model:{value:(_vm.shop_id),callback:function ($$v) {_vm.shop_id=$$v},expression:"shop_id"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"备注","error":!_vm.note,"required":""},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"btn-",on:{"click":function($event){$event.stopPropagation();_vm.show_dialog=false}}},[_vm._v("取消")]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.creating,"disabled":_vm.creating||!_vm.can_do_it(),"color":"info"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.create_record($event)}}},[_vm._v("\n\t      确定\n\t      "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_vm._v("\n\t        Loading...\n\t      ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y/fU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Full = __webpack_require__("reqk");

var _Full2 = _interopRequireDefault(_Full);

var _sale = __webpack_require__("iMxt");

var _sale2 = _interopRequireDefault(_sale);

var _Login = __webpack_require__("gFLI");

var _Login2 = _interopRequireDefault(_Login);

var _LockScreen = __webpack_require__("ky9E");

var _LockScreen2 = _interopRequireDefault(_LockScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// layout components
var async_import = function async_import(file) {
  return function () {
    return __webpack_require__("jQWn")("./" + file + '.vue');
  };
};

// dashboard components

// import sale_orders from '@/views/admin/pages/sale_orders'
// import shop_stock from '@/views/admin/pages/shop_stock'
// import shop_cash_mng from '@/views/admin/pages/shop_cash_mng'
// import shop_new_vip from '@/views/admin/pages/shop_new_vip'
// import shop_user_saved from '@/views/admin/pages/shop_user_saved'
// import shop_user_prepay from '@/views/admin/pages/shop_user_prepay'
// import shop_ship_order from '@/views/admin/pages/shop_ship_order'
// import shop_recv_order from '@/views/admin/pages/shop_recv_order'
// import shop_pandian_order from '@/views/admin/pages/shop_pandian_order'
// import shop_destroy_order from '@/views/admin/pages/shop_destroy_order'
// import shop_request_order from '@/views/admin/pages/shop_request_order'

/*
import DashboardOne from '@/views/dashboard/DashboardOne'
import DashboardTwo from '@/views/dashboard/DashboardTwo'

// Inbox component
import Inbox from '@/views/inbox/Inbox'

// calendar components
import Calendar from '@/views/calendar/Calendar'

// ui components
import Buttons from '@/views/ui-elements/Buttons'
import Cards from '@/views/ui-elements/Cards'
import Grid from '@/views/ui-elements/Grid'
import List from '@/views/ui-elements/List'
import Menu from '@/views/ui-elements/Menu'
import Slider from '@/views/ui-elements/Slider'
import Snackbar from '@/views/ui-elements/Snackbar'
import Tooltip from '@/views/ui-elements/Tooltip'
import Dialog from '@/views/ui-elements/Dialog'
import Select from '@/views/ui-elements/Select'
import Input from '@/views/ui-elements/Input'
import Checkbox from '@/views/ui-elements/Checkbox'
import Radio from '@/views/ui-elements/Radio'
import Toolbar from '@/views/ui-elements/Toolbar'
import Progress from '@/views/ui-elements/Progress'
import Tabs from '@/views/ui-elements/Tabs'
import Carousel from '@/views/ui-elements/Carousel'
import Chips from '@/views/ui-elements/Chips'
import Datepicker from '@/views/ui-elements/Datepicker'
import Timepicker from '@/views/ui-elements/Timepicker'

// chart components
import VueChartjs from '@/views/charts/VueChartjs'
import VueEcharts from '@/views/charts/VueEcharts'

// maps views
import GoogleMaps from '@/views/maps/GoogleMaps'
import LeafletMaps from '@/views/maps/LeafletMaps'
import JvectorMap from '@/views/maps/JvectorMap'

// Pages views
import Blank from '@/views/pages/Blank'
import Gallery from '@/views/pages/Gallery'
import Pricing from '@/views/pages/Pricing'

// users views
import UserProfile from '@/views/users/UserProfile'
import UsersList from '@/views/users/UsersList'

// drag-drop components
import Vue2Dragula from '@/views/drag-drop/Vue2Dragula'
import VueDraggable from '@/views/drag-drop/Vuedraggable'
import VueDraggableResizeable from '@/views/drag-drop/VueDraggableResizable'

// icons components
import Themify from '@/views/icons/Themify'
import Material from '@/views/icons/Material'

// editor components
import QuillEditor from '@/views/editor/QuillEditor'
import WYSIWYG from '@/views/editor/WYSIWYG'

// form componenets
import FormValidation from '@/views/forms/FormValidation'
import Stepper from '@/views/forms/Stepper'

// session components
import SignUp from '@/views/session/SignUp'


// Data table componenets
import Standard from '@/views/tables/Standard'
import Slots from '@/views/tables/Slots'
import SelectableRows from '@/views/tables/SelectableRows'
import SearchWithText from '@/views/tables/SearchWithText'
*/
_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: '/',
    component: _Full2.default,
    // redirect : 'noredirect',
    children: [{
      path: '/',
      component: _sale2.default,
      meta: {
        title: 'Sale',
        breadcrumb: 'Dashboard / Dashboard V1'
      }
    }, {
      path: '/admin/pages/sale_orders',
      component: async_import('sale_orders'),
      meta: {
        title: 'sale_orders',
        breadcrumb: '销售 / 销售详单'
      }

    }, {
      path: '/admin/pages/miaosha_order',
      component: async_import('miaosha_order'),
      meta: {
        title: 'miaosha_order',
        breadcrumb: '秒杀订单'
      }

    }]
  }, {
    path: '/login',
    component: _Login2.default,
    meta: {
      title: 'Login',
      breadcrumb: 'Session / Login'
    }
  }, {
    path: '/lock-screen',
    component: _LockScreen2.default,
    meta: {
      title: 'Lock Screen',
      breadcrumb: 'Session / Lock Screen'
    }
  }]
});

/***/ }),

/***/ "Zbde":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab-item',{attrs:{"id":_vm.name}},[(!_vm.vip_info.mobile)?_c('v-layout',{staticClass:"pa-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","xl12":"","lg12":""}},[_c('v-layout',{staticClass:"pa-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs9":""}},[_c('v-text-field',{attrs:{"label":"商品过滤","clearable":""},model:{value:(_vm.gid),callback:function ($$v) {_vm.gid=$$v},expression:"gid"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){_vm.lookup_home_stock()}}},[_c('v-icon',{staticClass:"iconfont",attrs:{"dark":""}},[_vm._v("icon-search")]),_vm._v(" "),_c('span',[_vm._v(" 查询仓库库存 ")])],1),_vm._v(" "),(_vm.total_pages>1)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.next_page()}}},[_c('v-icon',{staticClass:"iconfont",attrs:{"dark":""}},[_vm._v("ti-angle-right")]),_vm._v(" "),_c('span',[_vm._v("下一页("+_vm._s(_vm.curr_page)+"/"+_vm._s(_vm.total_pages)+")")])],1):_vm._e()],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xl12":"","lg12":"","md12":"","xs12":""}},[_c('div',{staticClass:"app-card mb-0"},[_c('div',{staticClass:"app-card-content"},[_c('ul',{staticClass:"ace-thumbnails clearfix"},_vm._l((_vm.list_array),function(item){return _c('li',{on:{"click":function($event){_vm.sale_it(item)}}},[_c('a',{staticClass:"cboxElement",attrs:{"href":"#"}},[_c('img',{attrs:{"src":_vm.img_url(item)},on:{"error":function($event){_vm.default_img(item)}}}),_vm._v(" "),_c('div',{staticClass:"text"},[(item.nm)?_c('div',{staticClass:"inner",domProps:{"textContent":_vm._s(item.nm)}}):_vm._e(),_vm._v(" "),(item.name)?_c('div',{staticClass:"inner",domProps:{"textContent":_vm._s(item.name)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tags"},[_c('span',{staticClass:"label-holder"},[(item.save_num)?_c('span',{staticClass:"label label-danger red--text",staticStyle:{"font-size":"25px"}},[_vm._v("存:"+_vm._s(item.save_num))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"label-holder"},[(item.count)?_c('span',{staticClass:"label label-purple",domProps:{"textContent":_vm._s(item.count)}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"label-holder"},[(item.nm)?_c('span',{staticClass:"label label-name black--text",domProps:{"textContent":_vm._s(item.nm)}}):_vm._e(),_vm._v(" "),(item.name)?_c('span',{staticClass:"label label-name black--text",domProps:{"textContent":_vm._s(item.name)}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"label-holder"},[_c('span',{staticClass:"label label-name black--text",domProps:{"textContent":_vm._s(item.gid)}})])])])}))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zdt6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _base_api = __webpack_require__("+TLI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { mapGetters,mapMutations } from 'vuex'

exports.default = {
    //template:``,
    name: '',
    props: {
        width: {
            type: String,
            default: '500px'
        }
    },

    computed: {
        prodcuts_list: function prodcuts_list() {
            return this.$store.state.products;
        },

        show_dialog: {
            get: function get() {
                return this.$store.state.dialog.show_destroy_dialog;
            },
            set: function set(val) {
                this.$store.commit('SHOW_DIALOG_DESTROY', val); //destroy
            }
        }
    },
    methods: {
        init_value: function init_value() {
            this.creating = false;
            this.node = '';
            this.why = 'else';
        },
        create_record: function create_record() {
            console.log("click");
            var self = this;
            if (self.prodcuts_list.list.length == 0) {
                return self.$notify({
                    group: 'msgpad',
                    type: 'warn',
                    title: '操作失败！',
                    text: '无待操作商品'
                });
            }
            self.creating = true;
            (0, _base_api.base_api)({
                schema: 'ship.php',
                method: 'post',
                params: { oper: 'destroy' }, //self.show_dialog
                data: {
                    order_id: self.prodcuts_list.order_id,
                    node: self.node,
                    why: self.why,
                    items: self.prodcuts_list.list.map(function (it) {
                        return {
                            gid: it.gid,
                            info: it.name,
                            num: it.num,
                            incount: 0
                        };
                    })
                }
            }).then(function (doc) {
                self.$store.commit('PAYINFO_SETTING', { pay_status: 1, 'title': "报损成功" });
                self.$notify({
                    group: 'msgpad',
                    type: 'success',
                    title: '操作成功！',
                    text: '报损成功',
                    duration: 500
                });
                self.show_dialog = false;
            }).catch(function (err) {
                self.$notify({
                    group: 'msgpad',
                    type: 'warn',
                    title: '操作失败！',
                    text:  true ? err.response.data : err.message
                });
            }).then(function (_) {
                self.creating = false;
            });
        }
    },
    components: {},
    watch: {
        show_dialog: function show_dialog(val) {
            if (val) {
                this.init_value();
            }
        }
    },
    directives: {},
    mounted: function mounted() {},
    data: function data() {
        return (0, _defineProperty3.default)({
            creating: false,
            node: '',
            why: null
        }, 'node', "");
    },

    filters: {
        //pluralize: (n, w) => n === 1 ? w : (w + 's'),
        capitalize: function capitalize(s) {
            return s.charAt(0).toUpperCase() + s.slice(1);
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Zm6K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _msgpad_show = __webpack_require__("2QB/");

var _msgpad_show2 = _interopRequireDefault(_msgpad_show);

var _mix_sale_item = __webpack_require__("t4X9");

var _mix_sale_item2 = _interopRequireDefault(_mix_sale_item);

var _mix_prompt_dlg = __webpack_require__("ST9y");

var _mix_prompt_dlg2 = _interopRequireDefault(_mix_prompt_dlg);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var valid_check_info = {
    "less": {
        title: "请输入减免金额",
        remind: "减免金额不能大于商品售价",
        regexp: /^([0-9]*\.?[0-9]+)$/
    },
    "price": {
        title: "请输入自定义金额",
        remind: "只能输入0-9及小数点",
        regexp: /^([0-9]*\.?[0-9]+)$/
    },
    "discount": {
        title: "请输入折扣值0-100",
        remind: "只能输入0-100",
        regexp: /^[0-9]*$/,
        rang: [0, 100]
    },
    "count": {
        title: "请输入商品数量",
        remind: "数量不能为负数，仅能为数字",
        regexp: /^[0-9]*$/,
        rang: [0, 1000]
    },
    "weight": {
        title: "请输入商品重量",
        remind: "只能输入0-9及小数点",
        regexp: /^([0-9]*\.?[0-9]+)$/
    }
};

exports.default = {
    //template:``,
    name: '',
    mixins: [_mix_sale_item2.default, _mix_prompt_dlg2.default],
    props: {
        item: Object,
        // isfinished:Number,
        action: Function
    },
    computed: {},
    methods: {
        my_prompt_input: function my_prompt_input(cmd) {
            var _this = this;

            debugger;
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            if (valid_check_info[cmd]) {
                var cmd_oper = valid_check_info[cmd];
                var rang = cmd_oper.rang;
                this.prompt_dlg(cmd_oper.title, cmd_oper.title, cmd, function (value, self) {
                    if (cmd_oper.regexp.test(value)) {
                        if (!rang) return true;
                        if (rang && 1 * value >= rang[0] && 1 * value <= rang[1]) {
                            return true;
                        }
                        // debugger
                        return false;
                    }
                    return false;
                }).then(function (value) {
                    console.log("input :", value);
                    value *= 1;
                    if (cmd == 'count') return _this.set_number(value);
                    if (cmd == 'less') return _this.less_money(value);
                    if (cmd == 'price') return _this.set_real_price(value);
                    if (cmd == 'discount') return _this.set_discount(value);
                    if (cmd == 'weight') return _this.set_number(value);
                }).catch(function (err) {
                    console.log('reject:', err);
                });
            }
        },
        print_lable: function print_lable(item) {
            _axios2.default.post("http://localhost:3000/print/lable", item).then(function (doc) {
                debugger;
            }).catch(function (err) {});
        }
    },
    components: {},
    watch: {},
    directives: {},
    mounted: function mounted() {},
    data: function data() {
        return {
            menu: false
        };
    },

    filters: {
        //pluralize: (n, w) => n === 1 ? w : (w + 's'),
        capitalize: function capitalize(s) {
            return s.charAt(0).toUpperCase() + s.slice(1);
        }
    }
};

/***/ }),

/***/ "a2hP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-new */
var NAVBAR_USER_USER_INFO = exports.NAVBAR_USER_USER_INFO = 'NAVBAR_USER_USER_INFO';
var NAVBAR_USER_TODO_TASK = exports.NAVBAR_USER_TODO_TASK = 'NAVBAR_USER_TODO_TASK';
var NAVBAR_USER_MESSAGE = exports.NAVBAR_USER_MESSAGE = 'NAVBAR_USER_MESSAGE';
var NAVBAR_USER_NOTIFY = exports.NAVBAR_USER_NOTIFY = 'NAVBAR_USER_NOTIFY';

var VIP_SET_VIP_INFO = exports.VIP_SET_VIP_INFO = 'VIP_SET_VIP_INFO';
var VIP_SET_VIP_SAVED = exports.VIP_SET_VIP_SAVED = 'VIP_SET_VIP_SAVED';

var VIP_LOOKUP_VIP = exports.VIP_LOOKUP_VIP = 'VIP_LOOKUP_VIP';
var VIP_EDIT_VIP = exports.VIP_EDIT_VIP = 'VIP_EDIT_VIP';
var VIP_CREAT_VIP = exports.VIP_CREAT_VIP = 'VIP_CREAT_VIP';
var VIP_PREPAY_MONEY = exports.VIP_PREPAY_MONEY = 'VIP_PREPAY_MONEY';
var VIP_PREPAY_MONEY_ADJUST = exports.VIP_PREPAY_MONEY_ADJUST = 'VIP_PREPAY_MONEY_ADJUST';
var VIP_AMOUNT_ADJUST = exports.VIP_AMOUNT_ADJUST = 'VIP_AMOUNT_ADJUST';
var USE_AMOUNT_SET = exports.USE_AMOUNT_SET = 'USE_AMOUNT_LESS';

var PAYINFO_SETTING = exports.PAYINFO_SETTING = 'PAYINFO_SETTING';
//export const ACTIVE_SALE_TAB_SHEET = 'ACTIVE_SALE_TAB_SHEET'

var MSG_PAD_SHOW_MESSAGE = exports.MSG_PAD_SHOW_MESSAGE = 'MSG_PAD_SHOW_MESSAGE';
var MSG_PAD_HIDE = exports.MSG_PAD_HIDE = 'MSG_PAD_HIDE';

var PRODUCTS_SELECT_ALL = exports.PRODUCTS_SELECT_ALL = 'PRODUCTS_SELECT_ALL';
var PRODUCTS_RESPONS_LIST = exports.PRODUCTS_RESPONS_LIST = 'PRODUCTS_RESPONS_LIST';
var PRODUCTS_LIST_INC_MUL_INDEX = exports.PRODUCTS_LIST_INC_MUL_INDEX = 'PRODUCTS_LIST_INC_MUL_INDEX';
var PRODUCTS_LIST_CLEAN = exports.PRODUCTS_LIST_CLEAN = 'PRODUCTS_LIST_CLEAN';
var PRODUCTS_DISCOUNT_SELECTED = exports.PRODUCTS_DISCOUNT_SELECTED = 'PRODUCTS_DISCOUNT_SELECTED';

var PRODUCTS_PREPARE_LIST = exports.PRODUCTS_PREPARE_LIST = 'PRODUCTS_PREPARE_LIST';
var PRODUCTS_PREPARE_CLEAN = exports.PRODUCTS_PREPARE_CLEAN = 'PRODUCTS_PREPARE_CLEAN';

var USE_PREPAY_MONEY = exports.USE_PREPAY_MONEY = 'USE_PREPAY_MONEY';

var PRODUCTS_EDIT_ITEM = exports.PRODUCTS_EDIT_ITEM = 'PRODUCTS_EDIT_ITEM';
var PRODUCTS_EDIT_NOTE = exports.PRODUCTS_EDIT_NOTE = 'PRODUCTS_EDIT_NOTE';
var PRODUCTS_NEW_ORDER_ID = exports.PRODUCTS_NEW_ORDER_ID = 'PRODUCTS_NEW_ORDER_ID';
var PRODUCTS_RESET_VIP_PRICE = exports.PRODUCTS_RESET_VIP_PRICE = 'PRODUCTS_RESET_VIP_PRICE';
var PRODUCTS_RESTORE_LIST = exports.PRODUCTS_RESTORE_LIST = 'PRODUCTS_RESTORE_LIST';

var SAVE_ORDER_TO_BACKUP = exports.SAVE_ORDER_TO_BACKUP = 'SAVE_ORDER_TO_BACKUP';
var TAKE_ORDER_BY_BACKUP = exports.TAKE_ORDER_BY_BACKUP = 'TAKE_ORDER_BY_BACKUP';
var REMOVE_BACKUP_ORDER = exports.REMOVE_BACKUP_ORDER = 'REMOVE_BACKUP_ORDER';

var SHOW_DIALOG_REQUEST = exports.SHOW_DIALOG_REQUEST = 'SHOW_DIALOG_REQUEST';
var SHOW_DIALOG_DESTROY = exports.SHOW_DIALOG_DESTROY = 'SHOW_DIALOG_DESTROY';
var SHOW_DIALOG_SHIPOUT = exports.SHOW_DIALOG_SHIPOUT = 'SHOW_DIALOG_SHIPOUT';
var SHOW_DIALOG_EDITVIP = exports.SHOW_DIALOG_EDITVIP = 'SHOW_DIALOG_EDITVIP';
var SHOW_DIALOG_SAVED_ORDER = exports.SHOW_DIALOG_SAVED_ORDER = 'SHOW_DIALOG_SAVED_ORDER';
var SHOW_DIALOG_TAKE_CASH = exports.SHOW_DIALOG_TAKE_CASH = 'SHOW_DIALOG_TAKE_CASH';
var SHOW_DIALOG_SHOP_COST = exports.SHOW_DIALOG_SHOP_COST = 'SHOW_DIALOG_SHOP_COST';

var ERROR_MSG_NETWORK = exports.ERROR_MSG_NETWORK = 'ERROR_MSG_NETWORK';

/***/ }),

/***/ "aKWN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_pay_order_vue__ = __webpack_require__("95Q9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_pay_order_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_pay_order_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_pay_order_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_pay_order_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c87565_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_pay_order_vue__ = __webpack_require__("fzPX");
function injectStyle (ssrContext) {
  __webpack_require__("Y/fU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66c87565"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_pay_order_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c87565_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_pay_order_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "apj+":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/strings.js": "D/sH",
	"./fr/strings.js": "DX2N"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "apj+";

/***/ }),

/***/ "bHYB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c/yv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
exports.default = {
  //template:``,
  name: '',
  props: {
    name: { type: String, default: 'tab-shortcut' }
  },
  computed: {},
  methods: {},
  components: {},
  watch: {},
  directives: {},
  mounted: function mounted() {},
  data: function data() {
    return {};
  },

  filters: {
    //pluralize: (n, w) => n === 1 ? w : (w + 's'),
    capitalize: function capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }
  }
};

/***/ }),

/***/ "czN6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  //template:``,
  name: '',
  props: {
    name: { type: String, default: 'tab-prepare' },
    count_per: { type: Number, default: 50 }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    vip_info: 'vip_info',
    prepare_list: 'get_prepare_list'
    // list       :'get_prodcuts_list',//商品列表
    // item_money :'get_product_money',//单品总金额
    // item_discount:'get_product_discount',//单品折扣
  }), {
    isfinished: function isfinished() {
      return this.$store.getters.get_pay_info.pay_status;
    },
    total_pages: function total_pages() {
      var self = this;
      if (!self.prepare_list) return 0;
      return Math.ceil(self.prepare_list.length / self.count_per);
    },
    list_array: function list_array() {
      var self = this;

      return self.prepare_list.filter(function (it, index) {
        var name = it.name ? it.name : it.nm ? it.nm : "";

        if (self.gid) {
          var upGid = self.gid.toUpperCase();
          if (it.gid.includes(self.gid)) return true;
          if (name.includes(self.gid)) return true;
          if (it.zhujima && it.zhujima.includes(upGid)) return true;
        } else if (index >= self.curr_page * self.count_per && index < (self.curr_page + 1) * self.count_per) return true;
        return false;
      });
    }
  }),
  methods: {
    lookup_home_stock: function lookup_home_stock() {
      var self = this;
      self.$store.dispatch('act_lookup_home_stock', {
        gid: "", name: "",
        prepare: false,
        self: self,
        callback: function callback(data) {
          var tab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tab-prepare';

          self.$store.commit("SHOW_DIALOG_ACTIVE_TAB", tab);
        }
      });
    },
    next_page: function next_page() {
      if (this.total_pages == 0) return this.curr_page = 0;
      this.curr_page += 1;
      this.curr_page %= this.total_pages;
    },
    msgpad_show: function msgpad_show(group, title, text, type) {
      this.$notify({ group: group, title: title, text: text, type: type });
    },
    img_url: function img_url(item) {
      if (item.def) return "http://www.fa-xiao.com/icons/none.png";
      return "http://www.fa-xiao.com/icons/" + item.gid + ".jpg";
    },
    default_img: function default_img(item) {
      // item.def= true;
      this.$set(item, 'def', true);
      // debugger
      console.log("Load IMG ERROR:", item.gid);
    },
    sale_it: function sale_it(item) {
      if (this.isfinished > 0) {
        return this.msgpad_show("msgpad", "", "本单已经结算", 'error');
      }
      var obj = (0, _assign2.default)({}, item);
      obj.oper = 'add';
      // debugger
      if (obj.save_num > 0) {
        obj.sale_price = 0;
        obj.vip_price = {};
        obj.real_price = obj.real_vip_price = obj.sale_price = 0.0;
        obj.save_take = "take";
        obj.all_num = obj.save_num;
        obj.save_num = 0;
      } else {
        obj.save_take = 'sale';
        if (obj.shop_id) {
          //仓库库存
          obj.sale_price = 0;
          obj.vip_price = {};
          obj.real_price = obj.real_vip_price = obj.sale_price = 0.0;
        }
      }
      obj.num = 1;
      obj.name = obj.nm || obj.name;
      obj.vip = this.$store.getters.vip_info.user_group;
      // debugger
      // this.$store.commit('ACTIVE_SALE_TAB_SHEET',true);
      this.$store.commit('PRODUCTS_EDIT_ITEM', obj);
      this.$emit("active_tab", 'tab-sale');
      this.$emit('clear_input');
      console.log("sale_it", this.$root, "CLEAR_INPUT");
    }
  },
  components: {},
  watch: {},
  directives: {},
  mounted: function mounted() {},
  data: function data() {
    return {
      gid: '',
      curr_page: 0
    };
  },

  filters: {
    //pluralize: (n, w) => n === 1 ? w : (w + 's'),
    capitalize: function capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/***/ }),

/***/ "dEWK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"color":"gradient-primary","dark":""}},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Chat")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("search")])],1)],1),_vm._v(" "),_c('v-list',{attrs:{"subheader":""}},[_c('v-subheader',[_vm._v("Recent chat")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.title,attrs:{"avatar":""},on:{"click":function($event){}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":item.avatar}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.title)}})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":item.active ? 'primary' : 'grey'}},[_vm._v("chat_bubble")])],1)],1)})],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"subheader":""}},[_c('v-subheader',[_vm._v("Previous chats")]),_vm._v(" "),_vm._l((_vm.items2),function(item){return _c('v-list-tile',{key:item.title,attrs:{"avatar":""},on:{"click":function($event){}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":item.avatar}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.title)}})],1)],1)})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dn0Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationDefine = __webpack_require__("a2hP");

var types = _interopRequireWildcard(_mutationDefine);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var dialog_array = ['request', 'destroy', 'ship_out', 'editvip', 'saved_order', 'take_cash', 'shop_cost', 'user_input', 'pay_order', 'user_pay', 'active_tab', 'left_sidebar', 'vip_recharge']; /* eslint-disable no-new */


var default_value = {
  'active_tab': 0
  // 'ship_out'  :'ship_out'
  // 'user_pay':'pay_order'
};

var state = function () {
  var out_state = {
    user_input_fields: []
  };
  dialog_array.map(function (dialog) {
    out_state['show_' + dialog + '_dialog'] = typeof default_value[dialog] != 'undefined' ? default_value[dialog] : false;
  });
  return out_state;
}();

// getters
var getters = function () {
  var out_obj = {
    'user_input_fields': function user_input_fields(state) {
      return state['user_input_fields'];
    }
  };
  dialog_array.map(function (dialog) {
    out_obj['show_' + dialog + '_dialog'] = function (state) {
      return state['show_' + dialog + '_dialog'];
    };
  });

  return out_obj;
}();

var mutations = function () {
  var out_obj = {};

  out_obj['user_input_fields'.toUpperCase()] = function (state, val) {
    state['user_input_fields'] = val;
    state.show_user_input_dialog = true;
  };

  dialog_array.map(function (dialog) {
    var name = 'SHOW_DIALOG_' + dialog.toUpperCase();
    out_obj[name] = function (state, val) {
      var state_nm = 'show_' + dialog + '_dialog';
      state[state_nm] = val;
      // if(name == 'SHOW_DIALOG_ACTIVE_TAB') debugger
      console.log('MUTATIONS (' + state_nm + ')=> ' + name + ':' + val);
    };
  });
  return out_obj;
}();

// mutations

exports.default = {
  state: state,
  getters: getters,
  mutations: mutations
};

/***/ }),

/***/ "e7uY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("QCv7");

__webpack_require__("5beL");

__webpack_require__("muQq");

__webpack_require__("zlJ1");

__webpack_require__("pcWD");

/***/ }),

/***/ "fGws":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

exports.sale = sale;
exports.check_pay_state_3part = check_pay_state_3part;

var _ajax_request = __webpack_require__("Hm2B");

var _ajax_request2 = _interopRequireDefault(_ajax_request);

var _base_api = __webpack_require__("+TLI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sale(_ref) {
	var params = _ref.params,
	    data = _ref.data;

	var url = _base_api.base_url + '/pos/sale.php';
	console.log(_base_api.debug_obj, params);
	return (0, _ajax_request2.default)({
		url: url,
		method: 'post',
		params: (0, _assign2.default)({}, _base_api.debug_obj, params ? params : {}),
		data: data
	});
}

function check_pay_state_3part(query) {
	//weixin_alipy_state{order_id,type}
	var url = _base_api.base_url + '/pos/sale.php?oper=scanpay_state';
	return (0, _ajax_request2.default)({
		url: url,
		method: 'get',
		params: (0, _assign2.default)({}, _base_api.debug_obj, query ? query : {})
	});
}

/***/ }),

/***/ "fzPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.width},model:{value:(_vm.show_dialog),callback:function ($$v) {_vm.show_dialog=$$v},expression:"show_dialog"}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("费用支出")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',[_c('v-text-field',{attrs:{"label":"支出金额","error":parseFloat(_vm.money)!=_vm.money,"required":""},model:{value:(_vm.money),callback:function ($$v) {_vm.money=$$v},expression:"money"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.what_option,"error":!_vm.forwhat,"label":"用途","item-value":"value","item-text":"text","no-data-text":"请选择用途","required":"","clearable":""},model:{value:(_vm.forwhat),callback:function ($$v) {_vm.forwhat=$$v},expression:"forwhat"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.from_option,"error":!_vm.forwhat,"label":"支付方式","item-value":"value","item-text":"text","no-data-text":"请选择支付方式","required":"","clearable":""},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}}),_vm._v(" "),_c('v-select',{attrs:{"error":!_vm.bywho,"items":_vm.sysuser,"label":"经手人","item-value":"_id","item-text":"name","no-data-text":"无可选择的人员","required":"","clearable":""},model:{value:(_vm.bywho),callback:function ($$v) {_vm.bywho=$$v},expression:"bywho"}}),_vm._v(" "),_c('v-textarea',{attrs:{"label":"备注","rows":"2"},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"btn-",on:{"click":function($event){$event.stopPropagation();_vm.init_value();_vm.show_dialog=false}}},[_vm._v("取消")]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.creating,"disabled":_vm.creating||!(_vm.money*1&&_vm.forwhat&&_vm.from&&_vm.note&&_vm.bywho),"color":"info"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.create_record($event)}}},[_vm._v(" 确定\n          "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_vm._v("\n            Loading...\n          ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g0az":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.lookup_products_by_gid = lookup_products_by_gid;
exports.lookup_home_stock = lookup_home_stock;

var _ajax_request = __webpack_require__("Hm2B");

var _ajax_request2 = _interopRequireDefault(_ajax_request);

var _base_api = __webpack_require__("+TLI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

console.log("DEBUG_OBJ:", _base_api.debug_obj);

function lookup_products_by_gid(gid) {
    var def_base_url = _base_api.base_url + "/pos";

    var url = def_base_url + "/product?oper=lookup&gid=" + gid;
    return (0, _ajax_request2.default)({
        url: url,
        method: 'get',
        // params:{shop_id:'558cddd574184c39d2abf993',api:'mobile_device'}
        params: _base_api.debug_obj
    });
}

function lookup_home_stock(_ref) {
    var gid = _ref.gid,
        name = _ref.name;

    var def_base_url = _base_api.base_url + "/pos";

    var url = def_base_url + "/product?oper=store_count&gid=" + (gid ? gid : '') + "&name=" + (name ? name : '');
    return (0, _ajax_request2.default)({
        url: url,
        method: 'get',
        // params:{shop_id:'558cddd574184c39d2abf993',api:'mobile_device'}
        params: _base_api.debug_obj
    });
}

/***/ }),

/***/ "gFLI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("LufI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6ef5c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("1+W4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6ef5c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gq1p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hi8j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hwn7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations; /* eslint-disable no-new */


var _mutationDefine = __webpack_require__("a2hP");

var types = _interopRequireWildcard(_mutationDefine);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _msgpad_show = __webpack_require__("2QB/");

var _msgpad_show2 = _interopRequireDefault(_msgpad_show);

var _vip = __webpack_require__("If6g");

var API = _interopRequireWildcard(_vip);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
	vip: {
		mobile: "",
		name: "",
		user_group: "",
		// addr_act:"",
		// history_addr:[],
		// child:{birthday:"",sex:true},
		// history_addr:[],
		// spec_info: { userid: "" },
		user_amount: 0
	},
	saved: []

	/*
 vip: {
     mobile: "",
     // name: "张明亮",
     user_group:"",
     // addr_act:"",
     // history_addr:[],
     // child:{birthday:"",sex:true},
     // history_addr:[],
     // spec_info: { userid: "" },
     // user_amount: 120,
   },
 */
	// getters
};var getters = {
	vip_info: function vip_info(state) {
		return state.vip;
	},
	vip_prepay_money: function vip_prepay_money(state) {
		return state.vip.prepay_money;
	},
	// vip_amount_less  : state => state.vip.amount_less,
	vip_saved: function vip_saved(state) {
		return state.saved;
	}

	// actions
};var actions = {
	act_lookup_vip: function act_lookup_vip(context, _ref) {
		var mobile = _ref.mobile,
		    callback = _ref.callback;

		return API.lookup_vip(mobile).then(function (resp) {
			if (resp.status == 200) {
				var vip_type = "";
				if (resp.data['vip']) {
					// debugger
					vip_type = resp.data['vip'].user_group ? resp.data['vip'].user_group : '';

					context.commit(types.VIP_SET_VIP_INFO, resp.data['vip']);
				} else {
					(0, _msgpad_show2.default)("msgpad", "失败", "没有此会员信息", 'error');
					context.commit(types.VIP_SET_VIP_INFO, { mobile: "", user_group: "" });
					context.commit(types.PRODUCTS_PREPARE_LIST, []);
				}

				context.commit(types.PRODUCTS_RESET_VIP_PRICE, vip_type);

				// if(resp.data['saved']){
				// 	context.commit(types.VIP_SET_VIP_SAVED, resp.data['saved']);
				// 	context.commit(types.PRODUCTS_PREPARE_LIST, resp.data['saved']?resp.data['saved']:[]);
				// }else{
				// 	context.commit(types.VIP_SET_VIP_SAVED, []);
				// 	context.commit(types.PRODUCTS_PREPARE_LIST, resp.data['saved']?resp.data['saved']:[]);
				// }
				context.commit(types.VIP_SET_VIP_SAVED, resp.data['saved'] ? resp.data['saved'] : []);
				context.commit(types.PRODUCTS_PREPARE_LIST, resp.data['saved'] ? resp.data['saved'] : []);

				if (callback) callback(resp.data);
			} else {
				(0, _msgpad_show2.default)("msgpad", "失败", resp.data.err_msg, 'error');
			}
		}).catch(function (err) {
			(0, _msgpad_show2.default)("msgpad", "NETWORK_ERROR", err.message, 'error');
		});
	},
	act_create_vip: function act_create_vip(context, _ref2) {
		var data = _ref2.data,
		    callback = _ref2.callback;

		var vip_info = data;
		// let url = "/vip?oper=add"
		API.create_or_update_vip('add', { data: vip_info }).then(function (resp) {
			if (resp.status == 200) {
				console.log("CRATE_VIP:", resp.data);
				context.commit(types.VIP_SET_VIP_INFO, resp.data);
				context.commit(types.PRODUCTS_RESET_VIP_PRICE, resp.data.user_group);
				context.commit(types.PRODUCTS_PREPARE_LIST, []);
				context.commit(types.VIP_SET_VIP_SAVED, []);
				if (callback) callback(data);
			}
		}).catch(function (err) {
			if (err.response.data.search("alreay exist") > 0) {
				(0, _msgpad_show2.default)("msgpad", "NETWORK_ERROR", "会员已经存在!", 'error');
			} else {
				(0, _msgpad_show2.default)("msgpad", "NETWORK_ERROR", err.message, 'error');
			}
		});
	},
	act_edit_vip: function act_edit_vip(context, vip_info) {
		// let url = "/vip?oper=edit"
		API.create_or_update_vip('edit', { data: vip_info }).then(function (resp) {
			if (resp.status == 200) {
				console.log("EDIT_VIP:", resp.data);
				context.commit(types.VIP_SET_VIP_INFO, resp.data);
				context.commit(types.PRODUCTS_RESET_VIP_PRICE, resp.data.user_group);
			}
		}).catch(function (err) {
			(0, _msgpad_show2.default)("msgpad", "NETWORK_ERROR", err.message, 'error');
		});
	},
	act_get_vip_saved: function act_get_vip_saved(context, mobile) {
		// let url = "/vip?oper=saved"
		return API.lookup_vip_saved_products(mobile).then(function (resp) {
			context.commit(types.VIP_SET_VIP_SAVED, resp.data);
			return resp.data;
		}).catch(function (err) {
			(0, _msgpad_show2.default)("msgpad", "NETWORK_ERROR", err.message, 'error');
		});
	}
};

// mutations
var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.VIP_SET_VIP_INFO, function (state, vip) {
	if (!vip.spec_info) {
		vip.spec_info = { userid: "" };
	}
	state.vip = vip;
}), (0, _defineProperty3.default)(_mutations, types.VIP_SET_VIP_SAVED, function (state, saved) {
	// debugger
	state.saved = saved;
}), (0, _defineProperty3.default)(_mutations, types.VIP_PREPAY_MONEY, function (state, val) {
	state.vip.prepay_money = val;
}), (0, _defineProperty3.default)(_mutations, types.VIP_PREPAY_MONEY_ADJUST, function (state, val) {
	state.vip.prepay_money += val;
}), (0, _defineProperty3.default)(_mutations, types.VIP_AMOUNT_ADJUST, function (state, val) {
	state.vip.user_amount += val;
}), (0, _defineProperty3.default)(_mutations, types.USE_AMOUNT_SET, function (state, val) {
	state.vip.user_amount = val;
}), _mutations);

exports.default = {
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations
};

/***/ }),

/***/ "i86a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    methods: {
        command_list: function command_list(cmd, enter) {
            var self = this;
            var cmds = [{ cmd: 'store', todo: function todo() {
                    if (self.vip_info.mobile) {
                        return self.msgpad_show("msgpad", "ERROR", '查询仓库库存<br>请先清除会员信息！', 'error');
                    }
                    self.$store.dispatch('act_lookup_home_stock', {
                        gid: "", name: "",
                        prepare: !enter,
                        self: self,
                        callback: function callback(data) {
                            var tab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "tab-prepare";

                            self.act_tab(tab);
                            self.clear_input();
                        }
                    });
                } }, { cmd: 'clear', todo: function todo() {
                    if (enter) {
                        self.confirm_dlg("确定要重置系统？").then(function (_) {
                            self.$store.commit('MUTATIONS_SHOP_SHOP_INFO', null);
                            self.$router.push('/login');
                        }).catch(function (_) {
                            self.clear_input();
                        });
                    }
                } }];
            var cmd_def = cmds.find(function (it) {
                return it.cmd == cmd;
            });
            if (cmd_def) {
                cmd_def.todo();
                return true;
            }
            return false;
        }
    }
};

/***/ }),

/***/ "iLnh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

var _Sidebar = __webpack_require__("8Jk8");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _ChatSidebar = __webpack_require__("tVbq");

var _ChatSidebar2 = _interopRequireDefault(_ChatSidebar);

var _eventBus = __webpack_require__("x6jz");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _screenfull = __webpack_require__("I95x");

var _screenfull2 = _interopRequireDefault(_screenfull);

var _auth = __webpack_require__("AZo+");

var _g_sale = __webpack_require__("lvJx");

var _g_sale2 = _interopRequireDefault(_g_sale);

var _local_device = __webpack_require__("l6S5");

var _local_device2 = _interopRequireDefault(_local_device);

var _dialog_user_input = __webpack_require__("lBMQ");

var _dialog_user_input2 = _interopRequireDefault(_dialog_user_input);

var _dialog_vip_edit = __webpack_require__("yE19");

var _dialog_vip_edit2 = _interopRequireDefault(_dialog_vip_edit);

var _dialog_take_money = __webpack_require__("4qdK");

var _dialog_take_money2 = _interopRequireDefault(_dialog_take_money);

var _dialog_pay_order = __webpack_require__("aKWN");

var _dialog_pay_order2 = _interopRequireDefault(_dialog_pay_order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// getToken from cookie
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
exports.default = {
  mixins: [_g_sale2.default],
  data: function data() {
    return {
      device_api: _local_device2.default,
      collapsed: false, // collapse sidebar
      chatSidebar: false, // chat component right sidebar
      sidebarImages: "", // sidebar background images
      enableSidebarBackground: false,
      enableDefaultSidebar: false,
      rtlLayout: false,
      ifRtlLayout: false,
      searchFormOpen: false,
      items: [
        // {
        //   title: "Total App Memory",
        //   icon: "storage"
        // },
        // {
        //   title: "Total Memory Used",
        //   icon: "memory"
        // },
        // {
        //   title: "12 Unread Mail",
        //   icon: "mail"
        // },
        // {
        //   title: "Feedback",
        //   icon: "feedback"
        // }
      ],
      e31: true,
      e3: 1
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['sysuser_info', 'shop_info'])),
  methods: {
    show_dialog: function show_dialog(id) {
      this.$store.commit(id, true);
    },
    add_vip: function add_vip() {
      this.$store.commit("SHOW_DIALOG_EDITVIP", 'add');
    },
    reset_order: function reset_order() {
      var _this = this;

      this.confirm_dlg("确定要重置此单？").then(function (_) {
        _this.$store.commit("PRODUCTS_LIST_CLEAN");
        _this.$store.commit('VIP_SET_VIP_INFO', {});
        _this.$store.commit('VIP_SET_VIP_SAVED', []);
        _this.$store.commit('PRODUCTS_PREPARE_LIST', []);
        _this.$store.commit('SHOW_DIALOG_ACTIVE_TAB', 'tab-sale');
      });
    },
    toggleFullScreen: function toggleFullScreen() {
      if (_screenfull2.default.enabled) {
        _screenfull2.default.toggle();
      }
    },
    searchFormHanler: function searchFormHanler() {
      this.searchFormOpen = !this.searchFormOpen;
    },
    user_logout: function user_logout() {
      var self = this;
      this.$store.dispatch('act_worker_logout').then(function (data) {
        (0, _auth.removeToken)();
        self.$router.push('/login');
      });
    }
  },
  components: {
    appSidebar: _Sidebar2.default,
    ChatSidebar: _ChatSidebar2.default,
    dialog_user_input: _dialog_user_input2.default,
    dialog_vip_edit: _dialog_vip_edit2.default,
    dialog_take_money: _dialog_take_money2.default,
    dialog_pay_order: _dialog_pay_order2.default

  }
};

/***/ }),

/***/ "iMxt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sale_vue__ = __webpack_require__("iljX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sale_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sale_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sale_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sale_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3173b806_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sale_vue__ = __webpack_require__("/wzy");
function injectStyle (ssrContext) {
  __webpack_require__("MUGa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3173b806"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sale_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3173b806_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sale_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iljX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__("NYxO");

var _saleorder = __webpack_require__("/jFE");

var _saleorder2 = _interopRequireDefault(_saleorder);

var _prepare = __webpack_require__("s73x");

var _prepare2 = _interopRequireDefault(_prepare);

var _shortcut = __webpack_require__("o6BF");

var _shortcut2 = _interopRequireDefault(_shortcut);

var _dialog_user_pay = __webpack_require__("1EX4");

var _dialog_user_pay2 = _interopRequireDefault(_dialog_user_pay);

var _dialog_ship_out = __webpack_require__("7ie1");

var _dialog_ship_out2 = _interopRequireDefault(_dialog_ship_out);

var _dialog_destroy = __webpack_require__("8k8G");

var _dialog_destroy2 = _interopRequireDefault(_dialog_destroy);

var _dialog_vip_recharge = __webpack_require__("BW+J");

var _dialog_vip_recharge2 = _interopRequireDefault(_dialog_vip_recharge);

var _test = __webpack_require__("JlET");

var _test2 = _interopRequireDefault(_test);

var _local_device = __webpack_require__("l6S5");

var _local_device2 = _interopRequireDefault(_local_device);

var _debounce = __webpack_require__("HhAh");

var _debounce2 = _interopRequireDefault(_debounce);

var _mix_prompt_dlg = __webpack_require__("ST9y");

var _mix_prompt_dlg2 = _interopRequireDefault(_mix_prompt_dlg);

var _mix_sale = __webpack_require__("QKaY");

var _mix_sale2 = _interopRequireDefault(_mix_sale);

var _mix_commands = __webpack_require__("i86a");

var _mix_commands2 = _interopRequireDefault(_mix_commands);

var _g_sale = __webpack_require__("lvJx");

var _g_sale2 = _interopRequireDefault(_g_sale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import dialog_user_input from "./dialogs/dialog_user_input";
// import dialog_pay_order from "./dialogs/dialog_pay_order";
// import dialog_vip_edit from "./dialogs/dialog_vip_edit";
exports.default = {
    components: {
        SaleTab: _saleorder2.default,
        PrepareTab: _prepare2.default,
        ShortcutTab: _shortcut2.default,
        // countTo,
        Test: _test2.default,
        // dialog_user_input,
        // dialog_take_money,
        // dialog_pay_order,
        dialog_user_pay: _dialog_user_pay2.default,
        // dialog_vip_edit,
        dialog_ship_out: _dialog_ship_out2.default,
        dialog_destroy: _dialog_destroy2.default,
        dialog_vip_recharge: _dialog_vip_recharge2.default
    },
    mounted: function mounted() {
        this.active_tab = 'tab-sale';
    },

    mixins: [_mix_prompt_dlg2.default, _mix_sale2.default, _mix_commands2.default, _g_sale2.default],
    computed: (0, _extends3.default)({
        dev_view: function dev_view() {
            return this.$vuetify.breakpoint.name;
        },

        classObject: function classObject() {
            if (this.vip_info.mobile) return { xl4: true, lg4: true, md4: true };
            return { xl6: true, lg6: true, md6: true };
        }
    }, (0, _vuex.mapGetters)({
        mutil_index: 'get_mutil_index',

        vip_info: 'vip_info',
        vip_saved: 'vip_saved',

        sum_info: 'get_products_sum_info',
        pay_info: 'get_pay_info',
        order_id: 'get_order_id',
        order_note: 'get_order_note',

        prodcuts_list: 'get_prodcuts_list',
        selected_num: 'get_selected_num',

        post_data: 'get_sale_post_data',
        prepay_money: 'get_use_prepay_money',
        amount_less: 'get_amount_less',
        shop_info: 'shop_info'

    }), {
        active_tab: {
            get: function get() {
                return this.$store.state.dialog.show_active_tab_dialog;
            },
            set: function set(val) {
                // if(val == 'tab-prepare') debugger
                this.$store.commit('SHOW_DIALOG_ACTIVE_TAB', val);
            }
        },
        pay_info_str: function pay_info_str() {
            var pay_info = this.pay_info;
            if (pay_info.title) return pay_info.title;
            var type = pay_info.pay_type;
            var prepay = "";
            var cash = "";
            var string = "";
            if (pay_info.pay_status <= 0) string = '';

            if (pay_info.use_prepay) {
                prepay = "\u4F1A\u5458\u5361\u652F\u4ED8:" + this.sum_info.use_prepay + "\u5143";
            }
            if (pay_info.recv) {
                cash = "\u73B0\u91D1\u652F\u4ED8:" + this.pay_info.recv;
            }
            if (type == 'cash') {
                if (pay_info.bank_id) {
                    string = "\u94F6\u884C\u5361\u652F\u4ED8:" + (pay_info.total_money - pay_info.recv) + " " + ("" + cash) + prepay;
                } else {
                    string = "" + cash;
                    if (this.pay_info.recv > 0) {
                        string += " \u627E\u96F6: " + pay_info.ret.toFixed(2);
                    }
                    string += prepay;
                }
            } else if (type == "weixin") {
                string = "\u5FAE\u4FE1\u652F\u4ED8  " + prepay + cash;
            } else if (type == "alipay") {
                string = "\u652F\u4ED8\u5B9D\u652F\u4ED8 " + prepay + cash;
            } else if (type == "mall") {
                string = "\u5546\u573A\u4EE3\u6536 " + prepay + cash;
            } else if (type == "bank") {
                string = "\u94F6\u884C\u5361\u652F\u4ED8 " + prepay + cash;
            }
            console.log("Pay String:", string);
            return string;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)({
        edit_item: 'PRODUCTS_EDIT_ITEM',
        inc_mul_index: 'PRODUCTS_LIST_INC_MUL_INDEX',
        set_discount: 'PRODUCTS_DISCOUNT_SELECTED',
        act_tab: 'SHOW_DIALOG_ACTIVE_TAB'
    }), {
        log: function log(str) {
            console.log(str);
        },
        add_vip: function add_vip(type) {
            this.show_dialog('SHOW_DIALOG_EDITVIP', type);
        },
        clear_input: function clear_input(is_sale) {
            this.input_gid = '';
            if (is_sale) this.act_tab('tab-sale');
        },

        gid_input: (0, _debounce2.default)(function (e) {
            var gid = this.input_gid;
            if (gid && gid.length > 2) {
                this.lookup_product();
            } else if (!gid) {
                this.act_tab('tab-sale');
            }
        }, 350),
        do_pay_money: function do_pay_money() {
            var _this = this;

            var self = this;
            debugger;
            var ready = self.ready_for_sale();
            if (!ready) return;

            function do_it(pay_info) {
                debugger;
                var post_data = self.sale_detail(pay_info);
                return self.do_post_sale(post_data).then(function (doc) {
                    if (doc) {
                        self.show_dialog('SHOW_DIALOG_USER_PAY', false);
                        debugger;
                        doc.shop = self.shop_info;
                        self.confirm_dlg("是否打印小票？").then(function (_) {
                            _local_device2.default.post_printer(doc);
                        }).catch(function (err) {});
                    }
                });
            }

            if (self.sum_info.total_money > 0 && self.sum_info.total_money == self.prepay_money) {
                self.confirm_dlg("使用充值卡结算？").then(function (_) {
                    var p_pay = {
                        pay_type: "cash",
                        recv_money: 0,
                        where: "store",
                        taobao: false,
                        bank_id: "",
                        auth_code: ""
                    };
                    do_it(p_pay);
                }).catch();
                return;
            }

            self.show_dialog('SHOW_DIALOG_USER_PAY', {
                money: self.sum_info.total_money - self.sum_info.use_prepay,
                prepay_money: self.prepay_money,
                callback: function () {
                    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(pay_info) {
                        return _regenerator2.default.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        _context.next = 2;
                                        return do_it(pay_info);

                                    case 2:
                                    case "end":
                                        return _context.stop();
                                }
                            }
                        }, _callee, _this);
                    }));

                    function callback(_x) {
                        return _ref.apply(this, arguments);
                    }

                    return callback;
                }()
            });
        },
        show_destroy_dialog: function show_destroy_dialog() {

            this.ready_for_sale('destory') && this.show_dialog('SHOW_DIALOG_DESTROY', true);
        },
        show_ship_out_dialog: function show_ship_out_dialog() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ship_out";

            this.ready_for_sale(type) && this.show_dialog('SHOW_DIALOG_SHIP_OUT', type);
        },
        def_discount: function def_discount() {
            var self = this;
            self.prompt_dlg("请输入自定义折扣", "自定义折扣", 'discount', function (val, dlg) {
                if (/^[0-9]*$/.test(val)) {
                    val *= 1;
                    if (val >= 0 && val <= 100) {
                        return val;
                    }
                }
                return false;
            }).then(function (disc) {
                self.set_discount(disc);
            }).catch(function (e) {});
        },
        lookup_vip_saved: function lookup_vip_saved() {
            var self = this;
            var saved = self.vip_saved;
            if (saved.length == 0) {
                return self.msgpad_show("msgpad", "ERROR", '会员信息错误', 'error');
            }
            self.$store.commit('PRODUCTS_PREPARE_LIST', saved);
            self.active_tab = 'tab-prepare';
        },
        recharge: function recharge(val) {
            var self = this;
            debugger;
            // this.$set(this,'recharge_conf',val)
            console.log("RECHARGE:", val);
            if (!val.mobile) {
                return self.msgpad_show("msgpad", "ERROR", '会员信息错误', 'error');
            }
            if (val.money + val.ext == 0) {
                self.show_dialog('SHOW_DIALOG_USER_PAY', false);
                return self.msgpad_show("msgpad", "ERROR", '充值金额为0', 'error');
            }
            val.callback = function (pay_info) {
                if (!pay_info) {
                    debugger;
                    return;
                }
                var post_data = self.vip_prepay_fake_order(self.order_id + "-" + self.mutil_index, val.mobile, pay_info, val.note);
                // debugger;
                console.log("recharge - pay_info:", pay_info);
                console.log("recharge - post_data:", post_data);

                self.do_post_sale(post_data).then(function (doc) {
                    if (doc) {
                        console.log("SALE OK:", doc);
                        self.msgpad_show("msgpad", "成功", '充值金额成功', 'success');
                        self.show_dialog('SHOW_DIALOG_USER_PAY', false);
                        self.show_dialog('SHOW_DIALOG_VIP_RECHARGE', false);
                        self.$store.commit('PRODUCTS_LIST_INC_MUL_INDEX');
                        self.lookup_vip_info(val.mobile, function () {
                            debugger;
                            self.msgpad_show("msgpad", "成功", '会员信息更新成功', 'success');
                        });
                    }
                }).catch(function (err) {
                    return self.msgpad_show("msgpad", "ERROR", '充值失败,请稍后再试。', 'error');
                });
            };
            this.show_dialog('SHOW_DIALOG_USER_PAY', val);
        }
    }),
    data: function data() {
        return {
            // recharge :0,
            recharge_conf: {},
            avatar_size: 'large',
            title: false,
            size: 32,
            input_gid: '',
            form1: {
                money: null,
                who: "",
                bywho: ""
            }

        };
    }
};
// import countTo from "vue-count-to";
// import {lookup_vip}from "@/api/module/vip"

// import dialog_take_money from  "./dialogs/dialog_take_money";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/***/ }),

/***/ "jQWn":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./miaosha_order.vue": [
		"DjBI",
		1
	],
	"./sale_orders.vue": [
		"6x9C",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "jQWn";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "joD2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k59F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",class:_vm.sidebarFilter},[_c('v-toolbar',{staticClass:"transparent scroll-area navigation",attrs:{"flat":""}},[_c('v-list',{staticClass:"pa-0"},[_c('v-list-tile',{staticClass:"sidebar-profile",attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":"/static/img/user-11.jpg"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"fw-bold"},[_vm._v("John Leider")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{staticClass:"ma-0",attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"to":"/users/user-profile"}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-user")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("View Profile")])],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":"/inbox"}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-email")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Inbox")])],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":"/users/users-list"}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-bell")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Users List")])],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":"/session/login"}},[_c('v-icon',{staticClass:"mr-3 font-lg text-gray"},[_vm._v("ti-power-off")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Log Out")])],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{staticClass:"sidebar-title px-3"},[_c('span',[_vm._v(_vm._s(_vm.$lang.strings.general))])]),_vm._v(" "),_vm._l((_vm.category1),function(item){return [(item.items!= null)?[_c('v-list-group',{key:item.title,attrs:{"prepend-icon":item.action,"no-action":""},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}},[(item.items !== null)?_c('v-list-tile',{attrs:{"slot":"activator","ripple":""},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$lang.strings[item.title]))])],1)],1):_c('v-list-tile',{attrs:{"slot":"activator","ripple":"","to":item.path},slot:"activator"},[_c('v-list-tile-action',[_c('i',{class:item.action})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$lang.strings[item.title]))])],1)],1),_vm._v(" "),_vm._l((item.items),function(subItem){return (subItem !== null)?_c('v-list-tile',{key:subItem.title,attrs:{"ripple":"","to":subItem.path}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$lang.strings[subItem.title]))])],1)],1):_vm._e()})],2)]:[_c('v-list-tile',{key:item.path,attrs:{"to":item.path}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.action))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$lang.strings[item.title]))])],1)],1)]]}),_vm._v(" "),_c('div',{staticClass:"sidebar-title px-3"},[_c('span',[_vm._v(_vm._s(_vm.$lang.strings.components))])])],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kOQc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.width},model:{value:(_vm.show_dialog),callback:function ($$v) {_vm.show_dialog=$$v},expression:"show_dialog"}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("提现记录")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',[_c('v-text-field',{attrs:{"label":"提取金额","error":parseFloat(_vm.money)!=_vm.money,"required":""},model:{value:(_vm.money),callback:function ($$v) {_vm.money=$$v},expression:"money"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.sysuser,"error":!_vm.who,"label":"提取人","item-value":"_id","item-text":"name","no-data-text":"无可选择的人员","required":"","clearable":""},model:{value:(_vm.who),callback:function ($$v) {_vm.who=$$v},expression:"who"}}),_vm._v(" "),_c('v-select',{attrs:{"error":!_vm.bywho,"items":_vm.sysuser,"label":"经手人","item-value":"_id","item-text":"name","no-data-text":"无可选择的人员","required":"","clearable":""},model:{value:(_vm.bywho),callback:function ($$v) {_vm.bywho=$$v},expression:"bywho"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"btn-",on:{"click":function($event){$event.stopPropagation();_vm.init_value();_vm.show_dialog=false}}},[_vm._v("取消")]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.creating,"disabled":_vm.creating||!(_vm.money*1&&_vm.who&&_vm.bywho),"color":"info"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.create_record($event)}}},[_vm._v("\n\t      确定\n\t      "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_vm._v("\n\t        Loading...\n\t      ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kTXO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _auth = __webpack_require__("AZo+");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// getToken from cookie


// permissiom judge function
function hasPermission(roles, permissionRoles) {
	if (roles.indexOf('admin') >= 0) return true; // admin permission passed directly
	if (!permissionRoles) return true;
	return roles.some(function (role) {
		return permissionRoles.indexOf(role) >= 0;
	});
}
// import { Message } from 'element-ui'


var whiteList = ['/login', '/authredirect']; // no redirect whitelist

_router2.default.beforeEach(function (to, from, next) {
	if (_store2.default.getters.shop_info && (0, _auth.getToken)()) {
		// determine if there has token
		/* has token*/
		if (to.path === '/login') {
			next({ path: '/' });
		} else {
			return next();

			// if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
			// 	store.dispatch('GetUserInfo').then(res => { // 拉取user_info
			// 		const roles = res.data.roles // note: roles must be a array! such as: ['editor','develop']
			// 		store.dispatch('GenerateRoutes', {
			// 			roles
			// 		}).then(() => { // 根据roles权限生成可访问的路由表
			// 			router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
			// 			next({...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
			// 		})
			// 	}).catch(() => {
			// 		store.dispatch('FedLogOut').then(() => {
			// 			// Message.error('Verification failed, please login again')
			// 			next({path: '/login'})
			// 		})
			// 	})
			// } else {
			// 	// 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
			// 	if (hasPermission(store.getters.roles, to.meta.roles)) {
			// 		next() //
			// 	} else {
			// 		next({path: '/401', replace: true, query: {noGoBack: true } })
			// 	}
			// 	// 可删 ↑
			// }
		}
	} else {
		/* has no token*/
		if (whiteList.indexOf(to.path) !== -1) {
			// 在免登录白名单，直接进入
			next();
		} else {
			next('/login'); // 否则全部重定向到登录页
		}
	}
});

_router2.default.afterEach(function () {});

/***/ }),

/***/ "kw+W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      password: "",
      valid: false,
      passwordRules: [function (v) {
        return !!v || "Password is required";
      }]
    };
  },
  methods: {
    onSubmit: function onSubmit(evt) {
      evt.preventDefault();
    }
  }
};

/***/ }),

/***/ "ky9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LockScreen_vue__ = __webpack_require__("kw+W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LockScreen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LockScreen_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LockScreen_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LockScreen_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80a4f7a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LockScreen_vue__ = __webpack_require__("zbAu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LockScreen_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80a4f7a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LockScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "l6S5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var print_url = "http://localhost:3000/print"; // import request from '@/api/ajax_request.js'

var qs = __webpack_require__("mw3O");

var device_api = {

    post_printer: function post_printer(data) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


        return (0, _axios2.default)({
            url: print_url,
            method: 'post',
            params: params,
            data: qs.stringify(data)
        });
    },
    last_printer: function last_printer() {
        return (0, _axios2.default)({
            url: print_url + '/last',
            method: 'get'
        });
    },
    open_box: function open_box() {
        return (0, _axios2.default)({
            url: print_url + '/open',
            method: 'get'
        });
    },
    load_weight: function load_weight() {
        var weighter_url = "";
        return (0, _axios2.default)({
            url: weighter_url + '/open',
            method: 'get'
        });
    }
};

exports.default = device_api;

/***/ }),

/***/ "lBMQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_user_input_vue__ = __webpack_require__("O/hE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_user_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_user_input_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_user_input_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_user_input_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8feb4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_user_input_vue__ = __webpack_require__("rcjy");
function injectStyle (ssrContext) {
  __webpack_require__("zbya")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e8feb4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_user_input_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e8feb4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_user_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lvJx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	methods: {
		confirm_dlg: function confirm_dlg(title) {
			var _this = this;

			return new _promise2.default(function (resove, reject) {
				var dlg_conf = {
					title: title,
					fields: [],
					action: function action(_ref) {
						var close = _ref.close,
						    self = _ref.self,
						    type = _ref.type;

						if (type == 'cancel') return reject('cancel');
						self.close_dialog();
						return resove(type);
					}
				};
				_this.$store.commit('USER_INPUT_FIELDS', dlg_conf);
			});
		},
		edit_sale_note_dlg: function edit_sale_note_dlg(title) {
			var _this2 = this;

			if (this.$store.getters.get_pay_info.pay_status > 0) {
				this.msgpad_show("msgpad", "ERROR", '本单已经结算！', 'error');
				return;
			};
			return new _promise2.default(function (resove, reject) {
				var dlg_conf = {
					title: title,
					fields: [{
						title: '备注',
						placeholder: '备注',
						type: "string",
						value: _this2.order_note,
						name: 'note',
						err_msg: [],
						rules: [function (v) {
							return !!v || "备注是必须的";
						}]
					}],
					action: function action(_ref2) {
						var close = _ref2.close,
						    self = _ref2.self,
						    type = _ref2.type,
						    data = _ref2.data;

						if (type == 'cancel') return reject('cancel');
						var ok = self.$refs.form.validate();
						if (!ok) return reject(false);
						self.close_dialog();
						return resove(data);
					}
				};
				_this2.$store.commit('USER_INPUT_FIELDS', dlg_conf);
			}).then(function (data) {
				debugger;
				_this2.$store.commit('PRODUCTS_EDIT_NOTE', data.note);
			});
		}
	}
};

/***/ }),

/***/ "mGeM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__("3mzj");

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Customizer from "../components/Customizer/Customizer";
exports.default = {
  components: {
    appHeader: _Header2.default
    // appCustomizer: Customizer
  },
  computed: {
    // computed property to get page breadcrumbs
    pageTitle: function pageTitle() {
      return this.$breadcrumbs[0].meta.title;
    },
    pageBreadcrumb: function pageBreadcrumb() {
      return this.$breadcrumbs[0].meta.breadcrumb;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/***/ }),

/***/ "mimI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _mix_prompt_dlg = __webpack_require__("ST9y");

var _mix_prompt_dlg2 = _interopRequireDefault(_mix_prompt_dlg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {vip_recharge} from "@/api/module/vip"
// import {selectoption} from "@/api/module/select_options"    
exports.default = {
    //template:``,['mall', 'taobao', 'mix', 'cash','weixin','alipay']
    name: '',
    props: {
        // recharge:
        // total_money:{ type:Number,default:0},
        // order_id   :{ type:String,default:''},
    },
    mixins: [_mix_prompt_dlg2.default],
    watch: {
        recv_money: function recv_money(val, old) {
            // debugger
            if (val == null) return this.recv_money = 0;
        },
        show_dialog: function show_dialog(val) {
            var _this = this;

            if (val) {
                this.init_dialog();
                this.$nextTick(function (_) {
                    return _this.$refs["in_cash"].focus();
                });
                console.log("watch:show_dialog=", val);
            }
        },
        pay_type: function pay_type(val, old) {
            var _this2 = this;

            // if(val != 'cash')
            {
                this.recv_money = 0;
                this.bank_id = '';
                this.mix_cash = false;
            }
            this.auth_code = '';
            // console.log("CHANGE pay_type",val,this.$refs["in_"+val])
            if (['cash', 'weixin', 'alipay'].indexOf(val) >= 0) {
                this.$nextTick(function (_) {
                    return _this2.$refs["in_" + val].focus();
                });
            }
        },
        mix_cash: function mix_cash(val) {
            var _this3 = this;

            if (val) {
                if (this.pay_type == 'weixin') this.$nextTick(function () {
                    _this3.$refs['weixin_cash'].focus();
                });else if (this.pay_type == 'alipay') this.$nextTick(function () {
                    _this3.$refs['alipay_cash'].focus();
                });else if (this.pay_type == 'mall') this.$nextTick(function () {
                    _this3.$refs['mall_cash'].focus();
                });
            }
        }
    },
    computed: {
        show_dialog: {
            get: function get() {
                return this.$store.state.dialog.show_user_pay_dialog;
            },
            set: function set(val) {
                // if(!val){
                //     this.init_dialog();
                // }
                if (val) {
                    if (this.show_dialog == 'pay_order' || (0, _typeof3.default)(this.show_dialog) == 'object') {
                        this.creating = false;
                        return;
                    }
                }
                this.$store.commit('SHOW_DIALOG_USER_PAY', val);
            }
        },
        enable_types: function enable_types() {
            return this.show_dialog.types ? this.show_dialog.types : ['cash', 'weixin', 'alipay', 'mall', 'taobao'];
        },
        config: function config() {
            if (typeof this.show_dialog == 'boolean' && !this.show_dialog) return { money: 0, use_prepay: 0 };
            return this.show_dialog;
        },
        total_money: function total_money() {
            return this.config.money;
        },
        use_prepay: function use_prepay() {
            return this.config.prepay_money;
        },
        callback: function callback() {
            return this.show_dialog.callback;
        },

        cash_msg: function cash_msg() {
            var str_err = "";
            if (this.pay_type == 'cash') {
                if (this.recv_money == 0 && this.total_money != 0) {
                    if (this.bank_id == '') return str_err = "请输入实收现金或银行卡末4位！";
                    if (this.bank_id.length != 4) {
                        return str_err = "请输入银行卡末4位！";
                    }
                    return str_err = "银行卡消费:" + this.total_money.toFixed(2);
                } else if (this.recv_money + 0.009 < this.total_money) {
                    if (this.bank_id == '') return str_err = "实收现金不足";
                    if (this.bank_id.length != 4) {
                        return str_err = "混合收银，请输入银行卡末4位！";
                    }
                    return str_err = "混合收银:现金" + this.recv_money.toFixed(2) + "  银行卡:" + (this.total_money - this.recv_money).toFixed(2);
                } else if (this.recv_money >= this.total_money + 100) {
                    return "收取的现金不应多于商品总金额+100元!";
                }
                return '\u627E\u96F6:' + (this.recv_money - this.total_money).toFixed(2) + ' \u5143';
            } else if (this.pay_type == 'weixin' || this.pay_type == 'alipay') {
                if (this.recv_money > 0) {
                    str_err = "收取现金:" + this.recv_money.toFixed(2);
                }
                if (this.auth_code == '') return str_err += " 请输入付款码";
            } else if (this.pay_type == 'mall') {
                if (this.mix_cash) {
                    if (this.recv_money > this.total_money) {
                        return "收取的现金超过总金额";
                    }
                    str_err = "收取现金:" + this.recv_money.toFixed(2);
                }
                str_err + "商场代收:" + (this.total_money - this.recv_money).toFixed(2) + "元";
            }
            return str_err;
        }
    },
    methods: {
        enable_tab: function enable_tab(type) {
            if (this.enable_types.indexOf(type) < 0) return false;
            if (type == 'mall' && this.config.type == 'recharge') return false;
            return true;
        },
        enter_cash: function enter_cash(type) {
            var _this4 = this;

            if (type == 'cash') {
                if (this.recv_money > this.total_money) {
                    this.do_pay();
                } else {
                    this.$nextTick(function () {
                        _this4.$refs['in_bank'].focus();
                    });
                }
            } else if (type == 'bank') {
                if (this.bank_id.length == 4) return this.do_pay();
                if (this.bank_id.length == 0) return this.$refs['in_cash'].focus();
                this.$refs['in_bank'].select();
            }
        },
        pay_detail: function pay_detail() {
            /*
            this.pay_type   = 'cash';
            this.where      = "store";
            this.bank_id    = "";
            this.auth_code  = "";
            this.recv_money = 0;
            this.taobao     = false;
            this.err_msg    = "";
            */
            var pay_type = this.pay_type;
            if (pay_type == 'cash' /*&& this.recv_money ==0 */ && this.bank_id.length == 4) {
                pay_type = 'bank';
            }
            var detail = {
                total_money: this.total_money,
                pay_type: pay_type,
                recv_money: this.recv_money,
                where: this.where,
                taobao: this.taobao,
                bank_id: this.bank_id,
                auth_code: this.auth_code
            };
            if (this.config.ext) {
                detail.ext = this.config.ext;
            }
            return detail;
        },
        do_pay: function do_pay() {
            var _this5 = this;

            if (this.sanity_check()) {
                if (!this.callback) {
                    throw new Error(" NOT set Callback");
                }
                debugger;
                this.creating = true;
                this.callback(this.pay_detail()).then(function (_) {
                    _this5.creating = false;
                    debugger;
                });
            }
        },
        sanity_check: function sanity_check() {
            if (this.recv_money >= this.total_money) {
                if (this.pay_type != 'cash') {
                    this.$notify({ group: "msgpad", title: "错误", text: "收取的现金多于商品总金额", type: "error" });
                    return false;
                }
                this.pay_type = 'cash';
            }
            if (this.pay_type == 'cash') {
                if (this.total_money > 0 && this.recv_money >= this.total_money + 100) {
                    this.$notify({ group: "msgpad", title: "错误", text: "收取的现金不应多于商品总金额+100元!", type: "error" });
                    return false;
                }
                if (this.recv_money < this.total_money && this.bank_id.length != 4) {
                    this.$notify({ group: "msgpad", title: "错误", text: "收取的现金不足", type: "error" });
                    return false;
                }
            } else if (this.pay_type == 'weixin' || this.pay_type == 'alipay') {

                if (this.auth_code == "") {
                    this.$notify({ group: "msgpad", title: "错误", text: "请输入付款码！", type: "error" });
                    return false;
                }
            }
            return true;
        },
        prompt_input_money: function prompt_input_money() {
            var self = this;
            self.prompt_dlg("收取现金收", "现金", 'recv', function (val, dlg) {
                if (/^([0-9]*\.?[0-9]+)$/.test(val)) {
                    val *= 1;
                    if (val >= 0 && val <= self.total_money) {
                        return true;
                    } else {
                        dlg.set_errmsg('recv', '收取的现金不应多于商品总金额');
                    }
                }
                return false;
            }).then(function (money) {
                self.recv_money = money * 1;
            }).catch(function (e) {});
        },
        init_dialog: function init_dialog() {
            // debugger
            this.pay_type = 'cash';
            this.where = "store";
            this.bank_id = "";
            this.auth_code = "";
            this.recv_money = 0;
            this.taobao = false;;
            this.err_msg = "";
        }
    },
    components: {},
    directives: {},
    mounted: function mounted() {},
    data: function data() {
        return {
            pay_type: 'cash',
            where: 'store',
            bank_id: "",
            auth_code: "",
            recv_money: 0,
            creating: false,
            taobao: false,
            mix_cash: false,
            err_msg: "ERROR"
        };
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import * as sale_api from "@/api/module/sale"

/***/ }),

/***/ "muQq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n2UJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.show_dialog),callback:function ($$v) {_vm.show_dialog=$$v},expression:"show_dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline info lighten-2",attrs:{"primary-title":""}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-form',{ref:"form"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"会员号","clearable":"","rules":[_vm.is_valide_mobiel],"disabled":_vm.show_dialog=='edit'},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","md8":""}},[_c('v-text-field',{attrs:{"disabled":_vm.spec_info.valid,"label":"姓名","clearable":"","rules":[function (val){ return val?true:'会员姓名'; }],"hide-details":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.sex),callback:function ($$v) {_vm.sex=$$v},expression:"sex"}},[_c('v-radio',{attrs:{"label":"男","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"女","value":false}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","md8":""}},[_c('v-text-field',{attrs:{"disabled":_vm.spec_info.valid&&_vm.valide_userid(),"label":"身份证","clearable":"","rules":[_vm.is_valide_userid]},model:{value:(_vm.spec_info.userid),callback:function ($$v) {_vm.$set(_vm.spec_info, "userid", $$v)},expression:"spec_info.userid"}})],1),_vm._v(" "),(!_vm.spec_info.valid && _vm.valide_userid())?_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-btn',{attrs:{"color":"success"},on:{"click":_vm.check_valid}},[_vm._v("验证")])],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"收货地址","clearable":""},model:{value:(_vm.addr_act),callback:function ($$v) {_vm.addr_act=$$v},expression:"addr_act"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.vip_type,"label":"会员类型","item-value":"value","item-text":"text","no-data-text":"请选择用途","rules":[function (val){ return val?true:'会员类型'; }],"clearable":"","disabled":""},model:{value:(_vm.user_group),callback:function ($$v) {_vm.user_group=$$v},expression:"user_group"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("已签署跨境协议: " + (_vm.signed?'是':'否')),"color":"red","hint":"是否签署跨境协议"},model:{value:(_vm.signed),callback:function ($$v) {_vm.signed=$$v},expression:"signed"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","md8":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"儿童生日","prepend-icon":"ti-timer"},slot:"activator",model:{value:(_vm.birthday),callback:function ($$v) {_vm.birthday=$$v},expression:"birthday"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"max":new Date().toISOString().substr(0, 10),"min":"2010-01-01","no-title":"","clearable":"","scrollable":"","type":"date","locale":"zh"},on:{"change":_vm.save_menu},model:{value:(_vm.child.birthday),callback:function ($$v) {_vm.$set(_vm.child, "birthday", $$v)},expression:"child.birthday"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu= false}}},[_vm._v("取消")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.child.sex),callback:function ($$v) {_vm.$set(_vm.child, "sex", $$v)},expression:"child.sex"}},[_c('v-radio',{attrs:{"label":"男","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"女","value":false}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning"},nativeOn:{"click":function($event){_vm.show_dialog = false}}},[_vm._v("取消")]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.doing,"disabled":_vm.doing,"color":"info darken-1"},nativeOn:{"click":function($event){return _vm.create_record($event)}}},[_vm._v("保存")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nKaI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SidebarLinks = __webpack_require__("6YVE");

var _eventBus = __webpack_require__("x6jz");

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { category1, category2, category3, category4 } from "./SidebarLinks";
exports.default = {
  data: function data() {
    return {
      category1: _SidebarLinks.category1,
      // category2: category2,
      // category3: category3,
      // category4: category4,
      backgroundFilters: null,
      expandSidebar: ""
    };
  },

  computed: {
    // change the background color of the sidebar
    sidebarFilter: function sidebarFilter() {
      var _this = this;

      _eventBus2.default.$on("sidebarFilters", function (payload) {
        _this.backgroundFilters = payload;
      });
      return this.backgroundFilters;
    }
  }
};

/***/ }),

/***/ "o6BF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shortcut_vue__ = __webpack_require__("c/yv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shortcut_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shortcut_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shortcut_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shortcut_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0ad41e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shortcut_vue__ = __webpack_require__("UNiv");
function injectStyle (ssrContext) {
  __webpack_require__("8s9y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e0ad41e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shortcut_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0ad41e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shortcut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "o9Le":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o9je":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
exports.default = {
  //template:``,
  name: '',
  props: {},
  computed: {},
  methods: {},
  components: {},
  watch: {},
  directives: {},
  mounted: function mounted() {},
  data: function data() {
    return {};
  },

  filters: {
    //pluralize: (n, w) => n === 1 ? w : (w + 's'),
    capitalize: function capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }
  }
};

/***/ }),

/***/ "p8by":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pcWD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rJFl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rcjy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px","persistent":""},model:{value:(_vm.show_dialog),callback:function ($$v) {_vm.show_dialog=$$v},expression:"show_dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline info lighten-2",attrs:{"primary-title":""}},[_vm._v("\n          "+_vm._s(_vm.dlg_config.title)+"\n        ")]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",staticClass:"mb-4",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},_vm._l((_vm.dlg_config.fields),function(field){return _c('myinput',{key:field.name,attrs:{"field":field,"err_msg":field.err_msg,"rules":field.rules?field.rules:[]},on:{"change":function (val){_vm.field_change(val,field.name)}},model:{value:(field.value),callback:function ($$v) {_vm.$set(field, "value", $$v)},expression:"field.value"}})}))],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"btn-danger",on:{"click":function($event){$event.stopPropagation();_vm.show_dialog=_vm.doing=false,_vm.action('cancel')}}},[_vm._v("取消")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-success",attrs:{"loading":_vm.doing,"disabled":_vm.doing},on:{"click":function($event){$event.stopPropagation();_vm.action('ok')}}},[_vm._v("确定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "reqk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__("mGeM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_296b07d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__("I2dI");
function injectStyle (ssrContext) {
  __webpack_require__("bHYB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-296b07d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_296b07d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "s73x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prepare_vue__ = __webpack_require__("czN6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prepare_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prepare_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prepare_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prepare_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca99707a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_prepare_vue__ = __webpack_require__("Zbde");
function injectStyle (ssrContext) {
  __webpack_require__("xOe6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca99707a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prepare_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca99707a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_prepare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "smBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.field.type == 'select' && _vm.field.enum)?_c('v-select',{attrs:{"items":_vm.field.enum,"label":_vm.field.placeholder?_vm.field.placeholder:'',"item-value":"_id","item-text":"name"},model:{value:(_vm.curr_value),callback:function ($$v) {_vm.curr_value=$$v},expression:"curr_value"}}):_c('v-text-field',{attrs:{"clearable":"","error-messages":_vm.err_msg,"rules":_vm.rules?_vm.rules:[],"label":_vm.field.placeholder?_vm.field.placeholder:''},model:{value:(_vm.curr_value),callback:function ($$v) {_vm.curr_value=$$v},expression:"curr_value"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t4X9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['item'],
    computed: {
        take: function take() {
            return this.item.save_take == 'take';
        },
        money: function money() {
            return this.$store.getters.get_product_money(this.item.gid);
        },
        discount: function discount() {
            return this.$store.getters.get_product_discount(this.item.gid);
        },

        vip: function vip() {
            return this.$store.getters.vip_info;
        },
        show_less: function show_less() {
            if (this.item.less % this.item.real_price) return "减" + this.item.less;else {
                return "送" + this.item.less / this.item.real_price;
            }
        },
        isfinished: function isfinished() {
            return this.$store.getters.get_pay_info.pay_status;
        },
        prepay_money: function prepay_money() {
            return this.$store.getters.get_use_prepay_money;
        }
    },
    methods: {
        msgpad_show: function msgpad_show(group, title, text, type) {
            this.$notify({ group: group, title: title, text: text, type: type });
        },
        img_url: function img_url(item) {
            return "http://www.fa-xiao.com/icons/" + item.gid + ".jpg";
        },
        load_weight: function load_weight() {},
        return_it: function return_it() {
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            this.no_prepay_money();
            this.$store.commit('PRODUCTS_EDIT_ITEM', {
                gid: this.item.gid,
                oper: 'return_it'
            });
        },
        no_prepay_money: function no_prepay_money() {
            // this.$store.commit('VIP_PREPAY_MONEY', this.vip.prepay_money + this.prepay_money);
            this.$store.commit('VIP_PREPAY_MONEY_ADJUST', this.prepay_money);
            this.$store.commit('USE_PREPAY_MONEY', 0.0);
        },
        free_it: function free_it() {

            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            // if(this.item.less + this.item.real_price > this.money){
            if (this.money - this.item.real_price < 0 || this.money < 0) {
                console.log(this.item.less + this.item.real_price, this.money);
                return this.msgpad_show("msgpad", "ERROR", '赠送金额不正确，不能大于商品总销售价格！', 'error');
            }
            this.no_prepay_money();
            this.$store.commit('PRODUCTS_EDIT_ITEM', {
                gid: this.item.gid,
                oper: 'free_it'
            });
        },
        set_to_int: function set_to_int() {
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            this.no_prepay_money();
            this.$store.commit('PRODUCTS_EDIT_ITEM', {
                gid: this.item.gid,
                oper: 'set_to_int',
                value: this.money - parseInt(this.money)
            });
        },
        less_money: function less_money(val) {
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            if (val != undefined) {
                this.no_prepay_money();
                this.$store.commit('PRODUCTS_EDIT_ITEM', {
                    gid: this.item.gid,
                    oper: 'set_less',
                    value: val * 1
                });
            }
        },
        test: function test() {
            this.$store.commit('PRODUCTS_RESET_VIP_PRICE', {
                gid: this.item.gid,
                oper: 'selected'
            });
        },
        use_vip_price: function use_vip_price() {
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            this.no_prepay_money();
            this.$store.commit('PRODUCTS_EDIT_ITEM', {
                gid: this.item.gid,
                oper: 'use_vip_price',
                value: 'vip'
            });
        },
        delete_it: function delete_it() {
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            this.no_prepay_money();
            this.$store.commit('PRODUCTS_EDIT_ITEM', {
                gid: this.item.gid,
                oper: 'delete'
            });
        },
        triggeselect: function triggeselect() {
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };

            this.$store.commit('PRODUCTS_EDIT_ITEM', {
                gid: this.item.gid,
                oper: 'selected'
            });
        },
        inc_number: function inc_number(val) {
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            this.no_prepay_money();
            this.$store.commit('PRODUCTS_EDIT_ITEM', {
                gid: this.item.gid,
                oper: 'inc_num',
                value: val
            });
        },
        inc_save: function inc_save(val) {
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            this.$store.commit('PRODUCTS_EDIT_ITEM', {
                gid: this.item.gid,
                oper: 'inc_save',
                value: val
            });
        },
        set_number: function set_number(val) {
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            if (val != undefined) {
                this.no_prepay_money();
                this.$store.commit('PRODUCTS_EDIT_ITEM', {
                    gid: this.item.gid,
                    oper: 'set_num',
                    value: val
                });
            }
        },
        set_discount: function set_discount(val) {
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            if (val != undefined) {
                this.no_prepay_money();
                this.$store.commit('PRODUCTS_EDIT_ITEM', {
                    gid: this.item.gid,
                    oper: 'set_discount',
                    value: val
                });
            }
            console.log("SET DISCOUNT:", val);
        },
        set_real_price: function set_real_price(val) {
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            if (val != undefined) {
                this.no_prepay_money();
                this.$store.commit('PRODUCTS_EDIT_ITEM', {
                    gid: this.item.gid,
                    oper: 'set_real_price',
                    value: val
                });
            }
        },
        set_to_ems: function set_to_ems() {
            if (this.isfinished) {
                this.msgpad_show("msgpad", "ERROR", '本单已经结算', 'error');return;
            };
            this.$store.commit('PRODUCTS_EDIT_ITEM', {
                gid: this.item.gid,
                oper: 'set_ems'
            });
        }
    }
};

/***/ }),

/***/ "tMWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base_api = __webpack_require__("+TLI");

var _select_options = __webpack_require__("KykW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    //template:``,
    name: '',
    props: {
        width: {
            type: String,
            default: '500px'
        }
    },
    computed: {
        show_dialog: {
            get: function get() {
                return this.$store.state.dialog.show_vip_recharge_dialog;
            },
            set: function set(val) {
                this.$store.commit('SHOW_DIALOG_VIP_RECHARGE', val);
            }
        },
        vip_info: function vip_info() {
            return this.$store.state.vip.vip;
        }
    },
    methods: {
        get_recharge_type: function get_recharge_type() {
            var _this = this;

            console.log("NEED GET SYSUSER LIST");
            return (0, _select_options.selectoption)({ oper: 'recharge_type', key: "_id", value: "money,ext,note,start_tm,end_tm", type: 'obj', skipp: 'shop_id' }).then(function (resp) {
                _this.recharge_types = resp.data;
                _this.recharge_types.map(function (it) {
                    it.text = "\u5145" + it.money + " \u9001" + it.ext;
                });
            }).catch(function (err) {
                console.log(err);
                debugger;
            });
        },

        // input_change(val){
        //     let input = parseFloat(val);
        //     if(isNaN(input)) return this.money = 0;
        //     this.money = input
        // },
        // value_update(val){
        //     this.money = parseFloat(val);
        //     console.log(val);
        // },
        empty_value: function empty_value() {
            this.mobile = this.vip_info.mobile;
            this.name = this.vip_info.name;
            this.money = 0;
            this.ext = 0;
            this.note = "";
            this.selected_type = null;
        },
        create_record: function create_record() {
            console.log("click");
            var self = this;
            var re_money = parseFloat(self.money);
            var re_ext = parseFloat(self.ext);

            if (isNaN(re_money) || isNaN(re_ext) || re_money + re_ext == 0) {
                return self.$notify({
                    group: 'msgpad',
                    type: 'error',
                    title: '操作失败！',
                    text: "金额填写错误"
                });
            }
            self.money = re_money;
            self.ext = re_ext;
            var conf = {
                money: re_money,
                ext: re_ext,
                mobile: this.vip_info.mobile,
                name: this.vip_info.name,
                type: 'recharge',
                note: self.note,
                callback: function callback() {
                    debugger;
                    console.log("OK");
                }
            };
            self.$emit('recharge', conf);
            self.doing = true;
            // self.$store.commit('SHOW_DIALOG_USER_PAY','pay_order')
            return;
        }
    },
    components: {},
    watch: {
        show_dialog: function show_dialog(val, old) {
            console.log("show_dialog :", val, old);
            if (val) {
                if (this.recharge_types.length == 0) {
                    this.get_recharge_type();
                }
                this.empty_value();
                // debugger
            } else {
                this.doing = false;
            }
        },
        selected_type: function selected_type(val, old) {
            if (val) {
                var item = this.recharge_types.find(function (it) {
                    return it._id == val;
                });
                if (item) {
                    console.log("Found id:", item);
                    this.money = item.money;
                    this.ext = item.ext;
                    if (!this.note) this.note = item.note;
                    return;
                }
            }
            // this.money = item.money;
            // this.ext = item.ext;
        }
    },
    directives: {},
    mounted: function mounted() {},
    data: function data() {
        return {
            mobile: "",
            name: "",
            selected_type: null,
            money: 0,
            ext: 0,
            note: "",
            doing: false,
            menu: false,
            recharge_types: []
        };
    }
};

/***/ }),

/***/ "tVbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatSidebar_vue__ = __webpack_require__("9Z//");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatSidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatSidebar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatSidebar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatSidebar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbe077c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatSidebar_vue__ = __webpack_require__("dEWK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChatSidebar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbe077c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChatSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tl62":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u7OC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations; /* eslint-disable no-new */


var _mutationDefine = __webpack_require__("a2hP");

var types = _interopRequireWildcard(_mutationDefine);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _msgpad_show = __webpack_require__("2QB/");

var _msgpad_show2 = _interopRequireDefault(_msgpad_show);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  items: []
  /*{
        list: [],
        make_to_int  :0,
        multil_index :0,
        amount_less  :0,
        note : '',
        vip:{}
      }*/


  // getters
};var getters = {
  get_saved_order: function get_saved_order(state, getters) {
    return function (index) {
      if (index) return state.items[index];else return state.items;
    };
  }

  // actions
};var actions = {};

// mutations
var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SAVE_ORDER_TO_BACKUP, function (state, order) {
  if (order) {
    state.items.unshift(order);
  }
}), (0, _defineProperty3.default)(_mutations, types.REMOVE_BACKUP_ORDER, function (state, index) {
  if (state.items[index]) {
    state.items.splice(index, 1);
  }
}), _mutations);

exports.default = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),

/***/ "uMRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oper_menu_vue__ = __webpack_require__("Zm6K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oper_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oper_menu_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oper_menu_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oper_menu_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fefeb030_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_oper_menu_vue__ = __webpack_require__("VGcv");
function injectStyle (ssrContext) {
  __webpack_require__("joD2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fefeb030"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oper_menu_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fefeb030_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_oper_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ulTV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _mutationDefine = __webpack_require__("a2hP");

var types = _interopRequireWildcard(_mutationDefine);

var _select_options = __webpack_require__("KykW");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-new */
var options_array = ['products_filter', 'sysuser'];

var default_value = {};

var state = function () {
    var out_state = {};

    options_array.map(function (op) {
        out_state['select_' + op + '_options'] = default_value[op] ? default_value[op] : [];
    });
    return out_state;
}();

// getters
var getters = function () {
    var out_obj = {};
    options_array.map(function (op) {
        out_obj['select_' + op + '_options'] = function (state) {
            return state['select_' + op + '_options'];
        };
    });

    return out_obj;
}();

var actions = {
    select_option_update: function select_option_update(context, _ref) {
        var oper = _ref.oper,
            _ref$query = _ref.query,
            query = _ref$query === undefined ? {} : _ref$query,
            callback = _ref.callback;


        // let query = {oper:'shop',key:"_id",value:"cn_name",type:'obj',skipp:'shop_id'}
        query.oper = oper;

        var op_type = 'select_' + oper + '_options';
        // debugger
        if (state[op_type].length) return _promise2.default.resolve(state[op_type]);
        if (!state[op_type]) return _promise2.default.reject("not configed selectoption");
        return (0, _select_options.selectoption)(query).then(function (resp) {
            state[op_type] = resp.data;
            context.commit('SELECT_OPTION_' + oper.toUpperCase(), resp.data);
            return resp.data;
        }).catch(function (err) {
            console.log(err);
            debugger;
        });
    }
};

var mutations = function () {
    var out_obj = {};

    options_array.map(function (op) {
        var name = 'SELECT_OPTION_' + op.toUpperCase();
        out_obj[name] = function (state, val) {
            state['select_' + op + '_options'] = val;
            console.log('MUTATIONS => ' + name + ':' + val);
        };
    });
    return out_obj;
}();

// mutations

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ "wPxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_item_list_vue__ = __webpack_require__("o9je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_item_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_item_list_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_item_list_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_item_list_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0328782a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_item_list_vue__ = __webpack_require__("zTvF");
function injectStyle (ssrContext) {
  __webpack_require__("7r/j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0328782a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_item_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0328782a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_item_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "x6jz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventBus = undefined;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventBus = exports.EventBus = new _vue2.default();

exports.default = EventBus;

/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _eventBus = __webpack_require__("x6jz");

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false, // page loading
      darkMode: false, // dark mode
      customizer: false, // customizer
      boxLayout: false, // box layout mode
      collapseSidebar: false, // collapse sidebar
      defaultSidebar: '',
      rtlLayout: false
    };
  },
  mounted: function mounted() {
    var self = this;
    setTimeout(function () {
      self.$notify({
        group: 'msgpad',
        type: 'success',
        title: 'Important message',
        text: 'Hello user! This is a notification!'
      });
    }, 0);
  },

  computed: {
    // computed property to get the state of dark mode
    darkModeHandler: function darkModeHandler() {
      var _this = this;

      _eventBus2.default.$on('darkMode', function (payload) {
        _this.darkMode = payload;
      });
      return this.darkMode;
    },

    // computed property to get the state of boxlayout event
    boxLayoutHandler: function boxLayoutHandler() {
      var _this2 = this;

      _eventBus2.default.$on('boxLayout', function (payload) {
        _this2.boxLayout = payload;
      });
      return this.boxLayout;
    },
    collapseSidebarHandler: function collapseSidebarHandler() {
      var _this3 = this;

      _eventBus2.default.$on('collapseSidebar', function (payload) {
        _this3.collapseSidebar = payload;
      });
      return this.collapseSidebar;
    },

    // pageLoading () {
    //   var self = this
    //   setTimeout(function () {
    //     self.loading = false
    //   }, 1500)
    //   return self.loading
    // },
    // computed property to get the state of customizer
    customizerIn: function customizerIn() {
      var _this4 = this;

      _eventBus2.default.$on('toggleCustomizer', function (payload) {
        _this4.customizer = payload;
      });
      return this.customizer;
    },

    // To set the default sidebar
    activeDefaultSidebar: function activeDefaultSidebar() {
      var _this5 = this;

      _eventBus2.default.$on('enableDefaultSidebar', function (payload) {
        _this5.defaultSidebar = payload;
      });
      return this.defaultSidebar;
    },
    rtlLayoutHandler: function rtlLayoutHandler() {
      var _this6 = this;

      _eventBus2.default.$on('rtlLayoutEvent', function (payload) {
        _this6.rtlLayout = payload;
      });
      return this.rtlLayout;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "xOe6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yE19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_vip_edit_vue__ = __webpack_require__("ILPL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_vip_edit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_vip_edit_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_vip_edit_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_vip_edit_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccf125f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_vip_edit_vue__ = __webpack_require__("n2UJ");
function injectStyle (ssrContext) {
  __webpack_require__("2Lsv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ccf125f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dialog_vip_edit_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccf125f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dialog_vip_edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "yVEx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.show_dialog),callback:function ($$v) {_vm.show_dialog=$$v},expression:"show_dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline info lighten-2",attrs:{"primary-title":""}},[_c('span',{staticClass:"headline"},[_vm._v("会员充值")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-form',{ref:"form"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"会员号","disabled":""},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"姓名","hide-details":"","disabled":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{staticClass:"import_input",attrs:{"items":_vm.recharge_types,"item-value":"_id","item-text":"text","no-data-text":"充值类型","clearable":""},model:{value:(_vm.selected_type),callback:function ($$v) {_vm.selected_type=$$v},expression:"selected_type"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"备注","clearable":""},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.show_dialog = false}}},[_vm._v("取消")]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.doing,"disabled":_vm.doing,"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.create_record($event)}}},[_vm._v("充值")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zTvF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-card mb-0"},[_c('div',{staticClass:"app-card-content"},[_c('v-list',{staticClass:"card-list",attrs:{"three-line":""}},[_c('v-list-tile',{attrs:{"px-0":""}},[_c('v-badge',{attrs:{"color":"green","overlap":""}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("5")]),_vm._v(" "),_c('img',{attrs:{"height":"60","width":"60","src":"/static/img/icon2.png"}})]),_vm._v(" "),_c('v-list-tile-content',{class:'ml-2'},[_c('v-list-tile-sub-title',[_c('div',[_c('h5',{staticClass:"fw-bold text-gray"},[_vm._v("英国牛栏爱他美3段")])]),_vm._v(" "),_c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"ti-download mr-1"}),_vm._v(" 225 Sale")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"mr-2"},[_c('i',{staticClass:"ti-eye mr-1"}),_vm._v(" 280 Views\n                    ")])])],1),_vm._v(" "),_c('v-list-tile-action',[_c('h3',{staticClass:"mb-0 fw-bold"},[_vm._v("$ 59")]),_vm._v(" "),_c('h4',{staticClass:"mb-0 fw-bold"},[_vm._v("x2")]),_vm._v(" "),_c('h2',{staticClass:"mb-0 fw-bold red--text"},[_vm._v("$108")])]),_vm._v(" "),_c('v-list-tile-action',[_c('v-menu',{attrs:{"origin":"center center","transition":"scale-transition","bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("settings")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Settings")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("more")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("View More")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();}}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("notifications_off")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Disable notifications")])],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zbAu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lock-screen-wrapper"},[_c('v-container',{attrs:{"pt-70":"","px-0":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":"","mx-auto":""}},[_c('div',{staticClass:"mb-150"},[_c('router-link',{staticClass:"d-block text-xs-center",attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/static/img/session-logo.png"}})]),_c('p')],1),_vm._v(" "),_c('div',{staticClass:"lock-screen-block text-xs-center"},[_c('div',{staticClass:"s-user mb-4"},[_c('img',{staticClass:"rounded-circle img-responsive",attrs:{"src":"/static/img/user-9.jpg","width":"143","height":"143"}})]),_vm._v(" "),_c('h2',{staticClass:"white--text"},[_vm._v("Jerry Cummings")]),_vm._v(" "),_c('v-form',{staticClass:"mb-4",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"Password","rules":_vm.passwordRules,"type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zbya":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zkQm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zlJ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zmSt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_item_table_vue__ = __webpack_require__("0DU1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_item_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_item_table_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_item_table_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_item_table_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f7b6751_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_item_table_vue__ = __webpack_require__("986N");
function injectStyle (ssrContext) {
  __webpack_require__("gq1p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f7b6751"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_item_table_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f7b6751_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_item_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.7718f9595454cf14483f.js